import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { AppService } from '../../../../../../app/app.service';
import { LoadingService } from '../../../../../../app/shared/services/loading.service';
import { TranslateService } from '../../../../../../app/translate';

import { ComponentDetails, EquipmentDetails, SystemDetails } from '../../../../manage-equipment/models/manage-equipment.model';
import { ManageEquipmentService } from '../../../../manage-equipment/manage-equipment.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ActionService } from '../../../../action/action.service.service';
import { ActionType, Compart, ComponentSetup, Family, Make, Model, SystemSetup } from '../../../../../../app/entities';
import { AvailableSystemToBeAReplacementViewModel, GeneralActionViewModel, InspectionAction } from '../../../../action/action-models';
import { SetupUndercarriageService } from '../../../../setup-undercarriage/setup-undercarriage.service';
import { PreferencesService } from '../../../../preferences/preferences.service';
import { InventoryService } from '../../../../inventory/inventory-service.service';
import { SystemComponentViewModel } from '../../../../inventory/inventory-models';
import { MatDialog } from '@angular/material/dialog';
import { ActionCommentComponent } from '../../../../../../app/modules/equipment-record-action/component/action-comment/action-comment.component';
import { ConfirmActionBackInComponent } from '../../../../../../app/modules/equipment-record-action/component/confirm-action-back-in/confirm-action-back-in.component';
import { ActionRecommentDationOnDate, ActionRecommentDationOnDateVM, AddRecommendationModel, AddRecommendationVM, SeverityTypeModel } from '../../../models/interpretation.model';
import { InterpretationService } from '../../../interpretation.service';
import moment from 'moment';
import { ConfirmationBoxComponent } from '../../../../../../app/shared/confirmation-box/confirmation-box.component';
@Component({
  selector: 'app-ucp-action-recommendation',
  templateUrl: './ucp-action-recommendation.component.html',
  styleUrls: ['./ucp-action-recommendation.component.scss']
})
export class UcpActionRecommendationComponent implements OnInit {
  private _userLanguage = 'english';
  equipmentId: number;
  equipmentSystems: SystemDetails[] = [];
  equipmentSystems_: SystemDetails;

  equipmentSystemsCopy: SystemDetails[] = [];
  BothequipmentSystemsCopy: SystemDetails;
  selectedSide: number;
  systemsLoaded: boolean;
  selectedAction: number = 1;
  Makes: Make[];
  NewSMU: number;
  oldSystemId: number;
  newSystemId: number


  oldSystemIdFrame: number;
  newSystemIdFrame: number
  public today = new Date();
  availableSystemReplacementsL: AvailableSystemToBeAReplacementViewModel[];
  availableSystemReplacementsLFrame: AvailableSystemToBeAReplacementViewModel[];

  availableSystemReplacementsR: AvailableSystemToBeAReplacementViewModel[];
  availableSystemReplacementsRFrame: AvailableSystemToBeAReplacementViewModel[];

  allRollers: ComponentDetails[];
  AllComponentsintheSelectedSide: ComponentDetails[];
  equipmentDetails: EquipmentDetails;
  fam: Family;
  model: Model;
  make: Make;
  compartList: Compart[];

  chainSystem: SystemSetup[] = [];
  chainSystemR: SystemSetup[] = [];
  chainSystemNEW: SystemSetup[] = [];


  frameSystem: SystemSetup[] = [];
  frameSystemR: SystemSetup[] = [];
  frameSystemNEW: SystemSetup[] = [];
  ActionComment: string = "";
  workOrderNo: string;
  ActiveWorkOrder: boolean = false;
  IsReplaceAll: boolean = false;

  oldSystemIdL: number;
  oldSystemIdR: number;

  newSystemIdL: number = 0;
  newSystemIdR: number = 0;
  newSystemIdLInfo: AvailableSystemToBeAReplacementViewModel
  newSystemIdRInfo: AvailableSystemToBeAReplacementViewModel
  newSystemIdLFrameInfo: AvailableSystemToBeAReplacementViewModel
  newSystemIdRFrameInfo: AvailableSystemToBeAReplacementViewModel
  oldSystemIdLFrame: number = 0;
  oldSystemIdRFrame: number = 0;

  newSystemIdLFrame: number = 0;
  newSystemIdRFrame: number = 0;
  ShowDone: boolean = false;
  IsLoading: boolean = false;
  SelectedBrand: number;

  NewPropel: number;
  distanceForward: number = 0;
  distanceReverse: number = 0;
  enableDistTravelledTracking: boolean;
  SeverityDropDownList: SeverityTypeModel[] = [];
  userUOD: string = 'km';
  EquipmentIdEdit: number;
  SmuEdit: number;
  DateEdit: string;
  Comment: string;
  systemIds: number[] = [];
  ISEdit: boolean = false;
  IsRSH: boolean = false;
  hasCRoller: boolean = false;
  constructor(
    private _translate: TranslateService,
    private _appService: AppService,
    private _loading: LoadingService,
    private _router: Router,
    private _manageEquipService: ManageEquipmentService,
    private _notification: NotificationsService,
    private _actionService: ActionService,
    private inventoryService: InventoryService,
    private _route: ActivatedRoute, private _sanitizer: DomSanitizer,
    private _setupService: SetupUndercarriageService,
    private _dialog: MatDialog,
    private readonly _pref: PreferencesService,
    private _interp: InterpretationService, private _notify: NotificationsService, public dialog: MatDialog,
  ) { }

  ngOnInit() {
    this._appService.setPageTitle('Add Action Recommendation');
    this.EquipmentIdEdit = +this._route.snapshot.paramMap.get('id');
    this.SmuEdit = +this._route.snapshot.paramMap.get('smu');
    this.DateEdit = this._route.snapshot.queryParams['actiondate']?.toString();
    this.equipmentId = this._route.snapshot.params.id;
    if (this.equipmentId > 0) {
      this.loadEquipmentDetails();
      //this.loadEquipmentSystems();
    }
    this.LoadMakes();
    this.getSeverityDropdown();
    this.getUserUOD();
  }

  loadEquipmentDetails() {
    this._manageEquipService.getEquipmentDetails(this.equipmentId).subscribe(res => {
      this.equipmentDetails = res;
      //console.log("result", this.equipmentDetails)
      this.enableDistTravelledTracking = this.equipmentDetails.EnableDistTravelledTracking;
      this.distanceForward = this.convertDistanceKmToMi(this.equipmentDetails.DistanceForward);
      this.distanceReverse = this.convertDistanceKmToMi(this.equipmentDetails.DistanceReverse);

      this.NewSMU = this.equipmentDetails.LastInspectionSMU;
      if (this.equipmentDetails.FamilyId == 203) {
        this.IsRSH = true;
      } else {
        this.IsRSH = false;
      }
      this.loadSystemIds();
    })
  }
    
  loadSystemIds() {
    this._loading.startLoading();
    const today = new Date();
    this._manageEquipService.getSystemIds(this.equipmentId).subscribe(systems => {
      this.systemIds = systems;
      console.log('this.systemIds', this.systemIds);
      this.systemIds.forEach(x => {
        this._manageEquipService.getEquipmentBySystems(x, moment(today).format('MM/DD/YYYY').toString(), false).subscribe(system => {
        this.equipmentSystems_ = system;
        this.equipmentSystems.push(this.equipmentSystems_);
        //console.log("systemsx,m cv,x",this.equipmentSystems.push(this.equipmentSystems_));
        console.log("systems", system);
        if (this.EquipmentIdEdit > 0 && this.SmuEdit != 0 && this.DateEdit != undefined) {
          this.ISEdit = true;
          this.GetActionRecommentdationBySmuDate();
        }
        this.equipmentSystems_.RemoveStatusId = 1;
        this.equipmentSystems_.Components.forEach(y => (
          y.PartCost = 0,
          y.LaborCost = 0,
          y.MiscCost = 0
        ));
        this.equipmentSystemsCopy = this.equipmentSystems;
        console.log('this.equipmentSystemsCopy', this.equipmentSystemsCopy)
        const hasComponentType234 = this.equipmentSystems_.Components.some(component => component.CompartTypeId === 234);
        if (hasComponentType234) {
          this.hasCRoller = true;
          if (this.equipmentDetails.ShowHideCRoller == false) {
            this.equipmentSystems_.Components = this.equipmentSystems_.Components.filter(x => x.CompartTypeId != 234)
          }
        } else {
          this.hasCRoller = false;
        }
        if (this.equipmentSystems != null && this.selectedSide > 0) {
        this.ChangeSide();
        this._loading.finishedLoading();
      }
      this._loading.finishedLoading();
      this.systemsLoaded = true;
        });
      })
      this._actionService.getExtraMakeOfThisEquipment(this.equipmentId).subscribe(m => {
        this.Makes.unshift(m);
      });
      console.log("systemsafterloop",this.equipmentSystems);
      console.log("systemsafterloop",this.equipmentSystems);
    }); 
  }

  // loadEquipmentSystems() {
  //   this._loading.startLoading();
  //   const today = new Date();
  //   this._manageEquipService.getEquipmentSystems(this.equipmentId, moment(today).format('MM/DD/YYYY')).subscribe(systems => {
  //     this.equipmentSystems = systems;
  //     if (this.EquipmentIdEdit > 0 && this.SmuEdit != 0 && this.DateEdit != undefined) {
  //       this.ISEdit = true;
  //       this.GetActionRecommentdationBySmuDate();
  //     }

  //     this.equipmentSystems.forEach(x => (
  //       x.RemoveStatusId = 1,
  //       x.Components.forEach(y => (
  //         y.PartCost = 0,
  //         y.LaborCost = 0,
  //         y.MiscCost = 0
  //       ))
  //     ));

  //     this.equipmentSystemsCopy = systems;
  //     const hasComponentType234 = this.equipmentSystems.some(system => system.Components.some(component => component.CompartTypeId === 234));
  //     if (hasComponentType234) {
  //       if (!this.equipmentDetails.ShowHideCRoller) {
  //         this.equipmentSystems = this.equipmentSystems.map(system => {
  //           const filteredComponents = system.Components.filter(component => component.CompartTypeId !== 234);
  //           return { ...system, Components: filteredComponents };
  //         });
  //       }
  //     }
  //     if (this.equipmentSystems != null && this.selectedSide > 0) {
  //       this.ChangeSide();
  //       this._loading.finishedLoading();
  //     }
  //     this._actionService.getExtraMakeOfThisEquipment(this.equipmentId).subscribe(m => {
  //       this.Makes.unshift(m);
  //     });
  //     this._loading.finishedLoading();
  //     this.systemsLoaded = true;
  //   });
  // }

  LoadMakes() {
    this._actionService.GetComponentReplacementBrends().subscribe(result => {
      this.Makes = result;
      this._loading.finishedLoading();
    },
      error => { console.error(error); });
  }

  ChangeSide() {
    this.AllComponentsintheSelectedSide = null;
    //console.log("ChangeSide - this.equipmentSystemsCopy: ", this.equipmentSystemsCopy);
    this.equipmentSystems = this.equipmentSystemsCopy;
    if (this.selectedSide == 1) {
      this.equipmentSystems = this.equipmentSystems.filter(x => x.Side == "Left");
      let chainsystems = this.equipmentSystems[0].Components;
      let framesystems = this.equipmentSystems[1].Components;



      this.AllComponentsintheSelectedSide = chainsystems.concat(framesystems);
      this.oldSystemId = this.equipmentSystems.find(x => x.Side == "Left" && x.SystemType == "Chain").Id;
      this.oldSystemIdL = this.equipmentSystems.find(x => x.Side == "Left" && x.SystemType == "Chain").Id;

      this.oldSystemIdFrame = this.equipmentSystems.find(x => x.Side == "Left" && x.SystemType == "Frame").Id;
      this.oldSystemIdLFrame = this.equipmentSystems.find(x => x.Side == "Left" && x.SystemType == "Frame").Id;



    } else if (this.selectedSide == 2) {
      this.equipmentSystems = this.equipmentSystems.filter(x => x.Side == "Right");

      let chainsystems = this.equipmentSystems[0].Components;
      let framesystems = this.equipmentSystems[1].Components;
      this.AllComponentsintheSelectedSide = chainsystems.concat(framesystems);

      this.oldSystemId = this.equipmentSystems.find(x => x.Side == "Right" && x.SystemType == "Chain").Id;
      this.oldSystemIdR = this.equipmentSystems.find(x => x.Side == "Right" && x.SystemType == "Chain").Id;
      this.oldSystemIdFrame = this.equipmentSystems.find(x => x.Side == "Right" && x.SystemType == "Frame").Id;
      this.oldSystemIdRFrame = this.equipmentSystems.find(x => x.Side == "Right" && x.SystemType == "Frame").Id;

    } else if (this.selectedSide == 3) {//both side selected
      //console.log("ChangeSide - both side selected - this.equipmentSystemsCopy: ", this.equipmentSystemsCopy);
      //console.log("ChangeSide - both side selected - this.equipmentSystems: ", this.equipmentSystems);

      let chainsystemsl = this.equipmentSystems[0].Components;
      let framesystemsl = this.equipmentSystems[1].Components;
      let chainsystemsr = this.equipmentSystems[2].Components;
      let framesystemsr = this.equipmentSystems[3].Components;
      //console.log("ChangeSide: ", framesystemsl);

      this.AllComponentsintheSelectedSide = chainsystemsl.concat(framesystemsl).concat(chainsystemsr).concat(framesystemsr);
      //console.log("ChangeSide AllComponentsintheSelectedSide: ", this.AllComponentsintheSelectedSide);
      this.oldSystemIdL = this.equipmentSystems.find(x => x.Side == "Left" && x.SystemType == "Chain").Id;
      this.oldSystemIdR = this.equipmentSystems.find(x => x.Side == "Right" && x.SystemType == "Chain").Id;

      this.oldSystemIdLFrame = this.equipmentSystems.find(x => x.Side == "Left" && x.SystemType == "Frame").Id;
      this.oldSystemIdRFrame = this.equipmentSystems.find(x => x.Side == "Right" && x.SystemType == "Frame").Id;

    }


    if (this.IsReplaceAll == true) {
      this.equipmentSystems.map(x => {
        x.ActionSelectionId = 2;
        x.SysReplaceActionId = 1;
      })
      this.AllComponentsintheSelectedSide.map(x => {
        x.ActionSelectionId = 2;
        if (x.CompartTypeId == 230) {
          x.ChainSysReplaceAction = 1;

          if (x.ChainSysReplaceAction == 1) {
            this.equipmentSystems.map(x1 => {
              if (x1.SystemType == "Chain") {
                x1.Components.map(y => {
                  y.ActionSelectionId = 2;
                  this._actionService.getReplacementComponentOptions(y.Id).subscribe(c => {
                    y.ActionsReplaceOption = c;
                    let getActionOption = y.ActionsReplaceOption;
                    y.ActionComponentId = getActionOption.find(i => i.Id == y.CompartId).Id;
                    y.ActionBudgetLife = getActionOption.find(i => i.Id == y.CompartId).BudgetLife;
                    y.ActionBudgetDistance = getActionOption.find(i => i.Id == y.CompartId).BudgetDistance;
                  });

                  this._actionService.GetAvailaleActionsForComponent(y.CompartId, this.equipmentId).subscribe(res => {
                    y.AvailableActions = res;
                    let cpy = Object.assign([], y.AvailableActions)
                    y.AvailableActions = cpy.filter(x2 => x2.ActionTypeName.toLowerCase().includes('Replace'.toLowerCase()))
                    //console.log("CHAIN", y.AvailableActions)

                    y.SelectedActionTypeId = y.AvailableActions[0].ActionTypeId;
                  });
                  y.ActionWorn = 0;
                  y.ActionCMU = 0;
                  y.ActionDOC = 0;
                  y.ActionCost = null;
                  let makelist = this.Makes;
                  if (this.SelectedBrand > 0) {
                    y.ActionBrandId = this.SelectedBrand;
                  } else {
                    y.ActionBrandId = makelist.find(x => x.Title.toLowerCase() == y.Brand.toLowerCase()).Id;

                  }
                })
              }
            })
          }
          console.log("details", this.equipmentDetails)
          let f = new Family();
          f.Id = this.equipmentDetails.FamilyId;
          f.Title = this.equipmentDetails.Family;

          let mod = new Model();
          mod.Id = this.equipmentDetails.ModelId;
          mod.Title = this.equipmentDetails.Model;
          this.fam = f;
          this.model = mod;
          this._setupService.GetAvailableCompartsAll(this.equipmentDetails.ModelId).subscribe(result => {
            this.compartList = result;
            //console.log("result__compartList", this.compartList)
          });
        }
        this._actionService.GetAvailaleActionsForComponent(x.CompartId, this.equipmentId).subscribe(res => {
          x.AvailableActions = res;
          //this.getAvailableComponentReplacement(x.Id, x);

          this._actionService.getReplacementComponentOptions(x.Id).subscribe(c => {
            //console.log("resukt1111111111111:", c)
            x.ActionsReplaceOption = c;

            let cpy = Object.assign([], x.AvailableActions)
            x.showCalcuator = false;
            x.showShoeDetails = false;
            x.AvailableActions = cpy.filter(x => x.ActionTypeName.toLowerCase().includes('New'.toLowerCase()))
            x.SelectedActionTypeId = x.AvailableActions[0].ActionTypeId;
            //  this.ChangeAvailableAction(x);

            x.ActionWorn = null;
            x.ActionCMU = null;
            x.ActionDOC = null;
            x.ActionCost = null;
            x.ActionBudgetLife = null;
            x.ActionBudgetDistance = null;
            let action = x.AvailableActions.find(y => y.ActionTypeId == x.SelectedActionTypeId);

            let getActionOption = x.ActionsReplaceOption;
            x.ActionComponentId = getActionOption.find(z => z.Id == x.CompartId).Id;
            x.ActionBudgetLife = getActionOption.find(z => z.Id == x.CompartId).BudgetLife;
            x.ActionBudgetDistance = getActionOption.find(z => z.Id == x.CompartId).BudgetDistance;
            x.showCalcuator = true;
            if (action.ActionTypeName.toLowerCase().includes('New'.toLowerCase())) {
              x.ActionWorn = 0;
              x.ActionCMU = 0;
              x.ActionDOC = 0;
              x.ActionCost = null;
              x.showCalcuator = false;
              x.ActionToolId = x.ToolId;

              if (x.CompartTypeId == 232) x.showShoeDetails = true;
              else x.showShoeDetails = false;

            } else {
              x.ActionWorn = null;
              x.ActionCMU = null;
              x.ActionDOC = null;
              x.ActionCost = null;
              if (x.CompartTypeId == 232) {
                x.showShoeDetails = true;
              } else x.showShoeDetails = false;
            }
            let makelist = this.Makes;
            if (this.SelectedBrand > 0) {
              x.ActionBrandId = this.SelectedBrand;
            } else {
              x.ActionBrandId = makelist.find(i => i.Title.toLowerCase() == x.Brand.toLowerCase()).Id;
            }

          });

        });



      })
    } else if (this.IsReplaceAll == false) {

      this.equipmentSystems.map(x => {
        x.ActionSelectionId = 1;
      })
      this.AllComponentsintheSelectedSide.map(x => {
        x.ActionSelectionId = 1;
        x.AvailableActions = [];
        x.ActionWorn = null;
        x.ActionCMU = null;
        x.ActionDOC = null;
        x.ActionCost = null;
        x.ActionComponentId = null;
        x.ActionBudgetLife = null;
        x.ActionBudgetDistance = null;
        x.SelectedActionTypeId = null;
      })
    }
    // this.equipmentSystems.map(x=>{
    //   x.Components.map(y=>{
    //     this.loadActionForCompart(y);
    //   })
    // })
  }

  ChangeReplaceFullUC() {
    if (this.IsReplaceAll == false) {
      this.AllComponentsintheSelectedSide.map(x => {
        x.ActionSelectionId = 1;
        x.AvailableActions = [];
        x.ActionWorn = null;
        x.ActionCMU = null;
        x.ActionDOC = null;
        x.ActionCost = null;
        x.ActionComponentId = null;
        x.ActionBudgetLife = null;
        x.ActionBudgetDistance = null;
        x.SelectedActionTypeId = null;
      })

    }

    if (this.IsReplaceAll == true) {

      this.equipmentSystems.map(x => {
        x.ActionSelectionId = 2;
        x.SysReplaceActionId = 1;
      })
      this.AllComponentsintheSelectedSide.map(x => {
        x.ActionSelectionId = 2;
        if (x.CompartTypeId == 230) {
          x.ChainSysReplaceAction = 1;

          if (x.ChainSysReplaceAction == 1) {
            this.equipmentSystems.map(x1 => {
              if (x1.SystemType == "Chain") {
                x1.Components.map(y => {
                  y.ActionSelectionId = 2;
                  this._actionService.getReplacementComponentOptions(y.Id).subscribe(c => {
                    y.ActionsReplaceOption = c;
                    let getActionOption = y.ActionsReplaceOption;
                    y.ActionComponentId = getActionOption.find(i => i.Id == y.CompartId).Id;
                    y.ActionBudgetLife = getActionOption.find(z => z.Id == x.CompartId).BudgetLife;
                    y.ActionBudgetDistance = getActionOption.find(z => z.Id == x.CompartId).BudgetDistance;
                  });

                  this._actionService.GetAvailaleActionsForComponent(y.CompartId, this.equipmentId).subscribe(res => {
                    y.AvailableActions = res;
                    let cpy = Object.assign([], y.AvailableActions)
                    y.AvailableActions = cpy.filter(x2 => x2.ActionTypeName.toLowerCase().includes('Replace'.toLowerCase()))
                    console.log("CHAIN", y.AvailableActions)

                    y.SelectedActionTypeId = y.AvailableActions[0].ActionTypeId;
                  });


                  y.ActionWorn = 0;
                  y.ActionWorn = 0;
                  y.ActionCost = null;
                  let makelist = this.Makes;
                  y.ActionBrandId = makelist.find(x => x.Title.toLowerCase() == y.Brand.toLowerCase()).Id;


                  // y.ActionBudgetLife = y.BudgetLife;



                })
              }
            })
          }
          console.log("details", this.equipmentDetails)
          let f = new Family();
          f.Id = this.equipmentDetails.FamilyId;
          f.Title = this.equipmentDetails.Family;

          let mod = new Model();
          mod.Id = this.equipmentDetails.ModelId;
          mod.Title = this.equipmentDetails.Model;



          this.fam = f;
          this.model = mod;
          this._setupService.GetAvailableCompartsAll(this.equipmentDetails.ModelId).subscribe(result => {
            this.compartList = result;
            // console.log("result__compartList", this.compartList)
          });
        }
        this._actionService.GetAvailaleActionsForComponent(x.CompartId, this.equipmentId).subscribe(res => {
          x.AvailableActions = res;
          //this.getAvailableComponentReplacement(x.Id, x);

          this._actionService.getReplacementComponentOptions(x.Id).subscribe(c => {
            //console.log("resukt1111111111111:", c)
            x.ActionsReplaceOption = c;

            let cpy = Object.assign([], x.AvailableActions)
            x.showCalcuator = false;
            x.showShoeDetails = false;
            x.AvailableActions = cpy.filter(x => x.ActionTypeName.toLowerCase().includes('New'.toLowerCase()))
            x.SelectedActionTypeId = x.AvailableActions[0].ActionTypeId;
            x.ActionWorn = null;
            x.ActionCMU = null;
            x.ActionDOC = null;
            x.ActionCost = null;
            x.ActionBudgetLife = null;
            x.ActionBudgetDistance = null;
            let action = x.AvailableActions.find(y => y.ActionTypeId == x.SelectedActionTypeId);

            let getActionOption = x.ActionsReplaceOption;
            x.ActionComponentId = getActionOption.find(z => z.Id == x.CompartId).Id;
            x.ActionBudgetLife = getActionOption.find(z => z.Id == x.CompartId).BudgetLife;
            x.ActionBudgetDistance = getActionOption.find(z => z.Id == x.CompartId).BudgetDistance;
            x.showCalcuator = true;
            if (action.ActionTypeName.toLowerCase().includes('New'.toLowerCase())) {
              x.ActionWorn = 0;
              x.ActionCMU = 0;
              x.ActionDOC = 0;
              x.ActionCost = null;
              x.showCalcuator = false;
              x.ActionToolId = x.ToolId;

              if (x.CompartTypeId == 232) x.showShoeDetails = true;
              else x.showShoeDetails = false;

            } else {
              x.ActionWorn = null;
              x.ActionCMU = null;
              x.ActionDOC = null;
              x.ActionCost = null;

              if (x.CompartTypeId == 232) x.showShoeDetails = true;
              else x.showShoeDetails = false;
            }
            let makelist = this.Makes;
            x.ActionBrandId = makelist.find(i => i.Title.toLowerCase() == x.Brand.toLowerCase()).Id;
          });
        });
      })
    }
  }
  UpdateAllComponentBrand() {
    this.AllComponentsintheSelectedSide.map(x => {

      if (x.CompartTypeId == 230) {
        if (x.ChainSysReplaceAction == 1) {
          this.equipmentSystems.map(x1 => {
            if (x1.SystemType == "Chain") {
              x1.Components.map(y => {
                y.ActionBrandId = this.SelectedBrand;//makelist.find(x => x.Title.toLowerCase() == y.Brand.toLowerCase()).Id;
              })
            }
          })
        }

      }

      x.ActionBrandId = this.SelectedBrand;
    });
  }
  UpdateWOForComponents() {
    this.equipmentSystems.map(x => {
      x.Components.map(y => {
        y.ActionWO = this.workOrderNo;
      })
    })
  }
  selectedSystemReplacement(event: any, side: string, systemType: string, replacement: AvailableSystemToBeAReplacementViewModel) {

    console.log("side: + systemType: new SystemId: ", side + " : " + systemType + " : " + event.value.SystemId)
    console.log("Replacement ", event)
    replacement = event.value
    this.inventoryService.getSystemComponentsInfo(event.value.SystemId).subscribe((info: SystemComponentViewModel[]) => {
      // Iterate over the replacement.Components array

      console.log("Replacement ", replacement, info)
      if (replacement) {
        replacement.Components = info;
      }
      //SystemsComponentTypesCountNeedToMatch
      var _replaceCompCount = replacement.Components.filter(f => f.CompartType != 234).length;
      var _curSys = this.equipmentSystems.find(f => f.SystemType == systemType && f.Side == side);
      var _baseCompCount = _curSys.Components.filter(f => f.CompartTypeId != 234).length;
      console.log("_replaceCompCount : _baseCompCount", _replaceCompCount, _baseCompCount);
      if (_replaceCompCount != _baseCompCount) {
        this._notification.error('Selected frame is not compatible due to differences in the components.');
        return;
      }
      if (systemType == "Chain") {
        if (side == "Left") {
          this.newSystemIdL = event.value.SystemId;
          this.newSystemIdLInfo = replacement
        } else {
          this.newSystemIdR = event.value.SystemId;
          this.newSystemIdRInfo = replacement
        }
      } else {
        if (side == "Left") {
          this.newSystemIdLFrame = event.value.SystemId;
          this.newSystemIdLFrameInfo = replacement

        } else {
          this.newSystemIdRFrame = event.value.SystemId;
          this.newSystemIdRFrameInfo = replacement

        }
      }
      this.equipmentSystems.map(x => {
        if (x.SystemType == systemType && x.Side == side) {


          x.Components.forEach((replacementComponent: ComponentDetails) => {
            // Find the corresponding component in the 'info' array based on the identifier
            const matchingInfoComponent = info.find((infoComponent: SystemComponentViewModel) =>

              //infoComponent.CompartType === replacementComponent.CompartTypeId
              ((infoComponent.CompartType === replacementComponent.CompartTypeId) && (infoComponent.Pos === replacementComponent.Position))

            )
            if (matchingInfoComponent) {
              replacementComponent.ActionWorn = matchingInfoComponent.WornPercentage;
              replacementComponent.ActionBudgetLife = matchingInfoComponent.Budget;
              replacementComponent.ActionBudgetDistance = matchingInfoComponent.DistanceBudget;
              replacementComponent.ActionCMU = matchingInfoComponent.CMU;
              replacementComponent.ActionDOC = matchingInfoComponent.DOC;
              replacementComponent.ActionCost = matchingInfoComponent.TotalCost;

              replacementComponent.ActionSelectionId = 2;
              // Add other properties as needed
            }
            // If a matching component is found, update the properties in 'replacementComponent'



          });
        }
      })
      console.log("newSystemIdL: + newSystemIdR: + newSystemIdLFrame: + newSystemIdRFrame + ", this.newSystemIdL + " ; " + this.newSystemIdR + " : " + this.newSystemIdLFrame + " : " + this.newSystemIdRFrame);

    });





  }
  loadActionForCompart(component: ComponentDetails) {
    this._actionService.GetAvailaleActionsForComponent(component.CompartId, this.equipmentId).subscribe(res => {
      component.AvailableActions = res;
    })
  }
  ChangeActionSelection(component: ComponentDetails, event: any) {
    this._actionService.GetAvailaleActionsForComponent(component.CompartId, this.equipmentId).subscribe(res => {
      component.AvailableActions = res;

      if (component.ActionSelectionId == 2) {


        this.getAvailableComponentReplacement(component.Id, component);
        let cpy = Object.assign([], component.AvailableActions)
        component.showCalcuator = false;

        if (component.CompartTypeId == 232) component.showShoeDetails = true;
        else component.showShoeDetails = false;

        return component.AvailableActions = cpy.filter(x => x.ActionTypeName.toLowerCase().includes('Replace'.toLowerCase()))

      } else if (component.ActionSelectionId == 3) {

        this.getAvailableComponentReplacement(component.Id, component);
        let cpy = Object.assign([], component.AvailableActions)
        component.showCalcuator = true;
        component.showShoeDetails = false;


        return component.AvailableActions = cpy.filter(x => !x.ActionTypeName.toLowerCase().includes('Replace'.toLowerCase()))
      } else {
        component.ActionComponentId = null;
        component.ActionWorn = null;
        component.ActionBudgetLife = null;
        component.ActionBudgetDistance = null;
        component.ActionCMU = null;
        component.ActionDOC = null;
        component.ActionCost = null;
        component.ActionBrandId = null;
        component.showShoeDetails = false;
        component.SwapComponentId = null;
        //component.ActionSelectionId = component.ActionSelectionId; //Repair
        component.SelectedActionTypeId = null;
        return component.AvailableActions = [];
      }

    })

  }

  ChangeAvailableAction(component: ComponentDetails, system: SystemDetails) {
    component.ActionWorn = null;
    console.log("System, : ", system);
    console.log("component : ", component);
    component.ActionCMU = null;
    component.ActionDOC = null;
    component.ActionCost = null;
    component.ActionBudgetLife = null;
    component.ActionBudgetDistance = null;
    let action = component.AvailableActions.find(x => x.ActionTypeId == component.SelectedActionTypeId);
    if (component.ActionSelectionId == 2) {

      if (component.CompartTypeId == 230 || component.CompartTypeId == 231) {
        system.ActionSelectionId = 2;
        system.SysReplaceActionId = 1;
        this.ChangeReplacementOptionForSystem(system, system.Side)
      }
      let getActionOption = component.ActionsReplaceOption;
      component.ActionComponentId = getActionOption.find(x => x.Id == component.CompartId).Id;
      component.ActionBudgetLife = getActionOption.find(x => x.Id == component.CompartId).BudgetLife;
      component.ActionBudgetDistance = getActionOption.find(x => x.Id == component.CompartId).BudgetDistance;
      component.showCalcuator = true;
      if (action.ActionTypeName.toLowerCase().includes('New'.toLowerCase())) {
        component.ActionWorn = 0;
        component.ActionCMU = 0;
        component.ActionDOC = 0;
        component.ActionCost = null;
        component.showCalcuator = false;
        component.ActionToolId = component.ToolId;
        if (component.CompartTypeId == 232) component.showShoeDetails = true;
        else component.showShoeDetails = false;

      } else {
        component.ActionWorn = null;
        component.ActionCMU = null;
        component.ActionDOC = null;
        component.ActionCost = null;
        if (component.CompartTypeId == 232) component.showShoeDetails = true;
        else component.showShoeDetails = false;

      }
    }
    else if (component.ActionSelectionId == 3) {

      if (component.SelectedActionTypeId == 12 || component.SelectedActionTypeId == 10302) {
        component.ActionWorn = 0;
        component.ActionReading = 0;
        component.showCalcuator = false;
      } else {
        component.ActionWorn = component.PercentWorn == -9999 ? null : component.PercentWorn;
        component.ActionReading = component.PercentWorn == -9999 ? null : component.Reading;
        component.showCalcuator = true;
      }
      component.ActionCMU = component.Cmu;
      component.ActionDOC = component.DOC;
      if (this.enableDistTravelledTracking)
        if ((this.distanceForward + this.distanceReverse) > 0)
          component.ActionDOC = (this.distanceForward + this.distanceReverse) - this.equipmentDetails.DOE;
        else if (component.DOC <= 0)
          component.ActionDOC = this.equipmentDetails.DOE;

      component.ActionToolId = component.PercentWorn == -9999 ? null : component.ToolId;
      component.ActionBudgetLife = component.BudgetLife;
      component.ActionBudgetDistance = component.BudgetDistance;
      component.ActionCost = null;

      if (component.SelectedActionTypeId === 10602 || component.SelectedActionTypeId === 17 || component.SelectedActionTypeId === 10702) {
        //console.log("system.Side : ", system);
        console.log("AllComponentsintheSelectedSide before: ", this.AllComponentsintheSelectedSide);
        var _usedRollerPoss = [];
        //_usedRollerPoss.push(component.Id);
        system.Components.forEach(e => {
          if (e.SwapComponentId != undefined)
            _usedRollerPoss.push(e.SwapComponentId);
        });
        //console.log("_usedRollerPoss: ", _usedRollerPoss);
        if (this.selectedSide == 3)
          component.allRollers = this.AllComponentsintheSelectedSide.filter(c => c.CompartTypeId === component.CompartTypeId && c.Id != component.Id && !_usedRollerPoss.includes(c.Id));
        else
          component.allRollers = this.AllComponentsintheSelectedSide.filter(c => c.CompartTypeId === component.CompartTypeId && c.Id != component.Id && c.Side == component.Side && !_usedRollerPoss.includes(c.Id));

        //component.showCalcuator = false;
        component.showCalcuator = true;
        console.log("AllComponentsintheSelectedSide after: ", this.AllComponentsintheSelectedSide);
      }

    }

    let makelist = this.Makes;
    component.ActionBrandId = makelist.find(x => x.Title.toLowerCase() == component.Brand.toLowerCase()).Id;


  }


  swapRollerEvent(roller: ComponentDetails, component: ComponentDetails, system: SystemDetails) {
    console.log("roller:", roller);
    var _system = system;
    if (this.selectedSide == 3) {
      var _systemOther = [...this.equipmentSystems.filter(f => f.SystemType == 'Frame')];
      _systemOther.forEach(s => {
        s.Components.forEach(e => {
          if (e.SwapComponentId == component.Id && e.SwapComponentId != roller.Id) {
            e.ActionSelectionId = 1; //No Action
            e.SelectedActionTypeId = null;
            e.SwapComponentId = null;
            this.ChangeActionSelection(e, null);
            this.ChangeAvailableAction(e, system);
          }
        });
      });
      if (roller.Side != component.Side)
        _system = { ...this.equipmentSystems.filter(f => f.Side == roller.Side && f.SystemType == 'Frame')[0] };
      else {

      }
    }
    console.log("_system:", _system);
    _system.Components.forEach(e => {
      if (e.SwapComponentId == component.Id && e.SwapComponentId != roller.Id) {
        e.ActionSelectionId = 1; //No Action
        e.SelectedActionTypeId = null;
        e.SwapComponentId = null;
        this.ChangeActionSelection(e, null);
        this.ChangeAvailableAction(e, system);
      } //&& e.Side == component.Side
      if (e.CompartTypeId === component.CompartTypeId && e.Id != component.Id && e.Position == roller.Position && (e.ActionSelectionId != component.ActionSelectionId || (e.ActionSelectionId == component.ActionSelectionId && (e.SwapComponentId == undefined || e.SwapComponentId == 0)))) {
        console.log("e.id,component.ID:", e.Id, component.Id);
        e.ActionSelectionId = component.ActionSelectionId; //Repair
        this.ChangeActionSelection(e, null);
        e.SelectedActionTypeId = component.SelectedActionTypeId;
        //e.SwapComponentId = component.Id;
        this.ChangeAvailableAction(e, system);

        e.ActionWorn = component.PercentWorn == -9999 ? null : component.PercentWorn;
        e.ActionCMU = component.Cmu;
        e.ActionDOC = component.DOC;
        e.ActionBudgetLife = component.BudgetLife;
        e.ActionBudgetDistance = component.BudgetDistance;
        e.ActionCost = null;
        e.ActionSelectionId = component.ActionSelectionId; //Repair
        e.SelectedActionTypeId = component.SelectedActionTypeId;
        e.SwapComponentId = component.Id;
      }
    });
    console.log("this.equipmentSystems updated:", this.equipmentSystems);
    component.ActionWorn = roller.PercentWorn == -9999 ? null : roller.PercentWorn;
    component.ActionCMU = roller.Cmu;
    component.ActionDOC = roller.DOC;
    component.ActionBudgetLife = roller.BudgetLife;
    component.ActionBudgetDistance = roller.BudgetDistance;
    component.ActionCost = null;
    component.SwapComponentId = roller.Id;
  }

  ChangeAction(component: ComponentDetails) {

    if (component.SelectedActionTypeId > 1 && component.AvailableActions.length > 0) {
      let action = component.AvailableActions.find(x => x.ActionTypeId == component.SelectedActionTypeId);
      if (action && (component.ActionSelectionId == 2 && action.ActionTypeName.toLowerCase().includes('Used'.toLowerCase()))) {
        component.showCalcuator = true;

        if (component.CompartTypeId == 232) {
          component.showShoeDetails = true;
        } else {
          component.showShoeDetails = false;
        }
        return true;
      }
    } else {
      component.showCalcuator = false;
      if (component.CompartTypeId == 232) component.showShoeDetails = true;
      else component.showShoeDetails = false;

      return false;
    }
  }

  ChangeActionCost(component: ComponentDetails) {
    if (component.SelectedActionTypeId > 1 && component.AvailableActions.length > 0) {
      let action = component.AvailableActions.find(x => x.ActionTypeId == component.SelectedActionTypeId);
      if (action && (component.ActionSelectionId == 2 && action.ActionTypeName.toLowerCase().includes('Used'.toLowerCase()) || action.ActionTypeName.toLowerCase().includes('New'.toLowerCase()))) {
        return true;
      }
    } else {
      return false;
    }
  }

  OnChangeCost(component: ComponentDetails) {

    component.ActionCost = (+component.PartCost) + (+component.MiscCost) + (+component.LaborCost);

  }

  ChangeReplacementOption(component: ComponentDetails, side: string) {

    if (side == "Left") {
      this.oldSystemId = this.oldSystemIdL;
    } else {
      this.oldSystemId = this.oldSystemIdR;
    }
    this._actionService.getAvailbleSystemReplacement(this.equipmentId, this.equipmentSystems[0].JobsiteId, true, this.oldSystemId).subscribe(r => {
      if (side == "Left")
        this.availableSystemReplacementsL = r;
      else
        this.availableSystemReplacementsR = r;
      if (this.newSystemId !== 0 && this.newSystemId !== undefined) {
        //this.selectedSystemReplacement({value : { SystemId: this.newSystemId}});
      }
    });

    if (component.ChainSysReplaceAction == 1) {
      this.equipmentSystems.map(x => {
        if (x.SystemType == "Chain" && x.Side == side) {
          x.Components.map(y => {
            y.ActionSelectionId = 2;
            this._actionService.getReplacementComponentOptions(y.Id).subscribe(c => {
              y.ActionsReplaceOption = c;
              let getActionOption = y.ActionsReplaceOption;
              y.ActionComponentId = getActionOption.find(i => i.Id == y.CompartId).Id;
              y.ActionBudgetLife = getActionOption.find(i => i.Id == y.CompartId).BudgetLife;
              y.ActionBudgetDistance = getActionOption.find(i => i.Id == y.CompartId).BudgetDistance;

            });

            this._actionService.GetAvailaleActionsForComponent(y.CompartId, this.equipmentId).subscribe(res => {
              y.AvailableActions = res;
              let cpy = Object.assign([], y.AvailableActions)
              y.AvailableActions = cpy.filter(x => x.ActionTypeName.toLowerCase().includes('Replace'.toLowerCase()))
              y.SelectedActionTypeId = y.AvailableActions[0].ActionTypeId;
            });
            y.ActionWorn = 0;
            y.ActionWorn = 0;
            y.ActionCost = null;
            let makelist = this.Makes;
            y.ActionBrandId = makelist.find(x => x.Title.toLowerCase() == y.Brand.toLowerCase()).Id;
          })
        }
      })
    }
    let f = new Family();
    f.Id = this.equipmentDetails.FamilyId;
    f.Title = this.equipmentDetails.Family;

    let mod = new Model();
    mod.Id = this.equipmentDetails.ModelId;
    mod.Title = this.equipmentDetails.Model;

    this.fam = f;
    this.model = mod;
    this._setupService.GetAvailableCompartsAll(this.equipmentDetails.ModelId).subscribe(result => {
      this.compartList = result;
    });

  }

  ChangeReplacementOptionType(system: SystemDetails, side: string) {
    if (system.ActionSelectionId == 1) {
      system.SysReplaceActionId = 0;
      this.newSystemIdL = 0;
      this.newSystemIdR = 0;
      this.newSystemId = 0;
      this.newSystemIdFrame = 0;
      this.newSystemIdLFrame = 0;
      this.newSystemIdRFrame = 0;
      this.equipmentSystems.map(x => {
        if (x.Id == system.Id && x.Side == side) {
          x.Components.map(component => {
            this.ChangeActionSelection(component, null);
            component.ActionSelectionId = 1;
            component.ActionComponentId = null;
            component.ActionWorn = null;
            component.ActionBudgetLife = null;
            component.ActionBudgetDistance = null;
            component.ActionCMU = null;
            component.ActionDOC = null;
            component.ActionCost = null;
            component.AvailableActions = [];
            component.ActionBrandId = null;

          })
        }
      })
    }
  }


  ChangeReplacementOptionForSystem(system: SystemDetails, side: string) {

    this.newSystemId = 0;
    this.newSystemIdFrame = 0;
    if (system.SystemType == "Chain") {
      if (side == "Left") {
        this.oldSystemId = this.oldSystemIdL;
        this.newSystemIdL = 0
      } else {
        this.oldSystemId = this.oldSystemIdR;
        this.newSystemIdR = 0;
      }
      this._actionService.getAvailbleSystemReplacement(this.equipmentId, this.equipmentSystems[0].JobsiteId, true, this.oldSystemId).subscribe(r => {
        if (side == "Left")
          this.availableSystemReplacementsL = r;
        else
          this.availableSystemReplacementsR = r;
        if (this.newSystemId !== 0 && this.newSystemId !== undefined) {
          //this.selectedSystemReplacement({value : { SystemId: this.newSystemId}});
        }
      });
    } else {
      if (side == "Left") {
        this.oldSystemId = this.oldSystemIdLFrame;
        this.newSystemIdLFrame = 0;
      } else {
        this.oldSystemId = this.oldSystemIdRFrame;
        this.newSystemIdRFrame = 0;
      }
      this._actionService.getAvailbleSystemReplacement(this.equipmentId, this.equipmentSystems[0].JobsiteId, true, this.oldSystemId).subscribe(r => {
        if (side == "Left")
          this.availableSystemReplacementsLFrame = r;
        else
          this.availableSystemReplacementsRFrame = r;
        if (this.newSystemId !== 0 && this.newSystemId !== undefined) {
          //this.selectedSystemReplacement({value : { SystemId: this.newSystemId}});
        }
      });
    }
    if (system.SysReplaceActionId == 1 || system.SysReplaceActionId == 3) {
      this.equipmentSystems.map(x => {
        if (x.Id == system.Id && x.Side == side) {
          x.Components.map(y => {
            y.ActionSelectionId = 2;
            this._actionService.getReplacementComponentOptions(y.Id).subscribe(c => {
              y.ActionsReplaceOption = c;
              let getActionOption = y.ActionsReplaceOption;
              y.ActionComponentId = getActionOption.find(i => i.Id == y.CompartId).Id;
              y.ActionBudgetLife = getActionOption.find(i => i.Id == y.CompartId).BudgetLife;
              y.ActionBudgetDistance = getActionOption.find(i => i.Id == y.CompartId).BudgetDistance;
            });
            this._actionService.GetAvailaleActionsForComponent(y.CompartId, this.equipmentId).subscribe(res => {
              y.AvailableActions = res;
              let cpy = Object.assign([], y.AvailableActions)
              y.AvailableActions = cpy.filter(x => x.ActionTypeName.toLowerCase().includes('Replace'.toLowerCase()))
              y.SelectedActionTypeId = y.AvailableActions[0].ActionTypeId;
            });
            y.ActionWorn = 0;
            y.ActionCMU = 0;
            y.ActionDOC = 0;
            y.ActionCost = null;
            let makelist = this.Makes;
            y.ActionBrandId = makelist.find(x => x.Title.toLowerCase() == y.Brand.toLowerCase()).Id;
            //y.ActionBudgetLife = y.BudgetLife;
          })
        }
      })
    } else if (system.SysReplaceActionId == 4 || system.SysReplaceActionId == 2) {
      this.equipmentSystems.map(x => {
        if (x.Id == system.Id && x.Side == side) {
          x.Components.map(y => {
            y.ActionSelectionId = system.SysReplaceActionId;
          })
        }
      })
    }

    let f = new Family();
    f.Id = this.equipmentDetails.FamilyId;
    f.Title = this.equipmentDetails.Family;
    let mod = new Model();
    mod.Id = this.equipmentDetails.ModelId;
    mod.Title = this.equipmentDetails.Model;
    this.fam = f;
    this.model = mod;
    this._setupService.GetAvailableCompartsAll(this.equipmentDetails.ModelId).subscribe(result => {
      this.compartList = result;
    });
  }

  getAvailableComponentReplacement(compId: number, component: ComponentDetails) {

    this._actionService.getReplacementComponentOptions(compId).subscribe(c => {
      component.ActionsReplaceOption = c;
    });
  }

  actionlist: GeneralActionViewModel[];
  disableSave: boolean = false;

  async ReloadPage() {
    debugger;
    //check chain replacement
    if (this.equipmentSystems.length > 0) {
      let chainsystemsL = [];
      let chainsystemsR = [];
      let framesystemsL = [];
      let framesystemsR = [];

      if (this.selectedSide == 3) {
        chainsystemsL = this.equipmentSystems.find(x => x.SystemType == "Chain" && x.Side == "Left").Components;
        chainsystemsR = this.equipmentSystems.find(x => x.SystemType == "Chain" && x.Side == "Right").Components;
        framesystemsL = this.equipmentSystems.find(x => x.SystemType == "Frame" && x.Side == "Left").Components;
        framesystemsR = this.equipmentSystems.find(x => x.SystemType == "Frame" && x.Side == "Right").Components;
      }
      else if (this.selectedSide == 1) {
        chainsystemsL = this.equipmentSystems.find(x => x.SystemType == "Chain" && x.Side == "Left").Components;
        framesystemsL = this.equipmentSystems.find(x => x.SystemType == "Frame" && x.Side == "Left").Components;
      } else if (this.selectedSide == 2) {
        chainsystemsR = this.equipmentSystems.find(x => x.SystemType == "Chain" && x.Side == "Right").Components;
        framesystemsR = this.equipmentSystems.find(x => x.SystemType == "Frame" && x.Side == "Right").Components;
      }

      //LEFT
      let haschainReplaceNewL = this.equipmentSystems.find(x => x.SystemType == "Chain" && x.Side == "Left" && x.ActionSelectionId == 2 && x.SysReplaceActionId == 1);
      let hasframeReplaceNewL = this.equipmentSystems.find(x => x.SystemType == "Frame" && x.Side == "Left" && x.ActionSelectionId == 2 && (x.SysReplaceActionId == 1 || x.SysReplaceActionId == 4));

      //RIGHT
      let haschainReplaceNewR = this.equipmentSystems.find(x => x.SystemType == "Chain" && x.Side == "Right" && x.ActionSelectionId == 2 && x.SysReplaceActionId == 1);
      let hasframeReplaceNewR = this.equipmentSystems.find(x => x.SystemType == "Frame" && x.Side == "Right" && x.ActionSelectionId == 2 && (x.SysReplaceActionId == 1 || x.SysReplaceActionId == 4));
      if (haschainReplaceNewL) {
        if (haschainReplaceNewL.NewSerialNo == "" || haschainReplaceNewL.NewSerialNo == null) {
          this._notification.error('Please enter new Left side chain serial number!');
          return;
        }
      }
      if (haschainReplaceNewR) {
        if (haschainReplaceNewR.NewSerialNo == "" || haschainReplaceNewR.NewSerialNo == null) {
          this._notification.error('Please enter new Right side chain serial number!');
          return;
        }
      }
      if (hasframeReplaceNewL) {
        if (hasframeReplaceNewL.NewSerialNo == "" || hasframeReplaceNewL.NewSerialNo == null) {
          this._notification.error('Please enter new Left side frame serial number!');
          return;
        }
      }
      if (hasframeReplaceNewR) {
        if (hasframeReplaceNewR.NewSerialNo == "" || hasframeReplaceNewR.NewSerialNo == null) {
          this._notification.error('Please enter new Right side frame serial number!');
          return;
        }
      }
      var _FIR = false;
      //LEFT
      //let haschainReplaceNewL = chainsystemsL.find(x => x.CompartTypeId == 230 && x.ActionSelectionId == 2 && x.ChainSysReplaceAction == 1);
      let haschainReplaceInvL = this.equipmentSystems.find(x => x.SystemType == "Chain" && x.Side == "Left" && x.ActionSelectionId == 2 && x.SysReplaceActionId == 2);
      let hasframeReplaceInvL = this.equipmentSystems.find(x => x.SystemType == "Frame" && x.Side == "Left" && x.ActionSelectionId == 2 && x.SysReplaceActionId == 2);
      //RIGHT
      //let haschainReplaceNewR = chainsystemsR.find(x => x.CompartTypeId == 230 && x.ActionSelectionId == 2 && x.ChainSysReplaceAction == 1);
      let haschainReplaceInvR = this.equipmentSystems.find(x => x.SystemType == "Chain" && x.Side == "Right" && x.ActionSelectionId == 2 && x.SysReplaceActionId == 2);
      let hasframeReplaceInvR = this.equipmentSystems.find(x => x.SystemType == "Frame" && x.Side == "Right" && x.ActionSelectionId == 2 && x.SysReplaceActionId == 2);
      if (haschainReplaceInvL) {

      }
      else {
        if (chainsystemsL) {
          chainsystemsL.forEach(x => {
            if (x.ActionSelectionId == 2 && (x.SelectedActionTypeId == null || x.ActionComponentId == null)) {
              this.validationForUsed = false;
              this.disableSave = false;
              this.IsLoading = false;
              _FIR = true;
              return;
            }
            else if (x.ActionSelectionId == 3 && x.SelectedActionTypeId == null) {
              this.validationForUsed = false;
              this.disableSave = false;
              this.IsLoading = false;
              _FIR = true;
              return;
            }
          })
        }
      }
      if (haschainReplaceInvR) {
      }
      else {
        if (chainsystemsR) {
          chainsystemsR.forEach(x => {
            if (x.ActionSelectionId == 2 && (x.SelectedActionTypeId == null || x.ActionComponentId == null)) {
              this.validationForUsed = false;
              this.disableSave = false;
              this.IsLoading = false;
              _FIR = true;
              return;
            }
            else if (x.ActionSelectionId == 3 && x.SelectedActionTypeId == null) {
              this.validationForUsed = false;
              this.disableSave = false;
              this.IsLoading = false;
              _FIR = true;
              return;
            }
          })
        }
      }
      if (hasframeReplaceInvL) {
      }
      else {
        if (framesystemsL) {
          framesystemsL.map(x => {
            if (x.ActionSelectionId == 2 && (x.SelectedActionTypeId == null || x.ActionComponentId == null)) {
              this.validationForUsed = false;
              this.disableSave = false;
              this.IsLoading = false;
              _FIR = true;
              return;
            }
            else if (x.ActionSelectionId == 3 && x.SelectedActionTypeId == null) {
              this.validationForUsed = false;
              this.disableSave = false;
              this.IsLoading = false;
              _FIR = true;
              return;
            }
          })
        }
      }
      if (framesystemsL) {
        framesystemsL.map(x => {
          if (x.ActionSelectionId == 2 && (x.SelectedActionTypeId == 10502 || x.SelectedActionTypeId == 10402 || x.SelectedActionTypeId == 10802 || x.SelectedActionTypeId == 10808 || x.SelectedActionTypeId == 10809)) {
            if (x.ActionReading == undefined || x.ActionToolId == undefined || x.ActionWorn == null) {
              this.validationForUsed = false;
              this.disableSave = false;
              this.IsLoading = false;
              //alert("Please Enter the Calculate Worn Measurement For " + x.Name + ' ' + x.Position)
              this._notification.error("Please Enter the Calculate Worn Measurement For " + x.Name + ' ' + x.Position);
              return;
            }
          }
        })
      }
      if (hasframeReplaceInvR) {
      }
      else {
        if (framesystemsR) {
          framesystemsR.map(x => {
            if (x.ActionSelectionId == 2 && (x.SelectedActionTypeId == null || x.ActionComponentId == null)) {
              this.validationForUsed = false;
              this.disableSave = false;
              this.IsLoading = false;
              _FIR = true;
              return;
            }
            else if (x.ActionSelectionId == 3 && x.SelectedActionTypeId == null) {
              this.validationForUsed = false;
              this.disableSave = false;
              this.IsLoading = false;
              _FIR = true;
              return;
            }
          })
        }
      }
      if (framesystemsR) {
        framesystemsR.map(x => {
          if (x.ActionSelectionId == 2 && (x.SelectedActionTypeId == 10502 || x.SelectedActionTypeId == 10402 || x.SelectedActionTypeId == 10802 || x.SelectedActionTypeId == 10808 || x.SelectedActionTypeId == 10809)) {
            if (x.ActionReading == undefined || x.ActionToolId == undefined || x.ActionWorn == null) {
              this.validationForUsed = false;
              this.disableSave = false;
              this.IsLoading = false;
              //alert("Please Enter the Calculate Worn Measurement For " + x.Name + ' ' + x.Position)
              this._notification.error("Please Enter the Calculate Worn Measurement For " + x.Name + ' ' + x.Position);
              return;
            }
          }
        })
      }
      if (_FIR) {
        console.log("_FIR: ", _FIR)
        console.log("this.validationForUsed: ", this.validationForUsed)
        //alert("Further Information Required!");
        this._notification.error('Further Information Required!');
      }
      else {
        console.log("_FIR Else: ", _FIR)
        console.log("this.validationForUsed: ", this.validationForUsed)
        if (this.validationForUsed) {
          this.IsLoading = true;
          //this._loading.startLoading();
          console.log("savebutton", this.disableSave)
          let result: any = await this.SaveAction()
          console.log('promise resolved: ' + result)
          console.log('next step')
          if (result > 0) {
          }
        }
      }
    }
  }


  PerformActionForIndivual(params: GeneralActionViewModel, component: ComponentDetails) {
    this._actionService.PerformAction(params).subscribe(a => {
      // this._loading.finishedLoading();
      if (a.OperationSucceed) {
        //this.succesfullySubmitted = true;
        component.ActionSucess = 1;
        this._notification.success('Component action completed');
      } else {
        //this._actioning = false;
        component.ActionSucess = 2;
        // this._notification.error('Component action can not be performed.');
        console.log("Error PerformAction", component.ActionSucess)

        console.log(a.Message);
      }
    });
  }

  PerformInspectionForAction() {
    this._loading.startLoading();
    let params = new InspectionAction();
    params.SMU = this.NewSMU;
    params.Actiondate = this.Actiondate;
    params.equipmentId = this.equipmentId;
    params.IsRSH = this.IsRSH;
    params.ProbelHrs = this.NewPropel;
    params.distanceForward = this.distanceForward;
    params.distanceReverse = this.distanceReverse;
    console.log("params: ", params);
    this._actionService.PerformInspectionAction(params).subscribe(a => {
      if (a.m_Item1 == true) {

        this.ShowDone = true;
        this.IsLoading = false;
        this._notification.success('The action was successfully completed and a new Inspection record created to reflect');
        this._loading.finishedLoading();
      } else {
        this._notification.error('Error Creating the Inspection.');
        console.log(a.m_Item2);
        this._loading.finishedLoading();
        this.IsLoading = false;
      }
    });
  }
  GotActionSearch() {
    this._router.navigate(['/search-action-recommendation']);
  }
  OpenActionComment(component: ComponentDetails) {
    const viewPhotoModalRef = this._dialog.open(ActionCommentComponent, {
      data: {
        Component: component,

      }
    });
    viewPhotoModalRef.afterClosed().subscribe(componentdetails => {
      if (componentdetails) {
        component.ActionComment = componentdetails.ActionComment;
      }
    });
  }

  getFormatedDate = (currentDate) => {
    let dd = currentDate.getDate();
    let mm = currentDate.getMonth() + 1; // January is 0!
    const yyyy = currentDate.getFullYear();
    if (dd < 10) {
      dd = `0${dd}`;
    }
    if (mm < 10) {
      mm = `0${mm}`;
    }
    return `${dd} ${mm} ${yyyy}`;
  };

  submitChainSystem(systems: SystemSetup[], comp: ComponentDetails, side: number, canInspection: boolean, sys_2: any[], comp_2: ComponentDetails, syssteup_2: SystemSetup, totalcostComp1: number, totalcostComp2: number) {
    console.log("submitChainSystem: ", systems);
    this._setupService.submit2SystemsInInventory(systems).subscribe(result => {
      if (result[0].Id > 0) {
        this.newSystemId = result[0].Id;
        this.ChainSystemReplacebyInventory(comp, side, canInspection, sys_2, comp_2, syssteup_2, 1, totalcostComp1, totalcostComp2)
      }
    });
  }

  submitFrameSystem(systems: SystemSetup[], comp: ComponentDetails, side: number, canInspection: boolean, sys_2: any[], comp_2: ComponentDetails, syssteup_2: SystemSetup, totalcostComp1: number, totalcostComp2: number) {
    console.log("submitFrameSystem: ", systems);
    this._setupService.submit2SystemsInInventory(systems).subscribe(result => {
      if (result[0].Id > 0) {
        this.newSystemIdFrame = result[0].Id;
        this.FrameSystemReplacebyInventory(comp, side, canInspection, sys_2, comp_2, syssteup_2, 2, totalcostComp1, totalcostComp2)
      }
    });
  }

  ChangeWorkOrder(comp: ComponentDetails, event: any) {
    comp.ActionWO = event.target.value;
  }
  ChangesSerial(system: SystemDetails, event: any) {
    system.NewSerialNo = event.target.value;

    this._setupService.checkSystemSerialNo(event.target.value).subscribe(r => {
      if (!r) {
        system.Components[0].ActionSucess = 0;
      } else {
        system.Components[0].ActionSucess = 2;
        this._notification.error('Operation failed!', 'That system serial number already exists! Please enter a valid serial number.');
      }
    });
  }
  ChangesCost(comp: ComponentDetails, event: any, system: SystemDetails) {
    if (event.target.value != "") {
      comp.ActionCost = Number(event.target.value);
      if (system.SysReplaceActionId == 2) {
        if (system.SystemType == "Chain") {
          if (system.Side == "Left") {
            let updatedCOmp = this.newSystemIdLInfo.Components.find(x => x.Pos == comp.Position && x.CompartType == comp.CompartTypeId);
            updatedCOmp.TotalCost = Number(event.target.value);
            this.UpdateInventoryComponent(updatedCOmp);
          } else {
            let updatedCOmp = this.newSystemIdRInfo.Components.find(x => x.Pos == comp.Position && x.CompartType == comp.CompartTypeId);
            updatedCOmp.TotalCost = Number(event.target.value);
            this.UpdateInventoryComponent(updatedCOmp);
          }
        } else {
          if (system.Side == "Left") {
            let updatedCOmp = this.newSystemIdLFrameInfo.Components.find(x => x.Pos == comp.Position && x.CompartType == comp.CompartTypeId);
            updatedCOmp.TotalCost = Number(event.target.value);
            this.UpdateInventoryComponent(updatedCOmp);
          } else {
            let updatedCOmp = this.newSystemIdRFrameInfo.Components.find(x => x.Pos == comp.Position && x.CompartType == comp.CompartTypeId);
            updatedCOmp.TotalCost = Number(event.target.value);
            this.UpdateInventoryComponent(updatedCOmp);
          }
        }
      }
    }
  }

  ChangesBudgetLife(comp: ComponentDetails, event: any, system: SystemDetails) {
    if (event.target.value != "") {
      comp.ActionBudgetLife = Number(event.target.value);
      if (system.SysReplaceActionId == 2) {
        if (system.SystemType == "Chain") {
          if (system.Side == "Left") {
            let updatedCOmp = this.newSystemIdLInfo.Components.find(x => x.Pos == comp.Position && x.CompartType == comp.CompartTypeId);
            updatedCOmp.Budget = Number(event.target.value);
            this.UpdateInventoryComponent(updatedCOmp);
          } else {
            let updatedCOmp = this.newSystemIdRInfo.Components.find(x => x.Pos == comp.Position && x.CompartType == comp.CompartTypeId);
            updatedCOmp.Budget = Number(event.target.value);
            this.UpdateInventoryComponent(updatedCOmp);
          }
        } else {
          if (system.Side == "Left") {
            let updatedCOmp = this.newSystemIdLFrameInfo.Components.find(x => x.Pos == comp.Position && x.CompartType == comp.CompartTypeId);
            updatedCOmp.Budget = Number(event.target.value);
            this.UpdateInventoryComponent(updatedCOmp);
          } else {
            let updatedCOmp = this.newSystemIdRFrameInfo.Components.find(x => x.Pos == comp.Position && x.CompartType == comp.CompartTypeId);
            updatedCOmp.Budget = Number(event.target.value);
            this.UpdateInventoryComponent(updatedCOmp);
          }
        }
      }
    }
  }

  ChangesBudgetDistance(comp: ComponentDetails, event: any, system: SystemDetails) {
    if (event.target.value != "") {
      comp.ActionBudgetDistance = Number(event.target.value);
      if (system.SysReplaceActionId == 2) {
        if (system.SystemType == "Chain") {
          if (system.Side == "Left") {
            let updatedCOmp = this.newSystemIdLInfo.Components.find(x => x.Pos == comp.Position && x.CompartType == comp.CompartTypeId);
            updatedCOmp.DistanceBudget = Number(event.target.value);
            this.UpdateInventoryComponent(updatedCOmp);
          } else {
            let updatedCOmp = this.newSystemIdRInfo.Components.find(x => x.Pos == comp.Position && x.CompartType == comp.CompartTypeId);
            updatedCOmp.DistanceBudget = Number(event.target.value);
            this.UpdateInventoryComponent(updatedCOmp);
          }
        } else {
          if (system.Side == "Left") {
            let updatedCOmp = this.newSystemIdLFrameInfo.Components.find(x => x.Pos == comp.Position && x.CompartType == comp.CompartTypeId);
            updatedCOmp.DistanceBudget = Number(event.target.value);
            this.UpdateInventoryComponent(updatedCOmp);
          } else {
            let updatedCOmp = this.newSystemIdRFrameInfo.Components.find(x => x.Pos == comp.Position && x.CompartType == comp.CompartTypeId);
            updatedCOmp.DistanceBudget = Number(event.target.value);
            this.UpdateInventoryComponent(updatedCOmp);
          }
        }
      }
    }
  }


  ChangesCMU(comp: ComponentDetails, event: any, system: SystemDetails) {
    if (event.target.value != "") {
      comp.ActionCMU = Number(event.target.value);
      //console.log("event.target.value:", event.target.value);
      if (system.SysReplaceActionId == 2) {
        if (system.SystemType == "Chain") {
          if (system.Side == "Left") {
            let updatedCOmp = this.newSystemIdLInfo.Components.find(x => x.Pos == comp.Position && x.CompartType == comp.CompartTypeId);
            updatedCOmp.CMU = Number(event.target.value);
            this.UpdateInventoryComponent(updatedCOmp);
          } else {
            let updatedCOmp = this.newSystemIdRInfo.Components.find(x => x.Pos == comp.Position && x.CompartType == comp.CompartTypeId);
            updatedCOmp.CMU = Number(event.target.value);
            this.UpdateInventoryComponent(updatedCOmp);
          }
        } else {
          if (system.Side == "Left") {
            let updatedCOmp = this.newSystemIdLFrameInfo.Components.find(x => x.Pos == comp.Position && x.CompartType == comp.CompartTypeId);
            updatedCOmp.CMU = Number(event.target.value);
            this.UpdateInventoryComponent(updatedCOmp);
          } else {
            let updatedCOmp = this.newSystemIdRFrameInfo.Components.find(x => x.Pos == comp.Position && x.CompartType == comp.CompartTypeId);
            updatedCOmp.CMU = Number(event.target.value);
            this.UpdateInventoryComponent(updatedCOmp);
          }
        }
      }
    }
  }

  ChangesDOC(comp: ComponentDetails, event: any, system: SystemDetails) {
    //console.log("event.target.value:", event.target.value);
    if (event.target.value != "") {
      comp.ActionDOC = Number(event.target.value);

      if (system.SysReplaceActionId == 2) {
        if (system.SystemType == "Chain") {
          if (system.Side == "Left") {
            let updatedComp = this.newSystemIdLInfo.Components.find(x => x.Pos == comp.Position && x.CompartType == comp.CompartTypeId);
            updatedComp.DOC = Number(event.target.value);
            this.UpdateInventoryComponent(updatedComp);
          } else {
            let updatedComp = this.newSystemIdRInfo.Components.find(x => x.Pos == comp.Position && x.CompartType == comp.CompartTypeId);
            updatedComp.DOC = Number(event.target.value);
            this.UpdateInventoryComponent(updatedComp);
          }
        } else {
          if (system.Side == "Left") {
            let updatedComp = this.newSystemIdLFrameInfo.Components.find(x => x.Pos == comp.Position && x.CompartType == comp.CompartTypeId);
            updatedComp.DOC = Number(event.target.value);
            this.UpdateInventoryComponent(updatedComp);
          } else {
            let updatedComp = this.newSystemIdRFrameInfo.Components.find(x => x.Pos == comp.Position && x.CompartType == comp.CompartTypeId);
            updatedComp.DOC = Number(event.target.value);
            this.UpdateInventoryComponent(updatedComp);
          }
        }
      }
    }
  }

  ChangesWorn(comp: ComponentDetails, event: any, system: SystemDetails) {
    if (event.target.value != "") {
      comp.ActionWorn = Number(event.target.value);
      //console.log("this.newSystemIdLInfo",this.newSystemIdLInfo)
      if (system.SysReplaceActionId == 2) {
        if (system.SystemType == "Chain") {
          if (system.Side == "Left") {
            let updatedCOmp = this.newSystemIdLInfo.Components.find(x => x.Pos == comp.Position && x.CompartType == comp.CompartTypeId);
            updatedCOmp.WornPercentage = Number(event.target.value);
            this.UpdateInventoryComponent(updatedCOmp);
          } else {
            let updatedCOmp = this.newSystemIdRInfo.Components.find(x => x.Pos == comp.Position && x.CompartType == comp.CompartTypeId);
            updatedCOmp.WornPercentage = Number(event.target.value);
            this.UpdateInventoryComponent(updatedCOmp);
          }
        } else {
          if (system.Side == "Left") {
            let updatedCOmp = this.newSystemIdLFrameInfo.Components.find(x => x.Pos == comp.Position && x.CompartType == comp.CompartTypeId);
            updatedCOmp.WornPercentage = Number(event.target.value);
            this.UpdateInventoryComponent(updatedCOmp);
          } else {
            let updatedCOmp = this.newSystemIdRFrameInfo.Components.find(x => x.Pos == comp.Position && x.CompartType == comp.CompartTypeId);
            updatedCOmp.WornPercentage = Number(event.target.value);
            this.UpdateInventoryComponent(updatedCOmp);
          }
        }
      }
    }
  }


  UpdateInventoryComponent(component: SystemComponentViewModel) {
    this.inventoryService
      .updateSystemInInventoryInfo(component)
      .subscribe(res => {
        console.log("updated", res)
      });
  }


  getTitle(comp: ComponentDetails) {
    var OEM = comp.OEMPartNo;
    var MFR = comp.MFRPartNo;
    var value = "";
    if (OEM != null && MFR != null) {
      return value = "OEM Part# :" + OEM + '\n' + "Mfr.Part# :" + MFR;
    } else if (OEM != null) {
      return value = "OEM Part# :" + OEM;
    } else if (MFR != null) {
      return value = "Mfr.Part# :" + MFR;
    } else {
      return value;
    }
  }
  Actiondate: Date;
  pickedEventDate(event: any) {
    this.Actiondate = event;
    this.disableSave = false;
  }
  newActionDate = new Date();
  lastInspectionDate = new Date();
  ChecklastInspectionDateAndSMU() {
    this.ShowWarning = false;
    this.warning = "";
    this.newActionDate = new Date(this.Actiondate);
    this.lastInspectionDate = new Date(this.equipmentDetails.LastInspectionDate_,)
    if (this.newActionDate != null && this.NewSMU != null) {
      if (this.equipmentDetails.LastInspectionDate != "Never") {
        if (this.NewSMU < this.equipmentDetails.LastInspectionSMU && this.lastInspectionDate > this.newActionDate) {
          this.OpenConfirmDialog()
          this.GetFutureInspectionForEquipment();
        }
        this.GetFutureInspectionForEquipment();

      }

    }
  }

  ShowWarning: boolean = false;
  warning: string = "";
  GetFutureInspectionForEquipment() {
    this._actionService.CheckValidationForAction(this.equipmentId, this.Actiondate, this.NewSMU).subscribe(res => {
      if (res != "") {
        this.ShowWarning = true;
        this.warning = res;
        this.disableSave = true;
      } else {
        this.ShowWarning = false;
        this.warning = res;
        this.disableSave = false;

      }

    })
  }

  LoadPreviosuInspectionSystemDetails() {
    this._actionService.getPreviousInspectionForSelectedEquipment(this.equipmentId, this.Actiondate, this.NewSMU).subscribe(res => {
      console.log("result previosu inspection", res);
      this.equipmentSystems = res;
      this.equipmentSystemsCopy = res;


      this.IsLoading = false;

    })
  }
  OpenConfirmDialog() {
    const viewPhotoModalRef = this._dialog.open(ConfirmActionBackInComponent, {
      disableClose: true,
      data: {
        EquipmentId: this.equipmentId,
        SMU: this.NewSMU,
        ActionDate: this.Actiondate
      }
    });
    viewPhotoModalRef.afterClosed().subscribe(res => {
      if (res == true) {
        this.IsLoading = true;
        //go Ahead with current data
        //get previous inspection data into the page instead of current details
        this.LoadPreviosuInspectionSystemDetails();

      } else if (res == false) {
        //clear data
        this.NewSMU = null;
        this.Actiondate = null;
      }
    });
  }
  getChangeBackColour(component: ComponentDetails) {
    if (component.SelectedActionTypeId > 0) {
      let action = component.AvailableActions.find(x => x.ActionTypeId == component.SelectedActionTypeId);
      if (component.ActionSelectionId == 2 && action.ActionTypeName.toLowerCase().includes('Used')) {
        return 'mandatoryField';
      }
    }


  }
  showPosition(position: number, compartTypeId: number): string {
    if (this.equipmentSystems[0].Components.length > 4) {
      return this.getPositionStringDoubleComponents(position, compartTypeId);
    } else {
      return this._appService.getPositionString(position, compartTypeId);
    }

  }
  getPositionStringDoubleComponents(Pos: number, CompartTypeId: number): string {
    if (CompartTypeId === 233) // Idler
      if (Pos === 1) return 'Front'; else if (Pos === 2) return 'Rear';
    if (CompartTypeId === 234 && Pos === 1) // Carrier roller
      return 'Front';
    if (CompartTypeId >= 230 && CompartTypeId <= 232 || CompartTypeId === 236 || CompartTypeId === 237 || CompartTypeId === 240 || Pos === undefined) {// Link, Bushing, Shoe, Sprocket
      if (Pos === 1) return 'Front'; else if (Pos === 2) return 'Rear';

    }
    if (CompartTypeId == 446)
      return 'Rear'
    return Pos.toString();
  }

  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }
  Translate(value: string): string {
    return this._translate.translateToLang(value, this._userLanguage);
  }
  translate(value: string): string {
    return this._translate.translateToLang(value, this._userLanguage);
  }



  ChainSystemReplacebyInventory(haschainReplaceInventory: ComponentDetails, side: number, canInspection: boolean, sys_2: any[], comp_2: ComponentDetails, syssteup_2: SystemSetup, IsChainFrameReplaceNew: number, TotalcostComp1: number, totalCostCom2: number) {

    let params = new GeneralActionViewModel();
    params.Comment = haschainReplaceInventory.ActionComment;//this.ActionComment;
    params.EquipmentId = Number(this.equipmentId);
    params.MakeId = haschainReplaceInventory.ActionBrandId;
    params.NewSMU = this.NewSMU;
    params.ReplaceComponentCompartId = haschainReplaceInventory.ActionComponentId;
    params.ActionDate = this.Actiondate;
    params.ActionEqUnitId = haschainReplaceInventory.Id;
    params.ActionTypeId = +ActionType.ReplaceSystemFromInventory;
    params.BudgetLife = haschainReplaceInventory.ActionBudgetLife;
    params.BudgetDistance = haschainReplaceInventory.ActionBudgetDistance;
    params.MiscCost = TotalcostComp1;// haschainReplaceInventory.ActionCost;
    params.NewEqUnitId = haschainReplaceInventory.ActionSelectionId;
    params.DOEatInstall = this.distanceForward + this.distanceReverse;

    //from inventory  
    const promiseSystemReplacement = this.equipmentSystems.map(async z => {
      if (z.SystemType == "Chain" && z.Side == "Left" && side == 1) {

        this.oldSystemId = z.Id;

        console.log("Chain replace L", this.oldSystemId, this.newSystemId)
        const response = await this._actionService.SystemReplacement(params, this.newSystemId, this.oldSystemId, IsChainFrameReplaceNew).toPromise();
        return response

      } else if (z.SystemType == "Chain" && z.Side == "Right" && side == 2) {
        this.oldSystemId = z.Id;
        console.log("Chain replace R", this.oldSystemId, this.newSystemId)
        const response = await this._actionService.SystemReplacement(params, this.newSystemId, this.oldSystemId, IsChainFrameReplaceNew).toPromise();
        return response
      }
    })

    Promise.all(promiseSystemReplacement).then(() => {
      if (this.selectedSide != 3) {
        this.PerformInspectionForAction();
      } else {
        if (canInspection == true) {
          this.PerformInspectionForAction();
        } else if (canInspection == false) {
          this.chainSystemNEW = [];
          const chainsystemsreqNEW = sys_2.map((c, index) => {
            let pos = index + 1;
            let comp = new ComponentSetup();
            comp.Id = c.ActionSelectionId == 4 ? c.Id : 0;
            comp.Brand = this.Makes.find(x => x.Id == c.ActionBrandId);
            comp.BudgetLife = c.ActionBudgetLife;
            comp.DistanceBudget = c.ActionBudgetDistance;
            comp.BushTurnedPercent = 75;
            comp.EquipmentSMU = 0;
            comp.HoursAtInstall = c.ActionCMU;
            comp.InstallCost = c.ActionCost;
            comp.InstallDate = this.Actiondate;
            comp.PMUAtInstall = 0;
            comp.Pos = c.Position;
            comp.PropelHrs = 0;
            comp.ShoeGrouser = 1;
            comp.SystemId = 0;
            comp.listPosition = pos;
            comp.Compart = this.compartList.find(i => i.Id == c.ActionComponentId);
            comp.ActionWO = c.ActionWO;
            comp.UsedWorn = c.ActionWorn;
            comp.UsedCMU = c.ActionCMU;
            comp.UsedDOC = c.ActionDOC;
            comp.Measurement = c.ActionReading;
            comp.ToolId = c.ActionToolId;
            comp.DOC = c.ActionDOC;
            comp.KeepComponent = c.ActionSelectionId == 4 ? true : false;
            return comp;
          })


          Promise.all(chainsystemsreqNEW).then(chainsystemsresNew => {
            syssteup_2.Components = chainsystemsresNew;
            let arry = [];
            arry.push(syssteup_2);
            this.chainSystemNEW = arry;

            console.log("chainSystemNEW: ", this.chainSystemNEW);
            this.submitChainSystem(this.chainSystemNEW, comp_2, 1, true, null, null, null, totalCostCom2, TotalcostComp1);
          });
        }
      }

      //this._notification.success('System successfully replaced');
    }).catch(err => {
      console.log("Errr promiseSystemReplacement", err)
    })


  }



  FrameSystemReplacebyInventory(hasframeReplaceInventory: ComponentDetails, side: number, canInspection: boolean, sys_2: any[], comp_2: ComponentDetails, syssteup_2: SystemSetup, IsFrameReplaceNew: number, totalcostComp1: number, totalcostComp2: number) {
    let params = new GeneralActionViewModel();
    params.Comment = hasframeReplaceInventory.ActionComment;//this.ActionComment;
    params.EquipmentId = Number(this.equipmentId);
    params.MakeId = hasframeReplaceInventory.ActionBrandId;
    params.NewSMU = this.NewSMU;
    params.ReplaceComponentCompartId = hasframeReplaceInventory.ActionComponentId;
    params.ActionDate = this.Actiondate;
    params.ActionEqUnitId = hasframeReplaceInventory.Id;
    params.ActionTypeId = +ActionType.ReplaceSystemFromInventory;
    params.BudgetLife = hasframeReplaceInventory.ActionBudgetLife;
    params.BudgetDistance = hasframeReplaceInventory.ActionBudgetDistance;
    params.MiscCost = totalcostComp1//hasframeReplaceInventory.ActionCost;
    params.NewEqUnitId = hasframeReplaceInventory.ActionSelectionId;
    params.DOEatInstall = this.distanceForward + this.distanceReverse;
    console.log("this.equipmentSystems___Frame", this.equipmentSystems)
    //from inventory  
    const promiseSystemReplacement = this.equipmentSystems.map(async z => {
      if (z.SystemType == "Frame" && z.Side == "Left" && side == 1) {

        this.oldSystemIdFrame = z.Id;

        console.log("Frame replace", this.oldSystemIdFrame, this.newSystemIdFrame)
        const response = await this._actionService.SystemReplacement(params, this.newSystemIdFrame, this.oldSystemIdFrame, IsFrameReplaceNew).toPromise();
        return response

      } else if (z.SystemType == "Frame" && z.Side == "Right" && side == 2) {
        this.oldSystemIdFrame = z.Id;
        console.log("Frame replace R", this.oldSystemIdFrame, this.newSystemIdFrame)
        const response = await this._actionService.SystemReplacement(params, this.newSystemIdFrame, this.oldSystemIdFrame, IsFrameReplaceNew).toPromise();
        return response
      }
    })

    Promise.all(promiseSystemReplacement).then(res => {
      console.log("promiseSystemReplacement", res)
      if (this.selectedSide != 3) {
        this.ChainSystemAllMethods();
      } else {
        if (canInspection == true) {
          this.ChainSystemAllMethods();
        } else if (canInspection == false) {
          this.frameSystemNEW = [];
          const framesystemsreqNEW = sys_2.map((c, index) => {
            console.log("frameData", c)
            let pos = index + 1;
            let comp = new ComponentSetup();
            comp.Id = c.ActionSelectionId == 4 ? c.Id : 0;
            comp.Brand = this.Makes.find(x => x.Id == c.ActionBrandId);
            comp.BudgetLife = c.ActionBudgetLife;
            comp.DistanceBudget = c.ActionBudgetDistance;
            comp.BushTurnedPercent = 75;
            comp.EquipmentSMU = 0;
            comp.HoursAtInstall = c.ActionCMU;
            comp.InstallCost = c.ActionCost;
            comp.InstallDate = this.Actiondate;
            comp.PMUAtInstall = 0;
            comp.Pos = c.Position;
            comp.PropelHrs = 0;
            comp.ShoeGrouser = 1;
            comp.SystemId = 0;
            comp.listPosition = pos;
            comp.Compart = this.compartList.find(i => i.Id == c.ActionComponentId);
            comp.ActionWO = c.ActionWO;
            comp.UsedWorn = c.ActionWorn;
            comp.UsedCMU = c.ActionCMU;
            comp.UsedDOC = c.ActionDOC;
            comp.Measurement = c.ActionReading;
            comp.ToolId = c.ActionToolId;
            comp.DOC = c.ActionDOC;
            comp.KeepComponent = c.ActionSelectionId == 4 ? true : false;
            return comp;
          })


          Promise.all(framesystemsreqNEW).then(framesystemsresNew => {
            syssteup_2.Components = framesystemsresNew;
            let arry = [];
            arry.push(syssteup_2);
            this.frameSystemNEW = arry;


            this.submitFrameSystem(this.frameSystemNEW, comp_2, 1, true, null, null, null, totalcostComp2, totalcostComp1);
          });
        }
      }

      //this._notification.success('System successfully replaced');
    }).catch(err => {
      console.log("Errr promiseSystemReplacement", err)
    })
  }
  validationForUsed: boolean = true;

  SaveAction() {
    debugger;
    this.disableSave = true;
    return new Promise((resolve) => {
      let y = 0
      setTimeout(() => {
        this.disableSave = true;
        //console.log("savebutton 11", this.disableSave)
        //this._loading.startLoading();
        //console.log("compartList", this.compartList)
        if (this.equipmentSystems.length > 0) {
          //console.log("chainsystems 11", this.equipmentSystems)
          let chainsystemsL = [];
          let chainsystemsR = [];
          let chainsystems = [];
          let framesystems = [];
          let framesystemsL = [];
          let framesystemsR = [];
          if (this.selectedSide == 3) {
            chainsystemsL = this.equipmentSystems.find(x => x.SystemType == "Chain" && x.Side == "Left").Components;
            chainsystemsR = this.equipmentSystems.find(x => x.SystemType == "Chain" && x.Side == "Right").Components;
            framesystemsL = this.equipmentSystems.find(x => x.SystemType == "Frame" && x.Side == "Left").Components;
            framesystemsR = this.equipmentSystems.find(x => x.SystemType == "Frame" && x.Side == "Right").Components;
            framesystems = framesystemsL.concat(framesystemsR);
          }
          else if (this.selectedSide == 1) {
            chainsystemsL = this.equipmentSystems.find(x => x.SystemType == "Chain" && x.Side == "Left").Components;
            framesystemsL = this.equipmentSystems.find(x => x.SystemType == "Frame" && x.Side == "Left").Components;
            framesystems = framesystemsL
          } else if (this.selectedSide == 2) {
            chainsystemsR = this.equipmentSystems.find(x => x.SystemType == "Chain" && x.Side == "Right").Components;
            framesystemsR = this.equipmentSystems.find(x => x.SystemType == "Frame" && x.Side == "Right").Components;
            framesystems = framesystemsR;
          }
          chainsystems = this.equipmentSystems.find(x => x.SystemType == "Chain").Components;
          //LEFT
          let hasframeReplaceNewL = this.equipmentSystems.find(x => x.SystemType == "Frame" && x.Side == "Left" && x.ActionSelectionId == 2 && (x.SysReplaceActionId == 1 || x.SysReplaceActionId == 4));
          let hasframeReplaceInventoryL = this.equipmentSystems.find(x => x.SystemType == "Frame" && x.Side == "Left" && x.ActionSelectionId == 2 && x.SysReplaceActionId == 2);
          //RIGHT
          let hasframeReplaceNewR = this.equipmentSystems.find(x => x.SystemType == "Frame" && x.Side == "Right" && x.ActionSelectionId == 2 && (x.SysReplaceActionId == 1 || x.SysReplaceActionId == 4));
          let hasframeReplaceInventoryR = this.equipmentSystems.find(x => x.SystemType == "Frame" && x.Side == "Right" && x.ActionSelectionId == 2 && x.SysReplaceActionId == 2);
          //check  for Used COkpnets validation
          if (hasframeReplaceNewL === undefined)
            hasframeReplaceNewL = null;
          if (hasframeReplaceInventoryL === undefined)
            hasframeReplaceInventoryL = null;
          if (hasframeReplaceNewR === undefined)
            hasframeReplaceNewR = null;
          if (hasframeReplaceInventoryR === undefined)
            hasframeReplaceInventoryR = null;
          //for frame components if validation true
          if (this.validationForUsed == true) {
            if (this.selectedSide == 1) { //Left Side
              if (hasframeReplaceNewL == null && hasframeReplaceInventoryL == null) {
                const framesystemsreq = framesystems.map(async x => {
                  y = 1;
                  if (x.ActionSelectionId != 1 && x.ActionSelectionId != 4) {
                    let params = new GeneralActionViewModel();
                    params.Comment = x.ActionComment;//this.ActionComment;
                    params.EquipmentId = Number(this.equipmentId);
                    params.MakeId = x.ActionBrandId;
                    params.NewSMU = this.NewSMU;
                    params.ReplaceComponentCompartId = x.ActionComponentId;
                    params.ActionDate = this.Actiondate;
                    params.ActionEqUnitId = x.Id;
                    params.ActionTypeId = x.SelectedActionTypeId;
                    params.BudgetLife = x.ActionBudgetLife;
                    params.BudgetDistance = x.ActionBudgetDistance;
                    params.MiscCost = x.ActionCost;
                    params.NewEqUnitId = (x.SelectedActionTypeId === 10602 || x.SelectedActionTypeId === 17 || x.SelectedActionTypeId === 10702) ? x.SwapComponentId : x.ActionSelectionId;
                    params.ReplaceComponentCompartName = x.ActionSelectionId == 2 ? x.ActionsReplaceOption.find(y => y.Id == x.ActionComponentId).Name : '';
                    params.UsedWorn = x.ActionWorn;
                    params.UsedCMU = x.ActionCMU;
                    params.UsedDOC = x.ActionDOC;
                    params.Measurement = x.ActionReading;
                    params.ToolId = x.ActionToolId;
                    params.ActionWO = x.ActionWO;
                    params.ShoeSize = x.ShoeSize
                    params.GrouserId = x.GrouserId
                    params.CleanerHolesId = x.CleanerHolesId == 0 ? null : x.CleanerHolesId
                    params.DOEatInstall = this.distanceForward + this.distanceReverse;
                    //console.log("params", params);
                    //   this.PerformActionForIndivual(params,x);
                    const response = await this._actionService.PerformAction(params).toPromise();
                    //console.log("response", response)
                    if (response.OperationSucceed == false) {
                      x.ActionSucess = 2;
                      //console.log("ErrorPerformAction", x.ActionSucess)
                    } else if (response.OperationSucceed == true) {
                      x.ActionSucess = 1;
                      //console.log("PerformAction", x.ActionSucess)
                    }
                    return response;
                  }
                  //this._loading.finishedLoading();
                })
                Promise.all(framesystemsreq).then(() => {
                  //console.log("resChain", resChain);
                  this.ChainSystemAllMethods()
                })
              }
              else if (hasframeReplaceInventoryL) {
                console.log("hasframeReplaceInventoryL: ", hasframeReplaceInventoryL);
                let params = new GeneralActionViewModel();
                params.Comment = hasframeReplaceInventoryL.Components[0].ActionComment;//this.ActionComment;
                params.EquipmentId = Number(this.equipmentId);
                params.MakeId = hasframeReplaceInventoryL.Components[0].ActionBrandId;
                params.NewSMU = this.NewSMU;
                params.ReplaceComponentCompartId = hasframeReplaceInventoryL.Components[0].ActionComponentId;
                params.ActionDate = this.Actiondate;
                params.ActionEqUnitId = hasframeReplaceInventoryL.Id;
                params.ActionTypeId = +ActionType.ReplaceSystemFromInventory;
                params.BudgetLife = hasframeReplaceInventoryL.Components[0].ActionBudgetLife;
                params.BudgetDistance = hasframeReplaceInventoryL.Components[0].ActionBudgetDistance;
                params.MiscCost = hasframeReplaceInventoryL.Components.reduce((accum, item) => accum + item.ActionCost, 0)//hasframeReplaceInventoryL.Components[0].ActionCost;
                params.NewEqUnitId = hasframeReplaceInventoryL.ActionSelectionId;
                params.DOEatInstall = this.distanceForward + this.distanceReverse;
                //console.log("params", params);
                //from inventory  
                const PromisechainsystemRepaceInvemtoryL = this.equipmentSystems.map(async z => {
                  if (z.SystemType == "Frame" && z.Side == "Left") {
                    this.oldSystemIdFrame = z.Id;
                    //console.log("Frame replace", this.oldSystemIdFrame, this.newSystemIdLFrame)
                    const response = await this._actionService.SystemReplacement(params, this.newSystemIdLFrame, this.oldSystemIdFrame, 0).toPromise();
                    return response;
                  }
                })
                Promise.all(PromisechainsystemRepaceInvemtoryL).then(() => {
                  //console.log("ReshainsystemRepaceInvemtoryL", ReshainsystemRepaceInvemtoryL);
                  this.ChainSystemAllMethods()
                }).catch(err => {
                  console.log("PromisechainsystemRepaceInvemtoryL", err);
                })
              }
              else if (hasframeReplaceNewL) {
                console.log("hasframeReplaceNewL: ", hasframeReplaceNewL);
                this.frameSystem = [];
                let sys = new SystemSetup();
                sys.Id = 0;
                sys.BudgetLife = hasframeReplaceNewL.NewBudgetLife;
                sys.BudgetDistance = hasframeReplaceNewL.NewBudgetDistance;
                sys.FrameCost = hasframeReplaceNewL.NewFrameCost;
                sys.EquipmentId = 0;
                sys.HoursAtInstall = hasframeReplaceNewL.SysReplaceActionId == 4 ? 0 : hasframeReplaceNewL.Components[0].ActionCMU;
                sys.HistoricalDistance = hasframeReplaceNewL.SysReplaceActionId == 4 ? 0 : hasframeReplaceNewL.Components[0].ActionDOC;
                sys.TotalDistance = this.distanceForward + this.distanceReverse;
                sys.InstallOnEquipment = false;
                sys.InstallationDate = this.Actiondate;
                sys.InstallationDate_ = this.getFormatedDate(new Date(this.Actiondate));
                sys.JobsiteId = this.equipmentSystems[0].JobsiteId;
                sys.PMUAtInstall = 0;
                sys.PropelAtInstall = 0;
                sys.Serial = hasframeReplaceNewL.NewSerialNo;
                sys.SetupDate = this.Actiondate;
                sys.Side = this.selectedSide;
                sys.SmuAtInstall = 0;
                sys.Type = 2;
                sys.Family = this.fam;
                sys.Model = this.model;
                if (hasframeReplaceNewL.SysReplaceActionId == 4)
                  sys.Make = this.Makes.find(x => x.Id == this.equipmentSystems[0].MakeId)
                else
                  sys.Make = this.Makes.find(x => x.Id == hasframeReplaceNewL.Components[0].ActionBrandId)
                const framesystemsreqL = framesystemsL.map((c, index) => {
                  //console.log("Frame Left__", c)
                  let pos = index + 1;
                  let comp = new ComponentSetup();
                  comp.Id = c.ActionSelectionId == 4 ? c.Id : 0;
                  comp.Brand = this.Makes.find(x => x.Id == c.ActionBrandId);
                  comp.BudgetLife = c.ActionBudgetLife;
                  comp.DistanceBudget = c.ActionBudgetDistance;
                  comp.BushTurnedPercent = 75;
                  comp.EquipmentSMU = 0;
                  comp.HoursAtInstall = c.ActionCMU;
                  comp.InstallCost = c.ActionCost;
                  comp.InstallDate = this.Actiondate;
                  comp.PMUAtInstall = 0;
                  comp.Pos = c.Position;
                  comp.PropelHrs = 0;
                  comp.ShoeGrouser = 1;
                  comp.SystemId = 0;
                  comp.listPosition = pos;
                  comp.Compart = this.compartList.find(i => i.Id == c.ActionComponentId);
                  comp.ActionWO = c.ActionWO;
                  comp.UsedWorn = c.ActionWorn;
                  comp.UsedCMU = c.ActionCMU;
                  comp.UsedDOC = c.ActionDOC;
                  comp.Measurement = c.ActionReading;
                  comp.ToolId = c.ActionToolId;
                  comp.DOC = c.ActionDOC;
                  comp.KeepComponent = c.ActionSelectionId == 4 ? true : false;
                  return comp;
                })
                Promise.all(framesystemsreqL).then(framesystemsres => {
                  sys.Components = framesystemsres;
                  let arry = [];
                  arry.push(sys);
                  this.frameSystem = arry;
                  console.log("hasframeReplaceNewL arry: ", arry, this.frameSystem);
                  //replace new chain 
                  //this.ValidateSerialNo(haschainReplaceNewL.ChainSysNewSrial, haschainReplaceNewL, this.chainSystem,1);
                  var comp1tot = hasframeReplaceNewL.Components.reduce((accum, item) => accum + item.ActionCost, 0)
                  this.submitFrameSystem(this.frameSystem, hasframeReplaceNewL.Components[0], 1, true, null, null, null, comp1tot, 0);
                }).catch(err => {
                  console.log("framesystemsreqR", err);
                })
              }
              else {
                this.ChainSystemAllMethods();
              }
            }
            else if (this.selectedSide == 2) {//Right Side
              if (hasframeReplaceNewR == null && hasframeReplaceInventoryR == null) {
                const framesystemsreq = framesystems.map(async x => {
                  y = 1;
                  if (x.ActionSelectionId != 1 && x.ActionSelectionId != 4) {
                    let params = new GeneralActionViewModel();
                    params.Comment = x.ActionComment;//this.ActionComment;
                    params.EquipmentId = Number(this.equipmentId);
                    params.MakeId = x.ActionBrandId;
                    params.NewSMU = this.NewSMU;
                    params.ReplaceComponentCompartId = x.ActionComponentId;
                    params.ActionDate = this.Actiondate;
                    params.ActionEqUnitId = x.Id;
                    params.ActionTypeId = x.SelectedActionTypeId;
                    params.BudgetLife = x.ActionBudgetLife;
                    params.BudgetDistance = x.ActionBudgetDistance;
                    params.MiscCost = x.ActionCost;
                    params.NewEqUnitId = (x.SelectedActionTypeId === 10602 || x.SelectedActionTypeId === 17 || x.SelectedActionTypeId === 10702) ? x.SwapComponentId : x.ActionSelectionId;
                    params.ReplaceComponentCompartName = x.ActionSelectionId == 2 ? x.ActionsReplaceOption.find(y => y.Id == x.ActionComponentId).Name : '';
                    params.UsedWorn = x.ActionWorn;
                    params.UsedCMU = x.ActionCMU;
                    params.UsedDOC = x.ActionDOC;
                    params.Measurement = x.ActionReading;
                    params.ToolId = x.ActionToolId;
                    params.ActionWO = x.ActionWO;
                    params.ShoeSize = x.ShoeSize
                    params.GrouserId = x.GrouserId
                    params.CleanerHolesId = x.CleanerHolesId == 0 ? null : x.CleanerHolesId
                    params.DOEatInstall = this.distanceForward + this.distanceReverse;
                    //console.log("params", params);
                    //   this.PerformActionForIndivual(params,x);
                    const response = await this._actionService.PerformAction(params).toPromise();
                    //console.log("response", response)
                    if (response.OperationSucceed == false) {
                      x.ActionSucess = 2;
                      console.log("ErrorPerformAction", x.ActionSucess)
                    } else if (response.OperationSucceed == true) {
                      x.ActionSucess = 1;
                      console.log("PerformAction", x.ActionSucess)
                    }
                    return response;
                  }
                  //this._loading.finishedLoading();
                })
                Promise.all(framesystemsreq).then(() => {
                  //console.log("resChain", resChain);
                  this.ChainSystemAllMethods()
                })
              }
              else if (hasframeReplaceInventoryR) {
                console.log("hasframeReplaceInventoryR: ", hasframeReplaceInventoryR);
                let params = new GeneralActionViewModel();
                params.Comment = hasframeReplaceInventoryR.Components[0].ActionComment;//this.ActionComment;
                params.EquipmentId = Number(this.equipmentId);
                params.MakeId = hasframeReplaceInventoryR.Components[0].ActionBrandId;
                params.NewSMU = this.NewSMU;
                params.ReplaceComponentCompartId = hasframeReplaceInventoryR.Components[0].ActionComponentId;
                params.ActionDate = this.Actiondate;
                params.ActionEqUnitId = hasframeReplaceInventoryR.Id;
                params.ActionTypeId = +ActionType.ReplaceSystemFromInventory;
                params.BudgetLife = hasframeReplaceInventoryR.Components[0].ActionBudgetLife;
                params.BudgetDistance = hasframeReplaceInventoryR.Components[0].ActionBudgetDistance;
                params.MiscCost = hasframeReplaceInventoryR.Components.reduce((accum, item) => accum + item.ActionCost, 0)//hasframeReplaceInventoryR.Components[0].ActionCost;
                params.NewEqUnitId = hasframeReplaceInventoryR.ActionSelectionId;
                params.DOEatInstall = this.distanceForward + this.distanceReverse;
                //console.log("params", params);
                //from inventory  
                const PromiseframesystemRepaceInvemtoryR = this.equipmentSystems.map(async z => {
                  if (z.SystemType == "Frame" && z.Side == "Right") {
                    this.oldSystemIdFrame = z.Id;
                    //console.log("Frame replace", this.oldSystemIdFrame, this.newSystemIdRFrame)
                    const response = await this._actionService.SystemReplacement(params, this.newSystemIdRFrame, this.oldSystemIdFrame, 0).toPromise();
                    return response;
                  }
                })
                Promise.all(PromiseframesystemRepaceInvemtoryR).then(() => {
                  //console.log("ReshainsystemRepaceInvemtoryR", ReshainsystemRepaceInvemtoryR);
                  this.ChainSystemAllMethods()
                }).catch(err => {
                  console.log("PromisechainsystemRepaceInvemtoryL", err);
                })
              }
              else if (hasframeReplaceNewR) {
                console.log("hasframeReplaceNewR: ", hasframeReplaceNewR);
                this.frameSystem = [];
                let sys = new SystemSetup();
                sys.Id = 0;
                sys.BudgetLife = hasframeReplaceNewR.NewBudgetLife;
                sys.BudgetDistance = hasframeReplaceNewR.NewBudgetDistance;
                sys.FrameCost = hasframeReplaceNewR.NewFrameCost;
                sys.EquipmentId = 0;
                sys.HoursAtInstall = hasframeReplaceNewR.SysReplaceActionId == 4 ? 0 : hasframeReplaceNewR.Components[0].ActionCMU;
                sys.HistoricalDistance = hasframeReplaceNewR.SysReplaceActionId == 4 ? 0 : hasframeReplaceNewR.Components[0].ActionDOC;
                sys.TotalDistance = this.distanceForward + this.distanceReverse;
                sys.InstallOnEquipment = false;
                sys.InstallationDate = this.Actiondate;
                sys.InstallationDate_ = this.getFormatedDate(new Date(this.Actiondate));
                sys.JobsiteId = this.equipmentSystems[0].JobsiteId;
                sys.PMUAtInstall = 0;
                sys.PropelAtInstall = 0;
                sys.Serial = hasframeReplaceNewR.NewSerialNo;
                sys.SetupDate = this.Actiondate;
                sys.Side = this.selectedSide;
                sys.SmuAtInstall = 0;
                sys.Type = 2;
                sys.Family = this.fam;
                sys.Model = this.model;
                if (hasframeReplaceNewR.SysReplaceActionId == 4)
                  sys.Make = this.Makes.find(x => x.Id == this.equipmentSystems[0].MakeId);
                else
                  sys.Make = this.Makes.find(x => x.Id == hasframeReplaceNewR.Components[0].ActionBrandId);
                const framesystemsreqL = framesystemsR.map((c, index) => {
                  //console.log("Frame_Right_", c)
                  let pos = index + 1;
                  let comp = new ComponentSetup();
                  comp.Id = c.ActionSelectionId == 4 ? c.Id : 0;
                  comp.Brand = this.Makes.find(x => x.Id == c.ActionBrandId);
                  comp.BudgetLife = c.ActionBudgetLife;
                  comp.DistanceBudget = c.ActionBudgetDistance;
                  comp.BushTurnedPercent = 75;
                  comp.EquipmentSMU = 0;
                  comp.HoursAtInstall = c.ActionCMU;
                  comp.InstallCost = c.ActionCost;
                  comp.InstallDate = this.Actiondate;
                  comp.PMUAtInstall = 0;
                  comp.Pos = c.Position;
                  comp.PropelHrs = 0;
                  comp.ShoeGrouser = 1;
                  comp.SystemId = 0;
                  comp.listPosition = pos;
                  comp.Compart = this.compartList.find(i => i.Id == c.ActionComponentId);
                  comp.ActionWO = c.ActionWO;
                  comp.UsedWorn = c.ActionWorn;
                  comp.UsedCMU = c.ActionCMU;
                  comp.UsedDOC = c.ActionDOC;
                  comp.Measurement = c.ActionReading;
                  comp.ToolId = c.ActionToolId;
                  comp.DOC = c.ActionDOC;
                  comp.KeepComponent = c.ActionSelectionId == 4 ? true : false;
                  return comp;
                })
                Promise.all(framesystemsreqL).then(framesystemsres => {
                  sys.Components = framesystemsres;
                  let arry = [];
                  arry.push(sys);
                  this.frameSystem = arry;
                  //replace new chain 
                  //this.ValidateSerialNo(haschainReplaceNewL.ChainSysNewSrial, haschainReplaceNewL, this.chainSystem,1);
                  var comp1tot = hasframeReplaceNewR.Components.reduce((accum, item) => accum + item.ActionCost, 0)
                  this.submitFrameSystem(this.frameSystem, hasframeReplaceNewR.Components[0], 2, true, null, null, null, comp1tot, 0);
                }).catch(err => {
                  console.log("framesystemsreqR", err);
                })
              }
              else {
                this.ChainSystemAllMethods();
              }
            }
            else { //Both Side
              if (hasframeReplaceNewL == null && hasframeReplaceInventoryL == null) {

                const promiseframesystemL = framesystemsL.map(async x => {
                  //this._loading.startLoading();
                  if (x.ActionSelectionId != 1 && x.ActionSelectionId != 4) {
                    let params = new GeneralActionViewModel();
                    params.Comment = x.ActionComment;//this.ActionComment;
                    params.EquipmentId = Number(this.equipmentId);
                    params.MakeId = x.ActionBrandId;
                    params.NewSMU = this.NewSMU;
                    params.ReplaceComponentCompartId = x.ActionComponentId;
                    params.ActionDate = this.Actiondate;
                    params.ActionEqUnitId = x.Id;
                    params.ActionTypeId = x.SelectedActionTypeId;
                    params.BudgetLife = x.ActionBudgetLife;
                    params.BudgetDistance = x.ActionBudgetDistance;
                    params.MiscCost = x.ActionCost;
                    params.NewEqUnitId = (x.SelectedActionTypeId === 10602 || x.SelectedActionTypeId === 17 || x.SelectedActionTypeId === 10702) ? x.SwapComponentId : x.ActionSelectionId;
                    params.ReplaceComponentCompartName = x.ActionSelectionId == 2 ? x.ActionsReplaceOption.find(y => y.Id == x.ActionComponentId).Name : '';
                    params.ActionWO = x.ActionWO;
                    params.UsedWorn = x.ActionWorn;
                    params.UsedCMU = x.ActionCMU;
                    params.UsedDOC = x.ActionDOC;
                    params.Measurement = x.ActionReading;
                    params.ToolId = x.ActionToolId;
                    params.ShoeSize = x.ShoeSize
                    params.GrouserId = x.GrouserId
                    params.CleanerHolesId = x.CleanerHolesId == 0 ? null : x.CleanerHolesId
                    params.DOEatInstall = this.distanceForward + this.distanceReverse;
                    //console.log("params", params);
                    const response = await this._actionService.PerformAction(params).toPromise();
                    //console.log("response", response)
                    if (response.OperationSucceed == false) {
                      x.ActionSucess = 2;
                      console.log("ErrorPerformAction", x.ActionSucess)
                    } else if (response.OperationSucceed == true) {
                      x.ActionSucess = 1;
                      console.log("PerformAction", x.ActionSucess)
                    }
                    return response;
                  }
                  // this._loading.finishedLoading();
                });
                Promise.all(promiseframesystemL).then(() => {
                  //console.log("resFrameSysL", resFrameSysL);
                  if (hasframeReplaceNewR == null && hasframeReplaceInventoryR == null) {
                    const promiseframesystemR = framesystemsR.map(async x => {
                      //this._loading.startLoading();
                      if (x.ActionSelectionId != 1 && x.ActionSelectionId != 4) {
                        let params = new GeneralActionViewModel();
                        params.Comment = x.ActionComment;//this.ActionComment;
                        params.EquipmentId = Number(this.equipmentId);
                        params.MakeId = x.ActionBrandId;
                        params.NewSMU = this.NewSMU;
                        params.ReplaceComponentCompartId = x.ActionComponentId;
                        params.ActionDate = this.Actiondate;
                        params.ActionEqUnitId = x.Id;
                        params.ActionTypeId = x.SelectedActionTypeId;
                        params.BudgetLife = x.ActionBudgetLife;
                        params.BudgetDistance = x.ActionBudgetDistance;
                        params.MiscCost = x.ActionCost;
                        params.NewEqUnitId = (x.SelectedActionTypeId === 10602 || x.SelectedActionTypeId === 17 || x.SelectedActionTypeId === 10702) ? x.SwapComponentId : x.ActionSelectionId;
                        params.ReplaceComponentCompartName = x.ActionSelectionId == 2 ? x.ActionsReplaceOption.find(y => y.Id == x.ActionComponentId).Name : '';
                        params.ActionWO = x.ActionWO;
                        params.UsedWorn = x.ActionWorn;
                        params.UsedCMU = x.ActionCMU;
                        params.UsedDOC = x.ActionDOC;
                        params.Measurement = x.ActionReading;
                        params.ToolId = x.ActionToolId;
                        params.ShoeSize = x.ShoeSize
                        params.GrouserId = x.GrouserId
                        params.CleanerHolesId = x.CleanerHolesId == 0 ? null : x.CleanerHolesId
                        params.DOEatInstall = this.distanceForward + this.distanceReverse;
                        //console.log("params", params);
                        //this.PerformActionForIndivual(params,x);
                        const response = await this._actionService.PerformAction(params).toPromise();
                        //console.log("response", response)
                        if (response.OperationSucceed == false) {
                          x.ActionSucess = 2;
                          console.log("ErrorPerformAction", x.ActionSucess)
                        } else if (response.OperationSucceed == true) {
                          x.ActionSucess = 1;
                          console.log("PerformAction", x.ActionSucess)
                        }
                        return response;
                      }
                      //this._loading.finishedLoading();
                    });
                    Promise.all(promiseframesystemR).then(resFrameSysR => {
                      console.log("resFrameSysR", resFrameSysR);
                      this.ChainSystemAllMethods();
                    }).catch(err => {
                      console.log("promisechainsystem", err);
                    })
                  }
                  else if (hasframeReplaceInventoryR) {
                    let params = new GeneralActionViewModel();
                    params.Comment = hasframeReplaceInventoryR.Components[0].ActionComment;//this.ActionComment;
                    params.EquipmentId = Number(this.equipmentId);
                    params.MakeId = hasframeReplaceInventoryR.Components[0].ActionBrandId;
                    params.NewSMU = this.NewSMU;
                    params.ReplaceComponentCompartId = hasframeReplaceInventoryR.Components[0].ActionComponentId;
                    params.ActionDate = this.Actiondate;
                    params.ActionEqUnitId = hasframeReplaceInventoryR.Id;
                    params.ActionTypeId = +ActionType.ReplaceSystemFromInventory;
                    params.BudgetLife = hasframeReplaceInventoryR.Components[0].ActionBudgetLife;
                    params.BudgetDistance = hasframeReplaceInventoryR.Components[0].ActionBudgetDistance;
                    params.MiscCost = hasframeReplaceInventoryR.Components.reduce((accum, item) => accum + item.ActionCost, 0)//hasframeReplaceInventoryR.Components[0].ActionCost;
                    params.NewEqUnitId = hasframeReplaceInventoryR.ActionSelectionId;
                    params.DOEatInstall = this.distanceForward + this.distanceReverse;
                    //from inventory  
                    const PromiseframesystemRepaceInvemtoryR = this.equipmentSystems.map(async z => {
                      if (z.SystemType == "Frame" && z.Side == "Right") {
                        this.oldSystemIdFrame = z.Id;
                        //console.log("Chain replace", this.oldSystemIdFrame, this.newSystemIdRFrame)
                        const response = await this._actionService.SystemReplacement(params, this.newSystemIdRFrame, this.oldSystemIdFrame, 0).toPromise();
                        return response;
                      }
                    })
                    Promise.all(PromiseframesystemRepaceInvemtoryR).then(() => {
                      this.ChainSystemAllMethods();
                    }).catch(err => {
                      console.log("PromisechainsystemRepaceInvemtoryR", err);
                    })
                  }
                  else if (hasframeReplaceNewR) {
                    this.frameSystem = [];
                    let sys = new SystemSetup();
                    sys.Id = 0;
                    sys.BudgetLife = hasframeReplaceNewR.NewBudgetLife;
                    sys.BudgetDistance = hasframeReplaceNewR.NewBudgetDistance;
                    sys.FrameCost = hasframeReplaceNewR.NewFrameCost;
                    sys.EquipmentId = 0;
                    sys.HoursAtInstall = hasframeReplaceNewR.Components[0].ActionCMU;
                    sys.HistoricalDistance = hasframeReplaceNewR.Components[0].ActionDOC;
                    sys.TotalDistance = this.distanceForward + this.distanceReverse;
                    sys.InstallOnEquipment = false;
                    sys.InstallationDate = this.Actiondate;
                    sys.InstallationDate_ = this.getFormatedDate(new Date(this.Actiondate));
                    sys.JobsiteId = this.equipmentSystems[0].JobsiteId;
                    sys.PMUAtInstall = 0;
                    sys.PropelAtInstall = 0;
                    sys.Serial = hasframeReplaceNewR.NewSerialNo;
                    sys.SetupDate = this.Actiondate;
                    sys.Side = this.selectedSide;
                    sys.SmuAtInstall = 0;
                    sys.Type = 2;
                    sys.Family = this.fam;
                    sys.Model = this.model;
                    //sys.Make = this.Makes.find(x => x.Id == hasframeReplaceNewR.Components[0].ActionBrandId)
                    if (hasframeReplaceNewR.SysReplaceActionId == 4)
                      sys.Make = this.Makes.find(x => x.Id == this.equipmentSystems[0].MakeId);
                    else
                      sys.Make = this.Makes.find(x => x.Id == hasframeReplaceNewR.Components[0].ActionBrandId);
                    const framesystemsreqR = framesystemsR.map((c, index) => {
                      let pos = index + 1;
                      let comp = new ComponentSetup();
                      comp.Id = c.ActionSelectionId == 4 ? c.Id : 0;
                      comp.Brand = this.Makes.find(x => x.Id == c.ActionBrandId);
                      comp.BudgetLife = c.ActionBudgetLife;
                      comp.DistanceBudget = c.ActionBudgetDistance;
                      comp.BushTurnedPercent = 75;
                      comp.EquipmentSMU = 0;
                      comp.HoursAtInstall = c.ActionCMU;
                      comp.InstallCost = c.ActionCost;
                      comp.InstallDate = this.Actiondate;
                      comp.PMUAtInstall = 0;
                      comp.Pos = c.Position;
                      comp.PropelHrs = 0;
                      comp.ShoeGrouser = 1;
                      comp.SystemId = 0;
                      comp.listPosition = pos;
                      comp.Compart = this.compartList.find(i => i.Id == c.ActionComponentId);
                      comp.ActionWO = c.ActionWO;
                      comp.UsedWorn = c.ActionWorn;
                      comp.UsedCMU = c.ActionCMU;
                      comp.UsedDOC = c.ActionDOC;
                      comp.Measurement = c.ActionReading;
                      comp.ToolId = c.ActionToolId;
                      comp.DOC = c.ActionDOC;
                      comp.KeepComponent = c.ActionSelectionId == 4 ? true : false;
                      return comp;
                    })
                    Promise.all(framesystemsreqR).then(framesystemsres => {
                      sys.Components = framesystemsres;
                      let arry = [];
                      arry.push(sys);
                      this.frameSystem = arry;
                      console.log("hasframeReplaceNewR arry: ", arry, this.frameSystem);
                      //replace new chain 
                      // this.ValidateSerialNo(haschainReplaceNewR.ChainSysNewSrial, haschainReplaceNewR, this.chainSystem,2);
                      var comp1tot = hasframeReplaceNewR.Components.reduce((accum, item) => accum + item.ActionCost, 0)
                      this.submitFrameSystem(this.frameSystem, hasframeReplaceNewR.Components[0], 2, true, null, null, null, comp1tot, 0);

                    }).catch(err => {
                      console.log("chainsystemsreqR", err);

                    })

                  } else {
                    this.ChainSystemAllMethods();
                  }

                }).catch(err => {
                  console.log("promisechainsystemL", err);

                })


              }
              else if (hasframeReplaceNewR == null && hasframeReplaceInventoryR == null) {

                const promiseframesystemR = framesystemsR.map(async x => {
                  //this._loading.startLoading();
                  if (x.ActionSelectionId != 1 && x.ActionSelectionId != 4) {

                    let params = new GeneralActionViewModel();
                    params.Comment = x.ActionComment;//this.ActionComment;
                    params.EquipmentId = Number(this.equipmentId);
                    params.MakeId = x.ActionBrandId;
                    params.NewSMU = this.NewSMU;
                    params.ReplaceComponentCompartId = x.ActionComponentId;
                    params.ActionDate = this.Actiondate;
                    params.ActionEqUnitId = x.Id;
                    params.ActionTypeId = x.SelectedActionTypeId;
                    params.BudgetLife = x.ActionBudgetLife;
                    params.BudgetDistance = x.ActionBudgetDistance;
                    params.MiscCost = x.ActionCost;
                    params.NewEqUnitId = (x.SelectedActionTypeId === 10602 || x.SelectedActionTypeId === 17 || x.SelectedActionTypeId === 10702) ? x.SwapComponentId : x.ActionSelectionId;
                    params.ReplaceComponentCompartName = x.ActionSelectionId == 2 ? x.ActionsReplaceOption.find(y => y.Id == x.ActionComponentId).Name : '';
                    params.ActionWO = x.ActionWO;
                    params.UsedWorn = x.ActionWorn;
                    params.UsedCMU = x.ActionCMU;
                    params.UsedDOC = x.ActionDOC;
                    params.Measurement = x.ActionReading;
                    params.ToolId = x.ActionToolId;
                    params.ShoeSize = x.ShoeSize
                    params.GrouserId = x.GrouserId
                    params.CleanerHolesId = x.CleanerHolesId == 0 ? null : x.CleanerHolesId
                    params.DOEatInstall = this.distanceForward + this.distanceReverse;
                    //this.PerformActionForIndivual(params,x);
                    const response = await this._actionService.PerformAction(params).toPromise();

                    if (response.OperationSucceed == false) {
                      x.ActionSucess = 2;

                    } else if (response.OperationSucceed == true) {
                      x.ActionSucess = 1;

                    }
                    return response;
                  }
                  //this._loading.finishedLoading();

                });

                Promise.all(promiseframesystemR).then(() => {
                  //this.PerformInspectionForAction();
                  if (hasframeReplaceInventoryL) {
                    let params = new GeneralActionViewModel();
                    params.Comment = hasframeReplaceInventoryL.Components[0].ActionComment;//this.ActionComment;
                    params.EquipmentId = Number(this.equipmentId);
                    params.MakeId = hasframeReplaceInventoryL.Components[0].ActionBrandId;
                    params.NewSMU = this.NewSMU;
                    params.ReplaceComponentCompartId = hasframeReplaceInventoryL.Components[0].ActionComponentId;
                    params.ActionDate = this.Actiondate;
                    params.ActionEqUnitId = hasframeReplaceInventoryL.Id;
                    params.ActionTypeId = +ActionType.ReplaceSystemFromInventory;
                    params.BudgetLife = hasframeReplaceInventoryL.Components[0].ActionBudgetLife;
                    params.BudgetDistance = hasframeReplaceInventoryL.Components[0].ActionBudgetDistance;
                    params.MiscCost = hasframeReplaceInventoryL.Components.reduce((accum, item) => accum + item.ActionCost, 0)//hasframeReplaceInventoryL.Components[0].ActionCost;
                    params.NewEqUnitId = hasframeReplaceInventoryL.ActionSelectionId;
                    params.DOEatInstall = this.distanceForward + this.distanceReverse;
                    console.log("params", params);
                    //from inventory  
                    const PromiseframesystemRepaceInvemtoryL = this.equipmentSystems.map(async z => {
                      if (z.SystemType == "Frame" && z.Side == "Left") {
                        this.oldSystemIdFrame = z.Id;
                        //console.log("Frame replace", this.oldSystemIdFrame, this.newSystemIdLFrame)
                        const response = await this._actionService.SystemReplacement(params, this.newSystemIdLFrame, this.oldSystemIdFrame, 0).toPromise();
                        return response;
                      }
                    })
                    Promise.all(PromiseframesystemRepaceInvemtoryL).then(() => {
                      //console.log("ResframesystemRepaceInvemtoryL", ResframesystemRepaceInvemtoryL)
                      this.ChainSystemAllMethods();
                    }).catch(err => {
                      console.log("PromisechainsystemRepaceInvemtoryL", err);
                    })
                  }
                  else if (hasframeReplaceNewL) {
                    this.chainSystem = [];
                    let sys = new SystemSetup();
                    sys.Id = 0;
                    sys.BudgetLife = hasframeReplaceNewL.NewBudgetLife;
                    sys.BudgetDistance = hasframeReplaceNewL.NewBudgetDistance;
                    sys.FrameCost = hasframeReplaceNewL.NewFrameCost;
                    sys.EquipmentId = 0;
                    sys.HoursAtInstall = hasframeReplaceNewL.Components[0].ActionCMU;
                    sys.HistoricalDistance = hasframeReplaceNewL.Components[0].ActionDOC;
                    sys.TotalDistance = this.distanceForward + this.distanceReverse;
                    sys.InstallOnEquipment = false;
                    sys.InstallationDate = this.Actiondate;
                    sys.InstallationDate_ = this.getFormatedDate(new Date(this.Actiondate));
                    sys.JobsiteId = this.equipmentSystems[0].JobsiteId;
                    sys.PMUAtInstall = 0;
                    sys.PropelAtInstall = 0;
                    sys.Serial = hasframeReplaceNewL.NewSerialNo;
                    sys.SetupDate = this.Actiondate;
                    sys.Side = this.selectedSide;
                    sys.SmuAtInstall = 0;
                    sys.Type = 2;
                    sys.Family = this.fam;
                    sys.Model = this.model;
                    //sys.Make = this.Makes.find(x => x.Id == hasframeReplaceNewL.Components[0].ActionBrandId)
                    if (hasframeReplaceNewL.SysReplaceActionId == 4)
                      sys.Make = this.Makes.find(x => x.Id == this.equipmentSystems[0].MakeId);
                    else
                      sys.Make = this.Makes.find(x => x.Id == hasframeReplaceNewL.Components[0].ActionBrandId);
                    const framesystemsreqL = framesystemsL.map((c, index) => {
                      //console.log("chainData", c)
                      let pos = index + 1;
                      let comp = new ComponentSetup();
                      comp.Id = c.ActionSelectionId == 4 ? c.Id : 0;
                      comp.Brand = this.Makes.find(x => x.Id == c.ActionBrandId);
                      comp.BudgetLife = c.ActionBudgetLife;
                      comp.DistanceBudget = c.ActionBudgetDistance;
                      comp.BushTurnedPercent = 75;
                      comp.EquipmentSMU = 0;
                      comp.HoursAtInstall = c.ActionCMU;
                      comp.InstallCost = c.ActionCost;
                      comp.InstallDate = this.Actiondate;
                      comp.PMUAtInstall = 0;
                      comp.Pos = c.Position;
                      comp.PropelHrs = 0;
                      comp.ShoeGrouser = 1;
                      comp.SystemId = 0;
                      comp.listPosition = pos;
                      comp.Compart = this.compartList.find(i => i.Id == c.ActionComponentId);
                      comp.ActionWO = c.ActionWO;
                      comp.UsedWorn = c.ActionWorn;
                      comp.UsedCMU = c.ActionCMU;
                      comp.UsedDOC = c.ActionDOC;
                      comp.Measurement = c.ActionReading;
                      comp.ToolId = c.ActionToolId;
                      comp.DOC = c.ActionDOC;
                      comp.KeepComponent = c.ActionSelectionId == 4 ? true : false;
                      return comp;
                    })

                    Promise.all(framesystemsreqL).then(framesystemsres => {
                      sys.Components = framesystemsres;
                      let arry = [];
                      arry.push(sys);
                      this.frameSystem = arry;
                      //replace new chain 


                      //this.ValidateSerialNo(haschainReplaceNewL.ChainSysNewSrial, haschainReplaceNewL, this.chainSystem,1);
                      var comp1tot = hasframeReplaceNewL.Components.reduce((accum, item) => accum + item.ActionCost, 0)
                      this.submitFrameSystem(this.frameSystem, hasframeReplaceNewL.Components[0], 1, true, null, null, null, comp1tot, 0);

                    }).catch(err => {
                      console.log("chainsystemsreqL", err);

                    })

                  }
                  else {
                    this.ChainSystemAllMethods();
                  }



                }).catch(err => {
                  console.log("promisechainsystem", err);

                })


              }
              else if (hasframeReplaceInventoryL) {
                console.log("hasframeReplaceInventoryL: ", hasframeReplaceInventoryL);
                let params = new GeneralActionViewModel();
                params.Comment = hasframeReplaceInventoryL.Components[0].ActionComment;//this.ActionComment;
                params.EquipmentId = Number(this.equipmentId);
                params.MakeId = hasframeReplaceInventoryL.Components[0].ActionBrandId;
                params.NewSMU = this.NewSMU;
                params.ReplaceComponentCompartId = hasframeReplaceInventoryL.Components[0].ActionComponentId;
                params.ActionDate = this.Actiondate;
                params.ActionEqUnitId = hasframeReplaceInventoryL.Id;
                params.ActionTypeId = +ActionType.ReplaceSystemFromInventory;
                params.BudgetLife = hasframeReplaceInventoryL.Components[0].ActionBudgetLife;
                params.BudgetDistance = hasframeReplaceInventoryL.Components[0].ActionBudgetDistance;
                params.MiscCost = hasframeReplaceInventoryL.Components.reduce((accum, item) => accum + item.ActionCost, 0)//hasframeReplaceInventoryL.Components[0].ActionCost;
                params.NewEqUnitId = hasframeReplaceInventoryL.ActionSelectionId;
                params.DOEatInstall = this.distanceForward + this.distanceReverse;
                //console.log("params", params);
                //from inventory  
                const PromiseframesystemRepaceInvemtoryL = this.equipmentSystems.map(async z => {
                  if (z.SystemType == "Frame" && z.Side == "Left") {

                    this.oldSystemIdFrame = z.Id;

                    console.log("Frame replace", this.oldSystemIdFrame, this.newSystemIdLFrame)

                    const response = await this._actionService.SystemReplacement(params, this.newSystemIdLFrame, this.oldSystemIdFrame, 0).toPromise();

                    return response;
                  }
                })

                Promise.all(PromiseframesystemRepaceInvemtoryL).then(ResframesystemRepaceInvemtoryL => {

                  console.log("ResframesystemRepaceInvemtoryL", ResframesystemRepaceInvemtoryL)
                  //this.PerformInspectionForAction();
                  if (hasframeReplaceInventoryR) {
                    let params = new GeneralActionViewModel();
                    params.Comment = hasframeReplaceInventoryR.Components[0].ActionComment;//this.ActionComment;
                    params.EquipmentId = Number(this.equipmentId);
                    params.MakeId = hasframeReplaceInventoryR.Components[0].ActionBrandId;
                    params.NewSMU = this.NewSMU;
                    params.ReplaceComponentCompartId = hasframeReplaceInventoryR.Components[0].ActionComponentId;
                    params.ActionDate = this.Actiondate;
                    params.ActionEqUnitId = hasframeReplaceInventoryR.Id;
                    params.ActionTypeId = +ActionType.ReplaceSystemFromInventory;
                    params.BudgetLife = hasframeReplaceInventoryR.Components[0].ActionBudgetLife;
                    params.BudgetDistance = hasframeReplaceInventoryR.Components[0].ActionBudgetDistance;
                    params.MiscCost = hasframeReplaceInventoryR.Components.reduce((accum, item) => accum + item.ActionCost, 0)//hasframeReplaceInventoryR.Components[0].ActionCost;
                    params.NewEqUnitId = hasframeReplaceInventoryR.ActionSelectionId;
                    params.DOEatInstall = this.distanceForward + this.distanceReverse;
                    console.log("params", params);
                    //from inventory  
                    const PromiseframesystemRepaceInvemtoryR = this.equipmentSystems.map(async z => {
                      if (z.SystemType == "Frame" && z.Side == "Right") {

                        this.oldSystemIdFrame = z.Id;

                        console.log("Frame replace", this.oldSystemIdFrame, this.newSystemIdRFrame)

                        const response = await this._actionService.SystemReplacement(params, this.newSystemIdRFrame, this.oldSystemIdFrame, 0).toPromise();

                        return response;
                      }
                    })

                    Promise.all(PromiseframesystemRepaceInvemtoryR).then(ResframesystemRepaceInvemtoryR => {

                      console.log("ResframesystemRepaceInvemtoryR", ResframesystemRepaceInvemtoryR)
                      this.ChainSystemAllMethods();
                    }).catch(err => {
                      console.log("PromisechainsystemRepaceInvemtoryR", err);

                    })
                  }
                  else if (hasframeReplaceNewR) {
                    this.frameSystem = [];
                    let sys = new SystemSetup();
                    sys.Id = 0;
                    sys.BudgetLife = hasframeReplaceNewR.NewBudgetLife;
                    sys.BudgetDistance = hasframeReplaceNewR.NewBudgetDistance;
                    sys.FrameCost = hasframeReplaceNewR.NewFrameCost;
                    sys.EquipmentId = 0;
                    sys.HoursAtInstall = hasframeReplaceNewR.Components[0].ActionCMU;
                    sys.HistoricalDistance = hasframeReplaceNewR.Components[0].ActionDOC;
                    sys.TotalDistance = this.distanceForward + this.distanceReverse;
                    sys.InstallOnEquipment = false;
                    sys.InstallationDate = this.Actiondate;
                    sys.InstallationDate_ = this.getFormatedDate(new Date(this.Actiondate));
                    sys.JobsiteId = this.equipmentSystems[0].JobsiteId;
                    sys.PMUAtInstall = 0;
                    sys.PropelAtInstall = 0;
                    sys.Serial = hasframeReplaceNewR.NewSerialNo;
                    sys.SetupDate = this.Actiondate;
                    sys.Side = this.selectedSide;
                    sys.SmuAtInstall = 0;
                    sys.Type = 2;
                    sys.Family = this.fam;
                    sys.Model = this.model;
                    sys.Make = this.Makes.find(x => x.Id == hasframeReplaceNewR.Components[0].ActionBrandId)
                    const framesystemsreqR = framesystemsR.map((c, index) => {
                      console.log("frameData", c)
                      let pos = index + 1;
                      let comp = new ComponentSetup();
                      comp.Id = c.ActionSelectionId == 4 ? c.Id : 0;
                      comp.Brand = this.Makes.find(x => x.Id == c.ActionBrandId);
                      comp.BudgetLife = c.ActionBudgetLife;
                      comp.DistanceBudget = c.ActionBudgetDistance;
                      comp.BushTurnedPercent = 75;
                      comp.EquipmentSMU = 0;
                      comp.HoursAtInstall = c.ActionCMU;
                      comp.InstallCost = c.ActionCost;
                      comp.InstallDate = this.Actiondate;
                      comp.PMUAtInstall = 0;
                      comp.Pos = c.Position;
                      comp.PropelHrs = 0;
                      comp.ShoeGrouser = 1;
                      comp.SystemId = 0;
                      comp.listPosition = pos;
                      comp.Compart = this.compartList.find(i => i.Id == c.ActionComponentId);
                      comp.ActionWO = c.ActionWO;
                      comp.UsedWorn = c.ActionWorn;
                      comp.UsedCMU = c.ActionCMU;
                      comp.UsedDOC = c.ActionDOC;
                      comp.Measurement = c.ActionReading;
                      comp.ToolId = c.ActionToolId;
                      comp.DOC = c.ActionDOC;
                      comp.KeepComponent = c.ActionSelectionId == 4 ? true : false;
                      return comp;
                    })
                    Promise.all(framesystemsreqR).then(framesystemsres => {
                      sys.Components = framesystemsres;
                      let arry = [];
                      arry.push(sys);
                      this.frameSystem = arry;
                      //replace new chain 
                      // this.ValidateSerialNo(haschainReplaceNewR.ChainSysNewSrial, haschainReplaceNewR, this.chainSystem,2);
                      var comp1tot = hasframeReplaceNewR.Components.reduce((accum, item) => accum + item.ActionCost, 0)
                      this.submitFrameSystem(this.frameSystem, hasframeReplaceNewR.Components[0], 2, true, null, null, null, comp1tot, 0);

                    }).catch(err => {
                      console.log("chainsystemsreqR", err);

                    })

                  }
                  else {
                    this.ChainSystemAllMethods();
                  }

                }).catch(err => {
                  console.log("PromisechainsystemRepaceInvemtoryL", err);

                })

              }
              else if (hasframeReplaceNewL && hasframeReplaceNewR == null) {


                this.frameSystem = [];
                let sys = new SystemSetup();
                sys.Id = 0;
                sys.BudgetLife = hasframeReplaceNewL.NewBudgetLife;
                sys.BudgetDistance = hasframeReplaceNewL.NewBudgetDistance;
                sys.FrameCost = hasframeReplaceNewL.NewFrameCost;
                sys.EquipmentId = 0;
                sys.HoursAtInstall = hasframeReplaceNewL.SysReplaceActionId == 4 ? 0 : hasframeReplaceNewL.Components[0].ActionCMU;
                sys.HistoricalDistance = hasframeReplaceNewL.SysReplaceActionId == 4 ? 0 : hasframeReplaceNewL.Components[0].ActionDOC;
                sys.TotalDistance = this.distanceForward + this.distanceReverse;
                sys.InstallOnEquipment = false;
                sys.InstallationDate = this.Actiondate;
                sys.InstallationDate_ = this.getFormatedDate(new Date(this.Actiondate));
                sys.JobsiteId = this.equipmentSystems[0].JobsiteId;
                sys.PMUAtInstall = 0;
                sys.PropelAtInstall = 0;
                sys.Serial = hasframeReplaceNewL.NewSerialNo;
                sys.SetupDate = this.Actiondate;
                sys.Side = this.selectedSide;
                sys.SmuAtInstall = 0;
                sys.Type = 2;
                sys.Family = this.fam;
                sys.Model = this.model;
                if (hasframeReplaceNewL.SysReplaceActionId == 4)
                  sys.Make = this.Makes.find(x => x.Id == this.equipmentSystems[0].MakeId);
                else
                  sys.Make = this.Makes.find(x => x.Id == hasframeReplaceNewL.Components[0].ActionBrandId);

                const framesystemsreqL = framesystemsL.map((c, index) => {
                  console.log("frameData", c)
                  let pos = index + 1;
                  let comp = new ComponentSetup();
                  //if (c.ActionSelectionId == 4) {
                  //  comp.Id = c.Id;
                  //}
                  comp.Id = c.ActionSelectionId == 4 ? c.Id : 0;
                  comp.Brand = this.Makes.find(x => x.Id == c.ActionBrandId);
                  comp.BudgetLife = c.ActionBudgetLife;
                  comp.DistanceBudget = c.ActionBudgetDistance;
                  comp.BushTurnedPercent = 75;
                  comp.EquipmentSMU = 0;
                  comp.HoursAtInstall = c.ActionCMU;
                  comp.InstallCost = c.ActionCost;
                  comp.InstallDate = this.Actiondate;
                  comp.PMUAtInstall = 0;
                  comp.Pos = c.Position;
                  comp.PropelHrs = 0;
                  comp.ShoeGrouser = 1;
                  comp.SystemId = 0;
                  comp.listPosition = pos;
                  comp.Compart = this.compartList.find(i => i.Id == c.ActionComponentId);
                  comp.ActionWO = c.ActionWO;
                  comp.UsedWorn = c.ActionWorn;
                  comp.UsedCMU = c.ActionCMU;
                  comp.UsedDOC = c.ActionDOC;
                  comp.Measurement = c.ActionReading;
                  comp.ToolId = c.ActionToolId;
                  comp.DOC = c.ActionDOC;
                  comp.KeepComponent = c.ActionSelectionId == 4 ? true : false;
                  return comp;
                })

                Promise.all(framesystemsreqL).then(framesystemsres => {
                  sys.Components = framesystemsres;
                  let arry = [];
                  arry.push(sys);
                  this.frameSystem = arry;
                  console.log("hasframeReplaceNewL arry: ", arry, this.frameSystem);
                  //replace new chain 
                  // this.ValidateSerialNo(haschainReplaceNewL.ChainSysNewSrial, haschainReplaceNewL, this.chainSystem,1);

                  if (hasframeReplaceInventoryR == null) {
                    var comp1tot = hasframeReplaceNewL.Components.reduce((accum, item) => accum + item.ActionCost, 0)
                    this.submitFrameSystem(this.frameSystem, hasframeReplaceNewL.Components[0], 1, true, null, null, null, comp1tot, 0);
                  }
                  else if (hasframeReplaceInventoryR) {
                    let params = new GeneralActionViewModel();
                    params.Comment = hasframeReplaceInventoryR.Components[0].ActionComment;//this.ActionComment;
                    params.EquipmentId = Number(this.equipmentId);
                    params.MakeId = hasframeReplaceInventoryR.Components[0].ActionBrandId;
                    params.NewSMU = this.NewSMU;
                    params.ReplaceComponentCompartId = hasframeReplaceInventoryR.Components[0].ActionComponentId;
                    params.ActionDate = this.Actiondate;
                    params.ActionEqUnitId = hasframeReplaceInventoryR.Id;
                    params.ActionTypeId = +ActionType.ReplaceSystemFromInventory;
                    params.BudgetLife = hasframeReplaceInventoryR.Components[0].ActionBudgetLife;
                    params.BudgetDistance = hasframeReplaceInventoryR.Components[0].ActionBudgetDistance;
                    params.MiscCost = hasframeReplaceInventoryR.Components.reduce((accum, item) => accum + item.ActionCost, 0)//hasframeReplaceInventoryR.Components[0].ActionCost;
                    params.NewEqUnitId = hasframeReplaceInventoryR.ActionSelectionId;
                    params.DOEatInstall = this.distanceForward + this.distanceReverse;
                    console.log("params", params);
                    //from inventory  
                    const PromiseframesystemRepaceInvemtoryR = this.equipmentSystems.map(async z => {
                      if (z.SystemType == "Frame" && z.Side == "Right") {

                        this.oldSystemIdFrame = z.Id;

                        console.log("Frame replace", this.oldSystemIdFrame, this.newSystemIdRFrame)

                        const response = await this._actionService.SystemReplacement(params, this.newSystemIdRFrame, this.oldSystemIdFrame, 0).toPromise();

                        return response;
                      }
                    })

                    Promise.all(PromiseframesystemRepaceInvemtoryR).then(ResframesystemRepaceInvemtoryR => {

                      console.log("ResframesystemRepaceInvemtoryR", ResframesystemRepaceInvemtoryR)
                      //this.PerformInspectionForAction();
                      var comp1tot = hasframeReplaceNewL.Components.reduce((accum, item) => accum + item.ActionCost, 0)
                      this.submitFrameSystem(this.frameSystem, hasframeReplaceNewL.Components[0], 1, true, null, null, null, comp1tot, 0);
                    }).catch(err => {
                      console.log("PromisechainsystemRepaceInvemtoryR", err);

                    })
                  }



                }).catch(err => {
                  console.log("framesystemsreqL", err);

                })

              }
              else if (hasframeReplaceNewR && hasframeReplaceNewL == null) {
                this.frameSystem = [];
                let sys = new SystemSetup();
                sys.Id = 0;
                sys.BudgetLife = hasframeReplaceNewR.NewBudgetLife;
                sys.BudgetDistance = hasframeReplaceNewR.NewBudgetDistance;
                sys.FrameCost = hasframeReplaceNewR.NewFrameCost;
                sys.EquipmentId = 0;
                sys.HoursAtInstall = hasframeReplaceNewR.SysReplaceActionId == 4 ? 0 : hasframeReplaceNewR.Components[0].ActionCMU;
                sys.HistoricalDistance = hasframeReplaceNewR.SysReplaceActionId == 4 ? 0 : hasframeReplaceNewR.Components[0].ActionDOC;
                sys.TotalDistance = this.distanceForward + this.distanceReverse;
                sys.InstallOnEquipment = false;
                sys.InstallationDate = this.Actiondate;
                sys.InstallationDate_ = this.getFormatedDate(new Date(this.Actiondate));
                sys.JobsiteId = this.equipmentSystems[0].JobsiteId;
                sys.PMUAtInstall = 0;
                sys.PropelAtInstall = 0;
                sys.Serial = hasframeReplaceNewR.NewSerialNo;
                sys.SetupDate = this.Actiondate;
                sys.Side = this.selectedSide;
                sys.SmuAtInstall = 0;
                sys.Type = 2;
                sys.Family = this.fam;
                sys.Model = this.model;
                if (hasframeReplaceNewR.SysReplaceActionId == 4)
                  sys.Make = this.Makes.find(x => x.Id == this.equipmentSystems[0].MakeId);
                else
                  sys.Make = this.Makes.find(x => x.Id == hasframeReplaceNewR.Components[0].ActionBrandId);
                const framesystemsreqR = framesystemsR.map((c, index) => {
                  console.log("frrameData", c)
                  let pos = index + 1;
                  let comp = new ComponentSetup();
                  comp.Id = c.ActionSelectionId == 4 ? c.Id : 0;
                  comp.Brand = this.Makes.find(x => x.Id == c.ActionBrandId);
                  comp.BudgetLife = c.ActionBudgetLife;
                  comp.DistanceBudget = c.ActionBudgetDistance;
                  comp.BushTurnedPercent = 75;
                  comp.EquipmentSMU = 0;
                  comp.HoursAtInstall = c.ActionCMU;
                  comp.InstallCost = c.ActionCost;
                  comp.InstallDate = this.Actiondate;
                  comp.PMUAtInstall = 0;
                  comp.Pos = c.Position;
                  comp.PropelHrs = 0;
                  comp.ShoeGrouser = 1;
                  comp.SystemId = 0;
                  comp.listPosition = pos;
                  comp.Compart = this.compartList.find(i => i.Id == c.ActionComponentId);
                  comp.ActionWO = c.ActionWO;
                  comp.UsedWorn = c.ActionWorn;
                  comp.UsedCMU = c.ActionCMU;
                  comp.UsedDOC = c.ActionDOC;
                  comp.Measurement = c.ActionReading;
                  comp.ToolId = c.ActionToolId;
                  comp.DOC = c.ActionDOC;
                  comp.KeepComponent = c.ActionSelectionId == 4 ? true : false;
                  return comp;
                })
                Promise.all(framesystemsreqR).then(framesystemsres => {
                  sys.Components = framesystemsres;
                  let arry = [];
                  arry.push(sys);
                  this.frameSystem = arry;
                  //replace new chain 
                  //this.ValidateSerialNo(haschainReplaceNewR.ChainSysNewSrial, haschainReplaceNewR, this.chainSystem,2);

                  var comp1tot = hasframeReplaceNewR.Components.reduce((accum, item) => accum + item.ActionCost, 0)
                  this.submitFrameSystem(this.frameSystem, hasframeReplaceNewR.Components[0], 2, true, null, null, null, comp1tot, 0);

                }).catch(err => {
                  console.log("framesystemsreqR", err);

                })

              }
              else if (hasframeReplaceNewR && hasframeReplaceNewL) {
                //console.log("Data___GG_LEFT", hasframeReplaceNewL.NewSerialNo)
                //console.log("Data___GG_RIGHT", hasframeReplaceNewR.NewSerialNo)
                this.frameSystemR = [];
                let sysR = new SystemSetup();
                sysR.Id = 0;
                sysR.BudgetLife = hasframeReplaceNewR.NewBudgetLife;
                sysR.BudgetDistance = hasframeReplaceNewR.NewBudgetDistance;
                sysR.FrameCost = hasframeReplaceNewR.NewFrameCost;
                sysR.EquipmentId = 0;
                sysR.HoursAtInstall = hasframeReplaceNewR.SysReplaceActionId == 4 ? 0 : hasframeReplaceNewR.Components[0].ActionCMU;
                sysR.HistoricalDistance = hasframeReplaceNewR.SysReplaceActionId == 4 ? 0 : hasframeReplaceNewR.Components[0].ActionDOC;
                sysR.TotalDistance = this.distanceForward + this.distanceReverse;
                sysR.InstallOnEquipment = false;
                sysR.InstallationDate = this.Actiondate;
                sysR.InstallationDate_ = this.getFormatedDate(new Date(this.Actiondate));
                sysR.JobsiteId = this.equipmentSystems[0].JobsiteId;
                sysR.PMUAtInstall = 0;
                sysR.PropelAtInstall = 0;
                sysR.Serial = hasframeReplaceNewR.NewSerialNo;
                sysR.SetupDate = this.Actiondate;
                sysR.Side = this.selectedSide;
                sysR.SmuAtInstall = 0;
                sysR.Type = 2;
                sysR.Family = this.fam;
                sysR.Model = this.model;
                if (hasframeReplaceNewR.SysReplaceActionId == 4)
                  sysR.Make = this.Makes.find(x => x.Id == this.equipmentSystems[0].MakeId);
                else
                  sysR.Make = this.Makes.find(x => x.Id == hasframeReplaceNewR.Components[0].ActionBrandId);



                this.frameSystem = [];
                let sys = new SystemSetup();
                sys.Id = 0;
                sys.BudgetLife = hasframeReplaceNewL.NewBudgetLife;
                sys.BudgetDistance = hasframeReplaceNewL.NewBudgetDistance;
                sys.FrameCost = hasframeReplaceNewL.NewFrameCost;
                sys.EquipmentId = 0;
                sys.HoursAtInstall = hasframeReplaceNewL.SysReplaceActionId == 4 ? 0 : hasframeReplaceNewL.Components[0].ActionCMU;
                sys.HistoricalDistance = hasframeReplaceNewL.SysReplaceActionId == 4 ? 0 : hasframeReplaceNewL.Components[0].ActionDOC;
                sys.TotalDistance = this.distanceForward + this.distanceReverse;
                sys.InstallOnEquipment = false;
                sys.InstallationDate = this.Actiondate;
                sys.InstallationDate_ = this.getFormatedDate(new Date(this.Actiondate));
                sys.JobsiteId = this.equipmentSystems[0].JobsiteId;
                sys.PMUAtInstall = 0;
                sys.PropelAtInstall = 0;
                sys.Serial = hasframeReplaceNewL.NewSerialNo;
                sys.SetupDate = this.Actiondate;
                sys.Side = this.selectedSide;
                sys.SmuAtInstall = 0;
                sys.Type = 2;
                sys.Family = this.fam;
                sys.Model = this.model;
                if (hasframeReplaceNewL.SysReplaceActionId == 4)
                  sys.Make = this.Makes.find(x => x.Id == this.equipmentSystems[0].MakeId);
                else
                  sys.Make = this.Makes.find(x => x.Id == hasframeReplaceNewL.Components[0].ActionBrandId);

                const framesystemsreqR = framesystemsR.map((c, index) => {

                  let pos = index + 1;
                  let comp = new ComponentSetup();
                  comp.Id = c.ActionSelectionId == 4 ? c.Id : 0;
                  comp.Brand = this.Makes.find(x => x.Id == c.ActionBrandId);
                  comp.BudgetLife = c.ActionBudgetLife;
                  comp.DistanceBudget = c.ActionBudgetDistance;
                  comp.BushTurnedPercent = 75;
                  comp.EquipmentSMU = 0;
                  comp.HoursAtInstall = c.ActionCMU;
                  comp.InstallCost = c.ActionCost;
                  comp.InstallDate = this.Actiondate;
                  comp.PMUAtInstall = 0;
                  comp.Pos = c.Position;
                  comp.PropelHrs = 0;
                  comp.ShoeGrouser = 1;
                  comp.SystemId = 0;
                  comp.listPosition = pos;
                  comp.Compart = this.compartList.find(i => i.Id == c.ActionComponentId);
                  comp.ActionWO = c.ActionWO;
                  comp.UsedWorn = c.ActionWorn;
                  comp.UsedCMU = c.ActionCMU;
                  comp.UsedDOC = c.ActionDOC;
                  comp.Measurement = c.ActionReading;
                  comp.ToolId = c.ActionToolId;
                  comp.DOC = c.ActionDOC;
                  comp.KeepComponent = c.ActionSelectionId == 4 ? true : false;
                  return comp;
                })
                Promise.all(framesystemsreqR).then(framesystemsres => {
                  sysR.Components = framesystemsres;
                  let arry = [];
                  arry.push(sysR);
                  this.frameSystem = arry;
                  //replace new chain 
                  //this.ValidateSerialNo(haschainReplaceNewR.ChainSysNewSrial, haschainReplaceNewR, this.chainSystem,2);
                  //console.log("system___", this.frameSystem);
                  var comp1tot = hasframeReplaceNewR.Components.reduce((accum, item) => accum + item.ActionCost, 0)
                  var comp2tot = hasframeReplaceNewL.Components.reduce((accum, item) => accum + item.ActionCost, 0)
                  this.submitFrameSystem(this.frameSystem, hasframeReplaceNewR.Components[0], 2, false, framesystemsL, hasframeReplaceNewL.Components[0], sys, comp1tot, comp2tot);
                }).catch(err => {
                  console.log("chainsystemsreqR", err);
                })
              }
              else if (hasframeReplaceInventoryR) {
                console.log("hasframeReplaceInventoryR: ", hasframeReplaceInventoryR);
                let params = new GeneralActionViewModel();
                params.Comment = hasframeReplaceInventoryR.Components[0].ActionComment;//this.ActionComment;
                params.EquipmentId = Number(this.equipmentId);
                params.MakeId = hasframeReplaceInventoryR.Components[0].ActionBrandId;
                params.NewSMU = this.NewSMU;
                params.ReplaceComponentCompartId = hasframeReplaceInventoryR.Components[0].ActionComponentId;
                params.ActionDate = this.Actiondate;
                params.ActionEqUnitId = hasframeReplaceInventoryR.Id;
                params.ActionTypeId = +ActionType.ReplaceSystemFromInventory;
                params.BudgetLife = hasframeReplaceInventoryR.Components[0].ActionBudgetLife;
                params.BudgetDistance = hasframeReplaceInventoryR.Components[0].ActionBudgetDistance;
                params.MiscCost = hasframeReplaceInventoryR.Components.reduce((accum, item) => accum + item.ActionCost, 0)//hasframeReplaceInventoryR.Components[0].ActionCost;
                params.NewEqUnitId = hasframeReplaceInventoryR.ActionSelectionId;
                params.DOEatInstall = this.distanceForward + this.distanceReverse;
                //console.log("params", params);
                //from inventory  
                const PromiseframesystemRepaceInvemtoryR = this.equipmentSystems.map(async z => {
                  if (z.SystemType == "Frame" && z.Side == "Right") {

                    this.oldSystemIdFrame = z.Id;

                    console.log("Frame replace", this.oldSystemIdFrame, this.newSystemIdRFrame)

                    const response = await this._actionService.SystemReplacement(params, this.newSystemIdRFrame, this.oldSystemIdFrame, 0).toPromise();

                    return response;
                  }
                })

                Promise.all(PromiseframesystemRepaceInvemtoryR).then(() => {

                  //console.log("ResframesystemRepaceInvemtoryR", ResframesystemRepaceInvemtoryR)
                  this.ChainSystemAllMethods();
                }).catch(err => {
                  console.log("PromisechainsystemRepaceInvemtoryR", err);

                })
              }
            }
          }
        }
        // console.log('loop completed')
        resolve(y)
      })
    })


  }



  ChainSystemAllMethods() {

    //stat-------------------------------------------
    let chainsystemsL = [];
    let chainsystemsR = [];
    let chainsystems = [];
    let framesystems = [];
    let framesystemsL = [];
    let framesystemsR = [];
    if (this.selectedSide == 3) {
      chainsystemsL = this.equipmentSystems.find(x => x.SystemType == "Chain" && x.Side == "Left").Components;
      chainsystemsR = this.equipmentSystems.find(x => x.SystemType == "Chain" && x.Side == "Right").Components;
      framesystemsL = this.equipmentSystems.find(x => x.SystemType == "Frame" && x.Side == "Left").Components;
      framesystemsR = this.equipmentSystems.find(x => x.SystemType == "Frame" && x.Side == "Right").Components;

      framesystems = framesystemsL.concat(framesystemsR);

    }
    else if (this.selectedSide == 1) {
      chainsystemsL = this.equipmentSystems.find(x => x.SystemType == "Chain" && x.Side == "Left").Components;
      framesystemsL = this.equipmentSystems.find(x => x.SystemType == "Frame" && x.Side == "Left").Components;
      framesystems = framesystemsL
    }
    else if (this.selectedSide == 2) {
      chainsystemsR = this.equipmentSystems.find(x => x.SystemType == "Chain" && x.Side == "Right").Components;
      framesystemsR = this.equipmentSystems.find(x => x.SystemType == "Frame" && x.Side == "Right").Components;
      framesystems = framesystemsR;
    }
    chainsystems = this.equipmentSystems.find(x => x.SystemType == "Chain").Components;
    //LEFT
    let haschainReplaceNewL = this.equipmentSystems.find(x => x.SystemType == "Chain" && x.Side == "Left" && x.ActionSelectionId == 2 && x.SysReplaceActionId == 1);
    let haschainReplaceInventoryL = this.equipmentSystems.find(x => x.SystemType == "Chain" && x.Side == "Left" && x.ActionSelectionId == 2 && x.SysReplaceActionId == 2);
    //RIGHT
    let haschainReplaceNewR = this.equipmentSystems.find(x => x.SystemType == "Chain" && x.Side == "Right" && x.ActionSelectionId == 2 && x.SysReplaceActionId == 1);
    let haschainReplaceInventoryR = this.equipmentSystems.find(x => x.SystemType == "Chain" && x.Side == "Right" && x.ActionSelectionId == 2 && x.SysReplaceActionId == 2);
    //end----------------------------------------------
    if (haschainReplaceNewL === undefined)
      haschainReplaceNewL = null;
    if (haschainReplaceInventoryL === undefined)
      haschainReplaceInventoryL = null;
    if (haschainReplaceNewR === undefined)
      haschainReplaceNewR = null;
    if (haschainReplaceInventoryR === undefined)
      haschainReplaceInventoryR = null;

    if (this.selectedSide == 1) { //LEFT Side selected
      if (haschainReplaceNewL == null && haschainReplaceInventoryL == null) {

        const promisechainsystemL = chainsystemsL.map(async x => {
          // this._loading.startLoading();
          if (x.ActionSelectionId > 1) {

            let params = new GeneralActionViewModel();
            params.Comment = x.ActionComment;//this.ActionComment;
            params.EquipmentId = Number(this.equipmentId);
            params.MakeId = x.ActionBrandId;
            params.NewSMU = this.NewSMU;
            params.ReplaceComponentCompartId = x.ActionComponentId;
            params.ActionDate = this.Actiondate;
            params.ActionEqUnitId = x.Id;
            params.ActionTypeId = x.SelectedActionTypeId;
            params.BudgetLife = x.ActionBudgetLife;
            params.BudgetDistance = x.ActionBudgetDistance;
            params.MiscCost = x.ActionCost;
            params.NewEqUnitId = (x.SelectedActionTypeId === 10602 || x.SelectedActionTypeId === 17 || x.SelectedActionTypeId === 10702) ? x.SwapComponentId : x.ActionSelectionId;
            params.ReplaceComponentCompartName = x.ActionSelectionId == 2 ? x.ActionsReplaceOption.find(y => y.Id == x.ActionComponentId).Name : '';
            params.ActionWO = x.ActionWO;
            params.UsedWorn = x.ActionWorn;
            params.UsedCMU = x.ActionCMU;
            params.UsedDOC = x.ActionDOC;
            params.Measurement = x.ActionReading;
            params.ToolId = x.ActionToolId;
            params.ShoeSize = x.ShoeSize
            params.GrouserId = x.GrouserId
            params.CleanerHolesId = x.CleanerHolesId == 0 ? null : x.CleanerHolesId
            params.DOEatInstall = this.distanceForward + this.distanceReverse;
            console.log("params", params);

            //this.PerformActionForIndivual(params,x);
            const response = await this._actionService.PerformAction(params).toPromise();
            console.log("response", response)
            if (response.OperationSucceed == false) {
              x.ActionSucess = 2;
              console.log("ErrorPerformAction", x.ActionSucess)
            } else if (response.OperationSucceed == true) {
              x.ActionSucess = 1;
              console.log("PerformAction", x.ActionSucess)
            }
            return response;
          }
          //this._loading.finishedLoading();

        });

        Promise.all(promisechainsystemL).then(resChainSysL => {
          console.log("resChainSysL", resChainSysL);
          this.PerformInspectionForAction();
        }).catch(err => {
          console.log("promisechainsystemL", err);

        })


      }
      else if (haschainReplaceInventoryL) {

        let params = new GeneralActionViewModel();
        params.Comment = haschainReplaceInventoryL.Components[0].ActionComment;//this.ActionComment;
        params.EquipmentId = Number(this.equipmentId);
        params.MakeId = haschainReplaceInventoryL.Components[0].ActionBrandId;
        params.NewSMU = this.NewSMU;
        params.ReplaceComponentCompartId = haschainReplaceInventoryL.Components[0].ActionComponentId;
        params.ActionDate = this.Actiondate;
        params.ActionEqUnitId = haschainReplaceInventoryL.Id;
        params.ActionTypeId = +ActionType.ReplaceSystemFromInventory;
        params.BudgetLife = haschainReplaceInventoryL.Components[0].ActionBudgetLife;
        params.BudgetDistance = haschainReplaceInventoryL.Components[0].ActionBudgetDistance;
        params.MiscCost = haschainReplaceInventoryL.Components.reduce((accum, item) => accum + item.ActionCost, 0)//haschainReplaceInventoryL.Components[0].ActionCost;
        params.NewEqUnitId = haschainReplaceInventoryL.ActionSelectionId;
        params.DOEatInstall = this.distanceForward + this.distanceReverse;
        console.log("Chain replace params", params);
        //from inventory  
        const PromisechainsystemRepaceInvemtoryL = this.equipmentSystems.map(async z => {
          if (z.SystemType == "Chain" && z.Side == "Left") {

            this.oldSystemId = z.Id;

            console.log("Chain replace", this.oldSystemId, this.newSystemIdL)

            const response = await this._actionService.SystemReplacement(params, this.newSystemIdL, this.oldSystemId, 0).toPromise();

            return response;
          }
        })

        Promise.all(PromisechainsystemRepaceInvemtoryL).then(ReshainsystemRepaceInvemtoryL => {

          console.log("ReshainsystemRepaceInvemtoryL", ReshainsystemRepaceInvemtoryL)
          this.PerformInspectionForAction();
        }).catch(err => {
          console.log("PromisechainsystemRepaceInvemtoryL", err);

        })

      }
      else if (haschainReplaceNewL) {
        this.chainSystem = [];
        let sys = new SystemSetup();
        sys.Id = 0;
        sys.BudgetLife = 0;
        sys.EquipmentId = 0;
        sys.HoursAtInstall = haschainReplaceNewL.Components[0].ActionCMU;
        sys.HistoricalDistance = haschainReplaceNewL.Components[0].ActionDOC;
        sys.TotalDistance = this.distanceForward + this.distanceReverse;
        sys.InstallOnEquipment = false;
        sys.InstallationDate = this.Actiondate;
        sys.InstallationDate_ = this.getFormatedDate(new Date(this.Actiondate));
        sys.JobsiteId = this.equipmentSystems[0].JobsiteId;
        sys.PMUAtInstall = 0;
        sys.PropelAtInstall = 0;
        sys.Serial = haschainReplaceNewL.NewSerialNo;
        sys.SetupDate = this.Actiondate;
        sys.Side = this.selectedSide;
        sys.SmuAtInstall = 0;
        sys.Type = 1;
        sys.Family = this.fam;
        sys.Model = this.model;
        sys.Make = this.Makes.find(x => x.Id == haschainReplaceNewL.Components[0].ActionBrandId)


        const chainsystemsreqL = chainsystemsL.map((c, index) => {
          console.log("chainData haschainReplaceNewL: ", c)
          let pos = index + 1;
          let comp = new ComponentSetup();
          comp.Brand = this.Makes.find(x => x.Id == c.ActionBrandId);
          comp.BudgetLife = c.ActionBudgetLife;
          comp.DistanceBudget = c.ActionBudgetDistance;
          comp.BushTurnedPercent = 75;
          comp.EquipmentSMU = 0;
          comp.HoursAtInstall = c.ActionCMU;
          comp.InstallCost = c.ActionCost;
          comp.InstallDate = this.Actiondate;
          comp.PMUAtInstall = 0;
          comp.Pos = c.Position;
          comp.PropelHrs = 0;
          comp.ShoeGrouser = 1;
          comp.SystemId = 0;
          comp.listPosition = pos;
          comp.Compart = this.compartList.find(i => i.Id == c.ActionComponentId);
          comp.ActionWO = c.ActionWO;
          comp.UsedWorn = c.ActionWorn;
          comp.UsedCMU = c.ActionCMU;
          comp.UsedDOC = c.ActionDOC;
          comp.Measurement = c.ActionReading;
          comp.ToolId = c.ActionToolId;
          comp.DOC = c.ActionDOC;
          return comp;
        })

        Promise.all(chainsystemsreqL).then(chainsystemsres => {
          sys.Components = chainsystemsres;
          let arry = [];
          arry.push(sys);
          this.chainSystem = arry;
          //replace new chain 


          //this.ValidateSerialNo(haschainReplaceNewL.ChainSysNewSrial, haschainReplaceNewL, this.chainSystem,1);
          var com1tot = haschainReplaceNewL.Components.reduce((accum, item) => accum + item.ActionCost, 0)
          console.log("chainSystem haschainReplaceNewL: ", this.chainSystem);
          this.submitChainSystem(this.chainSystem, haschainReplaceNewL.Components[0], 1, true, null, null, null, com1tot, 0);

        }).catch(err => {
          console.log("chainsystemsreqL", err);

        })

      } else {
        this.PerformInspectionForAction();
      }

    }
    else if (this.selectedSide == 2) { //RIGHT Side selected
      if (haschainReplaceNewR == null && haschainReplaceInventoryR == null) {

        const promisechainsystemR = chainsystemsR.map(async x => {
          // this._loading.startLoading();
          if (x.ActionSelectionId > 1) {

            let params = new GeneralActionViewModel();
            params.Comment = x.ActionComment;//this.ActionComment;
            params.EquipmentId = Number(this.equipmentId);
            params.MakeId = x.ActionBrandId;
            params.NewSMU = this.NewSMU;
            params.ReplaceComponentCompartId = x.ActionComponentId;
            params.ActionDate = this.Actiondate;
            params.ActionEqUnitId = x.Id;
            params.ActionTypeId = x.SelectedActionTypeId;
            params.BudgetLife = x.ActionBudgetLife;
            params.BudgetDistance = x.ActionBudgetDistance;
            params.MiscCost = x.ActionCost;
            params.NewEqUnitId = (x.SelectedActionTypeId === 10602 || x.SelectedActionTypeId === 17 || x.SelectedActionTypeId === 10702) ? x.SwapComponentId : x.ActionSelectionId;
            params.ReplaceComponentCompartName = x.ActionSelectionId == 2 ? x.ActionsReplaceOption.find(y => y.Id == x.ActionComponentId).Name : '';
            params.ActionWO = x.ActionWO;
            params.UsedWorn = x.ActionWorn;
            params.UsedCMU = x.ActionCMU;
            params.UsedDOC = x.ActionDOC;
            params.Measurement = x.ActionReading;
            params.ToolId = x.ActionToolId;
            params.ShoeSize = x.ShoeSize
            params.GrouserId = x.GrouserId
            params.CleanerHolesId = x.CleanerHolesId == 0 ? null : x.CleanerHolesId
            params.DOEatInstall = this.distanceForward + this.distanceReverse;
            console.log("params", params);

            //this.PerformActionForIndivual(params,x);
            const response = await this._actionService.PerformAction(params).toPromise();
            console.log("response", response)
            if (response.OperationSucceed == false) {
              x.ActionSucess = 2;
              console.log("ErrorPerformAction", x.ActionSucess)
            } else if (response.OperationSucceed == true) {
              x.ActionSucess = 1;
              console.log("PerformAction", x.ActionSucess)
            }
            return response;
          }
          //this._loading.finishedLoading();

        });

        Promise.all(promisechainsystemR).then(resChainSysR => {
          console.log("resChainSysR", resChainSysR);
          this.PerformInspectionForAction();
        }).catch(err => {
          console.log("promisechainsystem", err);

        })


      } else if (haschainReplaceInventoryR) {
        let params = new GeneralActionViewModel();
        params.Comment = haschainReplaceInventoryR.Components[0].ActionComment;//this.ActionComment;
        params.EquipmentId = Number(this.equipmentId);
        params.MakeId = haschainReplaceInventoryR.Components[0].ActionBrandId;
        params.NewSMU = this.NewSMU;
        params.ReplaceComponentCompartId = haschainReplaceInventoryR.Components[0].ActionComponentId;
        params.ActionDate = this.Actiondate;
        params.ActionEqUnitId = haschainReplaceInventoryR.Id;
        params.ActionTypeId = +ActionType.ReplaceSystemFromInventory;
        params.BudgetLife = haschainReplaceInventoryR.Components[0].ActionBudgetLife;
        params.BudgetDistance = haschainReplaceInventoryR.Components[0].ActionBudgetDistance;
        params.MiscCost = haschainReplaceInventoryR.Components.reduce((accum, item) => accum + item.ActionCost, 0)//haschainReplaceInventoryR.Components[0].ActionCost;
        params.NewEqUnitId = haschainReplaceInventoryR.ActionSelectionId;
        params.DOEatInstall = this.distanceForward + this.distanceReverse;
        console.log("params", params);
        //from inventory  
        const PromisechainsystemRepaceInvemtoryR = this.equipmentSystems.map(async z => {
          if (z.SystemType == "Chain" && z.Side == "Right") {

            this.oldSystemId = z.Id;

            console.log("Chain replace", this.oldSystemId, this.newSystemIdR)

            const response = await this._actionService.SystemReplacement(params, this.newSystemIdR, this.oldSystemId, 0).toPromise();

            return response;
          }
        })

        Promise.all(PromisechainsystemRepaceInvemtoryR).then(ReshainsystemRepaceInvemtoryR => {

          console.log("ReshainsystemRepaceInvemtory", ReshainsystemRepaceInvemtoryR)
          this.PerformInspectionForAction();
        }).catch(err => {
          console.log("PromisechainsystemRepaceInvemtoryR", err);

        })
      } else if (haschainReplaceNewR) {
        this.chainSystem = [];
        let sys = new SystemSetup();
        sys.Id = 0;
        sys.BudgetLife = 0;
        sys.EquipmentId = 0;
        sys.HoursAtInstall = haschainReplaceNewR.Components[0].ActionCMU;
        sys.HistoricalDistance = haschainReplaceNewR.Components[0].ActionDOC;
        sys.TotalDistance = this.distanceForward + this.distanceReverse;
        sys.InstallOnEquipment = false;
        sys.InstallationDate = this.Actiondate;
        sys.InstallationDate_ = this.getFormatedDate(new Date(this.Actiondate));
        sys.JobsiteId = this.equipmentSystems[0].JobsiteId;
        sys.PMUAtInstall = 0;
        sys.PropelAtInstall = 0;
        sys.Serial = haschainReplaceNewR.NewSerialNo;
        sys.SetupDate = this.Actiondate;
        sys.Side = this.selectedSide;
        sys.SmuAtInstall = 0;
        sys.Type = 1;
        sys.Family = this.fam;
        sys.Model = this.model;
        sys.Make = this.Makes.find(x => x.Id == haschainReplaceNewR.Components[0].ActionBrandId)
        const chainsystemsreqR = chainsystemsR.map((c, index) => {
          console.log("chainData", c)
          let pos = index + 1;
          let comp = new ComponentSetup();
          comp.Brand = this.Makes.find(x => x.Id == c.ActionBrandId);
          comp.BudgetLife = c.ActionBudgetLife;
          comp.DistanceBudget = c.ActionBudgetDistance;
          comp.BushTurnedPercent = 75;
          comp.EquipmentSMU = 0;
          comp.HoursAtInstall = c.ActionCMU;
          comp.InstallCost = c.ActionCost;
          comp.InstallDate = this.Actiondate;
          comp.PMUAtInstall = 0;
          comp.Pos = c.Position;
          comp.PropelHrs = 0;
          comp.ShoeGrouser = 1;
          comp.SystemId = 0;
          comp.listPosition = pos;
          comp.Compart = this.compartList.find(i => i.Id == c.ActionComponentId);
          comp.ActionWO = c.ActionWO;
          comp.UsedWorn = c.ActionWorn;
          comp.UsedCMU = c.ActionCMU;
          comp.UsedDOC = c.ActionDOC;
          comp.Measurement = c.ActionReading;
          comp.ToolId = c.ActionToolId;
          comp.DOC = c.ActionDOC;
          return comp;
        })
        Promise.all(chainsystemsreqR).then(chainsystemsres => {
          sys.Components = chainsystemsres;
          let arry = [];
          arry.push(sys);
          this.chainSystem = arry;


          //replace new chain 
          // this.ValidateSerialNo(haschainReplaceNewR.ChainSysNewSrial, haschainReplaceNewR, this.chainSystem, 2);
          var com1tot = haschainReplaceNewR.Components.reduce((accum, item) => accum + item.ActionCost, 0)
          console.log("chainSystem: ", this.chainSystem);
          this.submitChainSystem(this.chainSystem, haschainReplaceNewR.Components[0], 2, true, null, null, null, com1tot, 0);

        }).catch(err => {
          console.log("chainsystemsreqR", err);

        })

      } else {
        this.PerformInspectionForAction();
      }

    }
    else { //Both Side Selected

      if (haschainReplaceNewL == null && haschainReplaceInventoryL == null) {

        const promisechainsystemL = chainsystemsL.map(async x => {
          //this._loading.startLoading();
          if (x.ActionSelectionId > 1) {

            let params = new GeneralActionViewModel();
            params.Comment = x.ActionComment;//this.ActionComment;
            params.EquipmentId = Number(this.equipmentId);
            params.MakeId = x.ActionBrandId;
            params.NewSMU = this.NewSMU;
            params.ReplaceComponentCompartId = x.ActionComponentId;
            params.ActionDate = this.Actiondate;
            params.ActionEqUnitId = x.Id;
            params.ActionTypeId = x.SelectedActionTypeId;
            params.BudgetLife = x.ActionBudgetLife;
            params.BudgetDistance = x.ActionBudgetDistance;
            params.MiscCost = x.ActionCost;
            params.NewEqUnitId = (x.SelectedActionTypeId === 10602 || x.SelectedActionTypeId === 17 || x.SelectedActionTypeId === 10702) ? x.SwapComponentId : x.ActionSelectionId;
            params.ReplaceComponentCompartName = x.ActionSelectionId == 2 ? x.ActionsReplaceOption.find(y => y.Id == x.ActionComponentId).Name : '';
            params.ActionWO = x.ActionWO;
            params.UsedWorn = x.ActionWorn;
            params.UsedCMU = x.ActionCMU;
            params.UsedDOC = x.ActionDOC;
            params.Measurement = x.ActionReading;
            params.ToolId = x.ActionToolId;
            params.ShoeSize = x.ShoeSize
            params.GrouserId = x.GrouserId
            params.CleanerHolesId = x.CleanerHolesId == 0 ? null : x.CleanerHolesId
            params.DOEatInstall = this.distanceForward + this.distanceReverse;
            console.log("params", params);

            const response = await this._actionService.PerformAction(params).toPromise();
            console.log("response", response)
            if (response.OperationSucceed == false) {
              x.ActionSucess = 2;
              console.log("ErrorPerformAction", x.ActionSucess)
            } else if (response.OperationSucceed == true) {
              x.ActionSucess = 1;
              console.log("PerformAction", x.ActionSucess)
            }
            return response;
          }
          // this._loading.finishedLoading();

        });

        Promise.all(promisechainsystemL).then(resChainSysL => {
          console.log("resChainSysL", resChainSysL);
          if (haschainReplaceNewR == null && haschainReplaceInventoryR == null) {

            const promisechainsystemR = chainsystemsR.map(async x => {
              //this._loading.startLoading();
              if (x.ActionSelectionId > 1) {

                let params = new GeneralActionViewModel();
                params.Comment = x.ActionComment;//this.ActionComment;
                params.EquipmentId = Number(this.equipmentId);
                params.MakeId = x.ActionBrandId;
                params.NewSMU = this.NewSMU;
                params.ReplaceComponentCompartId = x.ActionComponentId;
                params.ActionDate = this.Actiondate;
                params.ActionEqUnitId = x.Id;
                params.ActionTypeId = x.SelectedActionTypeId;
                params.BudgetLife = x.ActionBudgetLife;
                params.BudgetDistance = x.ActionBudgetDistance;
                params.MiscCost = x.ActionCost;
                params.NewEqUnitId = (x.SelectedActionTypeId === 10602 || x.SelectedActionTypeId === 17 || x.SelectedActionTypeId === 10702) ? x.SwapComponentId : x.ActionSelectionId;
                params.ReplaceComponentCompartName = x.ActionSelectionId == 2 ? x.ActionsReplaceOption.find(y => y.Id == x.ActionComponentId).Name : '';
                params.ActionWO = x.ActionWO;
                params.UsedWorn = x.ActionWorn;
                params.UsedCMU = x.ActionCMU;
                params.UsedDOC = x.ActionDOC;
                params.Measurement = x.ActionReading;
                params.ToolId = x.ActionToolId;
                params.ShoeSize = x.ShoeSize
                params.GrouserId = x.GrouserId
                params.CleanerHolesId = x.CleanerHolesId == 0 ? null : x.CleanerHolesId
                params.DOEatInstall = this.distanceForward + this.distanceReverse;
                console.log("params", params);

                //this.PerformActionForIndivual(params,x);
                const response = await this._actionService.PerformAction(params).toPromise();
                console.log("response", response)
                if (response.OperationSucceed == false) {
                  x.ActionSucess = 2;
                  console.log("ErrorPerformAction", x.ActionSucess)
                } else if (response.OperationSucceed == true) {
                  x.ActionSucess = 1;
                  console.log("PerformAction", x.ActionSucess)
                }
                return response;
              }
              //this._loading.finishedLoading();

            });

            Promise.all(promisechainsystemR).then(resChainSysR => {
              console.log("resChainSysR", resChainSysR);
              this.PerformInspectionForAction();
            }).catch(err => {
              console.log("promisechainsystem", err);

            })


          }
          else if (haschainReplaceInventoryR) {
            let params = new GeneralActionViewModel();
            params.Comment = haschainReplaceInventoryR.Components[0].ActionComment;//this.ActionComment;
            params.EquipmentId = Number(this.equipmentId);
            params.MakeId = haschainReplaceInventoryR.Components[0].ActionBrandId;
            params.NewSMU = this.NewSMU;
            params.ReplaceComponentCompartId = haschainReplaceInventoryR.Components[0].ActionComponentId;
            params.ActionDate = this.Actiondate;
            params.ActionEqUnitId = haschainReplaceInventoryR.Id;
            params.ActionTypeId = +ActionType.ReplaceSystemFromInventory;
            params.BudgetLife = haschainReplaceInventoryR.Components[0].ActionBudgetLife;
            params.BudgetDistance = haschainReplaceInventoryR.Components[0].ActionBudgetDistance;
            params.MiscCost = haschainReplaceInventoryR.Components.reduce((accum, item) => accum + item.ActionCost, 0)//haschainReplaceInventoryR.Components[0].ActionCost;
            params.NewEqUnitId = haschainReplaceInventoryR.ActionSelectionId;
            params.DOEatInstall = this.distanceForward + this.distanceReverse;

            //from inventory  
            const PromisechainsystemRepaceInvemtoryR = this.equipmentSystems.map(async z => {
              if (z.SystemType == "Chain" && z.Side == "Right") {

                this.oldSystemId = z.Id;

                console.log("Chain replace", this.oldSystemId, this.newSystemIdR)

                const response = await this._actionService.SystemReplacement(params, this.newSystemIdR, this.oldSystemId, 0).toPromise();

                return response;
              }
            })

            Promise.all(PromisechainsystemRepaceInvemtoryR).then(() => {


              this.PerformInspectionForAction();
            }).catch(err => {
              console.log("PromisechainsystemRepaceInvemtoryR", err);

            })
          } else if (haschainReplaceNewR) {
            this.chainSystem = [];
            let sys = new SystemSetup();
            sys.Id = 0;
            sys.BudgetLife = 0;
            sys.EquipmentId = 0;
            sys.HoursAtInstall = haschainReplaceNewR.Components[0].ActionCMU;
            sys.HistoricalDistance = haschainReplaceNewR.Components[0].ActionDOC;
            sys.TotalDistance = this.distanceForward + this.distanceReverse;
            sys.InstallOnEquipment = false;
            sys.InstallationDate = this.Actiondate;
            sys.InstallationDate_ = this.getFormatedDate(new Date(this.Actiondate));
            sys.JobsiteId = this.equipmentSystems[0].JobsiteId;
            sys.PMUAtInstall = 0;
            sys.PropelAtInstall = 0;
            sys.Serial = haschainReplaceNewR.NewSerialNo;
            sys.SetupDate = this.Actiondate;
            sys.Side = this.selectedSide;
            sys.SmuAtInstall = 0;
            sys.Type = 1;
            sys.Family = this.fam;
            sys.Model = this.model;
            sys.Make = this.Makes.find(x => x.Id == haschainReplaceNewR.Components[0].ActionBrandId)
            const chainsystemsreqR = chainsystemsR.map((c, index) => {

              let pos = index + 1;
              let comp = new ComponentSetup();
              comp.Brand = this.Makes.find(x => x.Id == c.ActionBrandId);
              comp.BudgetLife = c.ActionBudgetLife;
              comp.DistanceBudget = c.ActionBudgetDistance;
              comp.BushTurnedPercent = 75;
              comp.EquipmentSMU = 0;
              comp.HoursAtInstall = c.ActionCMU;
              comp.InstallCost = c.ActionCost;
              comp.InstallDate = this.Actiondate;
              comp.PMUAtInstall = 0;
              comp.Pos = c.Position;
              comp.PropelHrs = 0;
              comp.ShoeGrouser = 1;
              comp.SystemId = 0;
              comp.listPosition = pos;
              comp.Compart = this.compartList.find(i => i.Id == c.ActionComponentId);
              comp.ActionWO = c.ActionWO;
              comp.UsedWorn = c.ActionWorn;
              comp.UsedCMU = c.ActionCMU;
              comp.UsedDOC = c.ActionDOC;
              comp.Measurement = c.ActionReading;
              comp.ToolId = c.ActionToolId;
              comp.DOC = c.ActionDOC;
              return comp;
            })
            Promise.all(chainsystemsreqR).then(chainsystemsres => {
              sys.Components = chainsystemsres;
              let arry = [];
              arry.push(sys);
              this.chainSystem = arry;
              //replace new chain 
              // this.ValidateSerialNo(haschainReplaceNewR.ChainSysNewSrial, haschainReplaceNewR, this.chainSystem,2);
              var com1tot = haschainReplaceNewR.Components.reduce((accum, item) => accum + item.ActionCost, 0)
              console.log("chainSystem: ", this.chainSystem);
              this.submitChainSystem(this.chainSystem, haschainReplaceNewR.Components[0], 2, true, null, null, null, com1tot, 0);

            }).catch(err => {
              console.log("chainsystemsreqR", err);

            })

          } else {
            this.PerformInspectionForAction();
          }

        }).catch(err => {
          console.log("promisechainsystemL", err);

        })


      }
      else if (haschainReplaceNewR == null && haschainReplaceInventoryR == null) {

        const promisechainsystemR = chainsystemsR.map(async x => {
          //this._loading.startLoading();
          if (x.ActionSelectionId > 1) {

            let params = new GeneralActionViewModel();
            params.Comment = x.ActionComment;//this.ActionComment;
            params.EquipmentId = Number(this.equipmentId);
            params.MakeId = x.ActionBrandId;
            params.NewSMU = this.NewSMU;
            params.ReplaceComponentCompartId = x.ActionComponentId;
            params.ActionDate = this.Actiondate;
            params.ActionEqUnitId = x.Id;
            params.ActionTypeId = x.SelectedActionTypeId;
            params.BudgetLife = x.ActionBudgetLife;
            params.BudgetDistance = x.ActionBudgetDistance;
            params.MiscCost = x.ActionCost;
            params.NewEqUnitId = (x.SelectedActionTypeId === 10602 || x.SelectedActionTypeId === 17 || x.SelectedActionTypeId === 10702) ? x.SwapComponentId : x.ActionSelectionId;
            params.ReplaceComponentCompartName = x.ActionSelectionId == 2 ? x.ActionsReplaceOption.find(y => y.Id == x.ActionComponentId).Name : '';
            params.ActionWO = x.ActionWO;
            params.UsedWorn = x.ActionWorn;
            params.UsedCMU = x.ActionCMU;
            params.UsedDOC = x.ActionDOC;
            params.Measurement = x.ActionReading;
            params.ToolId = x.ActionToolId;
            params.ShoeSize = x.ShoeSize
            params.GrouserId = x.GrouserId
            params.CleanerHolesId = x.CleanerHolesId == 0 ? null : x.CleanerHolesId
            params.DOEatInstall = this.distanceForward + this.distanceReverse;
            //this.PerformActionForIndivual(params,x);
            const response = await this._actionService.PerformAction(params).toPromise();

            if (response.OperationSucceed == false) {
              x.ActionSucess = 2;

            } else if (response.OperationSucceed == true) {
              x.ActionSucess = 1;

            }
            return response;
          }
          //this._loading.finishedLoading();

        });

        Promise.all(promisechainsystemR).then(() => {
          //this.PerformInspectionForAction();
          if (haschainReplaceInventoryL) {

            let params = new GeneralActionViewModel();
            params.Comment = haschainReplaceInventoryL.Components[0].ActionComment;//this.ActionComment;
            params.EquipmentId = Number(this.equipmentId);
            params.MakeId = haschainReplaceInventoryL.Components[0].ActionBrandId;
            params.NewSMU = this.NewSMU;
            params.ReplaceComponentCompartId = haschainReplaceInventoryL.Components[0].ActionComponentId;
            params.ActionDate = this.Actiondate;
            params.ActionEqUnitId = haschainReplaceInventoryL.Id;
            params.ActionTypeId = +ActionType.ReplaceSystemFromInventory;
            params.BudgetLife = haschainReplaceInventoryL.Components[0].ActionBudgetLife;
            params.BudgetDistance = haschainReplaceInventoryL.Components[0].ActionBudgetDistance;
            params.MiscCost = haschainReplaceInventoryL.Components.reduce((accum, item) => accum + item.ActionCost, 0)//haschainReplaceInventoryL.Components[0].ActionCost;
            params.NewEqUnitId = haschainReplaceInventoryL.ActionSelectionId;
            params.DOEatInstall = this.distanceForward + this.distanceReverse;
            console.log("params", params);
            //from inventory  
            const PromisechainsystemRepaceInvemtoryL = this.equipmentSystems.map(async z => {
              if (z.SystemType == "Chain" && z.Side == "Left") {

                this.oldSystemId = z.Id;

                console.log("Chain replace", this.oldSystemId, this.newSystemIdL)

                const response = await this._actionService.SystemReplacement(params, this.newSystemIdL, this.oldSystemId, 0).toPromise();

                return response;
              }
            })

            Promise.all(PromisechainsystemRepaceInvemtoryL).then(ReshainsystemRepaceInvemtoryL => {

              console.log("ReshainsystemRepaceInvemtoryL", ReshainsystemRepaceInvemtoryL)
              this.PerformInspectionForAction();
            }).catch(err => {
              console.log("PromisechainsystemRepaceInvemtoryL", err);

            })

          } else if (haschainReplaceNewL) {
            this.chainSystem = [];
            let sys = new SystemSetup();
            sys.Id = 0;
            sys.BudgetLife = 0;
            sys.EquipmentId = 0;
            sys.HoursAtInstall = haschainReplaceNewL.Components[0].ActionCMU;
            sys.HistoricalDistance = haschainReplaceNewL.Components[0].ActionDOC;
            sys.TotalDistance = this.distanceForward + this.distanceReverse;
            sys.InstallOnEquipment = false;
            sys.InstallationDate = this.Actiondate;
            sys.InstallationDate_ = this.getFormatedDate(new Date(this.Actiondate));
            sys.JobsiteId = this.equipmentSystems[0].JobsiteId;
            sys.PMUAtInstall = 0;
            sys.PropelAtInstall = 0;
            sys.Serial = haschainReplaceNewL.NewSerialNo;
            sys.SetupDate = this.Actiondate;
            sys.Side = this.selectedSide;
            sys.SmuAtInstall = 0;
            sys.Type = 1;
            sys.Family = this.fam;
            sys.Model = this.model;
            sys.Make = this.Makes.find(x => x.Id == haschainReplaceNewL.Components[0].ActionBrandId)
            const chainsystemsreqL = chainsystemsL.map((c, index) => {
              console.log("chainData", c)
              let pos = index + 1;
              let comp = new ComponentSetup();
              comp.Brand = this.Makes.find(x => x.Id == c.ActionBrandId);
              comp.BudgetLife = c.ActionBudgetLife;
              comp.DistanceBudget = c.ActionBudgetDistance;
              comp.BushTurnedPercent = 75;
              comp.EquipmentSMU = 0;
              comp.HoursAtInstall = c.ActionCMU;
              comp.InstallCost = c.ActionCost;
              comp.InstallDate = this.Actiondate;
              comp.PMUAtInstall = 0;
              comp.Pos = c.Position;
              comp.PropelHrs = 0;
              comp.ShoeGrouser = 1;
              comp.SystemId = 0;
              comp.listPosition = pos;
              comp.Compart = this.compartList.find(i => i.Id == c.ActionComponentId);
              comp.ActionWO = c.ActionWO;
              comp.UsedWorn = c.ActionWorn;
              comp.UsedCMU = c.ActionCMU;
              comp.UsedDOC = c.ActionDOC;
              comp.Measurement = c.ActionReading;
              comp.ToolId = c.ActionToolId;
              comp.DOC = c.ActionDOC;
              return comp;
            })

            Promise.all(chainsystemsreqL).then(chainsystemsres => {
              sys.Components = chainsystemsres;
              let arry = [];
              arry.push(sys);
              this.chainSystem = arry;
              //replace new chain 

              var com1tot = haschainReplaceNewL.Components.reduce((accum, item) => accum + item.ActionCost, 0)
              console.log("chainSystem: ", this.chainSystem);
              //this.ValidateSerialNo(haschainReplaceNewL.ChainSysNewSrial, haschainReplaceNewL, this.chainSystem,1);
              this.submitChainSystem(this.chainSystem, haschainReplaceNewL.Components[0], 1, true, null, null, null, com1tot, 0);

            }).catch(err => {
              console.log("chainsystemsreqL", err);

            })

          } else {
            this.PerformInspectionForAction();
          }



        }).catch(err => {
          console.log("promisechainsystem", err);

        })


      }
      else if (haschainReplaceInventoryL) {
        console.log("haschainReplaceInventoryR: ", haschainReplaceInventoryR)
        let params = new GeneralActionViewModel();
        params.Comment = haschainReplaceInventoryL.Components[0].ActionComment;//this.ActionComment;
        params.EquipmentId = Number(this.equipmentId);
        params.MakeId = haschainReplaceInventoryL.Components[0].ActionBrandId;
        params.NewSMU = this.NewSMU;
        params.ReplaceComponentCompartId = haschainReplaceInventoryL.Components[0].ActionComponentId;
        params.ActionDate = this.Actiondate;
        params.ActionEqUnitId = haschainReplaceInventoryL.Id;
        params.ActionTypeId = +ActionType.ReplaceSystemFromInventory;
        params.BudgetLife = haschainReplaceInventoryL.Components[0].ActionBudgetLife;
        params.BudgetDistance = haschainReplaceInventoryL.Components[0].ActionBudgetDistance;
        params.MiscCost = haschainReplaceInventoryL.Components.reduce((accum, item) => accum + item.ActionCost, 0)//haschainReplaceInventoryL.Components[0].ActionCost;
        params.NewEqUnitId = haschainReplaceInventoryL.ActionSelectionId;
        params.DOEatInstall = this.distanceForward + this.distanceReverse;
        console.log("params", params);
        //from inventory  
        const PromisechainsystemRepaceInvemtoryL = this.equipmentSystems.map(async z => {
          if (z.SystemType == "Chain" && z.Side == "Left") {

            this.oldSystemId = z.Id;

            console.log("Chain replace", this.oldSystemId, this.newSystemIdL)

            const response = await this._actionService.SystemReplacement(params, this.newSystemIdL, this.oldSystemId, 0).toPromise();

            return response;
          }
        })

        Promise.all(PromisechainsystemRepaceInvemtoryL).then(ReshainsystemRepaceInvemtoryL => {

          console.log("ReshainsystemRepaceInvemtoryL", ReshainsystemRepaceInvemtoryL)
          //this.PerformInspectionForAction();
          if (haschainReplaceInventoryR) {
            let params = new GeneralActionViewModel();
            params.Comment = haschainReplaceInventoryR.Components[0].ActionComment;//this.ActionComment;
            params.EquipmentId = Number(this.equipmentId);
            params.MakeId = haschainReplaceInventoryR.Components[0].ActionBrandId;
            params.NewSMU = this.NewSMU;
            params.ReplaceComponentCompartId = haschainReplaceInventoryR.Components[0].ActionComponentId;
            params.ActionDate = this.Actiondate;
            params.ActionEqUnitId = haschainReplaceInventoryR.Id;
            params.ActionTypeId = +ActionType.ReplaceSystemFromInventory;
            params.BudgetLife = haschainReplaceInventoryR.Components[0].ActionBudgetLife;
            params.BudgetDistance = haschainReplaceInventoryR.Components[0].ActionBudgetDistance;
            params.MiscCost = haschainReplaceInventoryR.Components.reduce((accum, item) => accum + item.ActionCost, 0)//haschainReplaceInventoryR.Components[0].ActionCost;
            params.NewEqUnitId = haschainReplaceInventoryR.ActionSelectionId;
            params.DOEatInstall = this.distanceForward + this.distanceReverse;
            console.log("params", params);
            //from inventory  
            const PromisechainsystemRepaceInvemtoryR = this.equipmentSystems.map(async z => {
              if (z.SystemType == "Chain" && z.Side == "Right") {

                this.oldSystemId = z.Id;

                console.log("Chain replace", this.oldSystemId, this.newSystemIdR)

                const response = await this._actionService.SystemReplacement(params, this.newSystemIdR, this.oldSystemId, 0).toPromise();

                return response;
              }
            })

            Promise.all(PromisechainsystemRepaceInvemtoryR).then(ReshainsystemRepaceInvemtoryR => {

              console.log("ReshainsystemRepaceInvemtory", ReshainsystemRepaceInvemtoryR)
              this.PerformInspectionForAction();
            }).catch(err => {
              console.log("PromisechainsystemRepaceInvemtoryR", err);

            })
          } else if (haschainReplaceNewR) {
            this.chainSystem = [];
            let sys = new SystemSetup();
            sys.Id = 0;
            sys.BudgetLife = 0;
            sys.EquipmentId = 0;
            sys.HoursAtInstall = haschainReplaceNewR.Components[0].ActionCMU;
            sys.HistoricalDistance = haschainReplaceNewR.Components[0].ActionDOC;
            sys.TotalDistance = this.distanceForward + this.distanceReverse;
            sys.InstallOnEquipment = false;
            sys.InstallationDate = this.Actiondate;
            sys.InstallationDate_ = this.getFormatedDate(new Date(this.Actiondate));
            sys.JobsiteId = this.equipmentSystems[0].JobsiteId;
            sys.PMUAtInstall = 0;
            sys.PropelAtInstall = 0;
            sys.Serial = haschainReplaceNewR.NewSerialNo;
            sys.SetupDate = this.Actiondate;
            sys.Side = this.selectedSide;
            sys.SmuAtInstall = 0;
            sys.Type = 1;
            sys.Family = this.fam;
            sys.Model = this.model;
            sys.Make = this.Makes.find(x => x.Id == haschainReplaceNewR.Components[0].ActionBrandId)
            const chainsystemsreqR = chainsystemsR.map((c, index) => {
              console.log("chainData", c)
              let pos = index + 1;
              let comp = new ComponentSetup();
              comp.Brand = this.Makes.find(x => x.Id == c.ActionBrandId);
              comp.BudgetLife = c.ActionBudgetLife;
              comp.DistanceBudget = c.ActionBudgetDistance;
              comp.BushTurnedPercent = 75;
              comp.EquipmentSMU = 0;
              comp.HoursAtInstall = c.ActionCMU;
              comp.InstallCost = c.ActionCost;
              comp.InstallDate = this.Actiondate;
              comp.PMUAtInstall = 0;
              comp.Pos = c.Position;
              comp.PropelHrs = 0;
              comp.ShoeGrouser = 1;
              comp.SystemId = 0;
              comp.listPosition = pos;
              comp.Compart = this.compartList.find(i => i.Id == c.ActionComponentId);
              comp.ActionWO = c.ActionWO;
              comp.UsedWorn = c.ActionWorn;
              comp.UsedCMU = c.ActionCMU;
              comp.UsedDOC = c.ActionDOC;
              comp.Measurement = c.ActionReading;
              comp.ToolId = c.ActionToolId;
              comp.DOC = c.ActionDOC;
              return comp;
            })
            Promise.all(chainsystemsreqR).then(chainsystemsres => {
              sys.Components = chainsystemsres;
              let arry = [];
              arry.push(sys);
              this.chainSystem = arry;
              //replace new chain 
              // this.ValidateSerialNo(haschainReplaceNewR.ChainSysNewSrial, haschainReplaceNewR, this.chainSystem,2);

              var com1tot = haschainReplaceNewR.Components.reduce((accum, item) => accum + item.ActionCost, 0)
              console.log("chainSystem: ", this.chainSystem);
              this.submitChainSystem(this.chainSystem, haschainReplaceNewR.Components[0], 2, true, null, null, null, com1tot, 0);

            }).catch(err => {
              console.log("chainsystemsreqR", err);

            })

          } else {
            this.PerformInspectionForAction();
          }

        }).catch(err => {
          console.log("PromisechainsystemRepaceInvemtoryL", err);

        })

      }

      else if (haschainReplaceNewL && haschainReplaceNewR == null) {


        this.chainSystem = [];
        let sys = new SystemSetup();
        sys.Id = 0;
        sys.BudgetLife = 0;
        sys.EquipmentId = 0;
        sys.HoursAtInstall = haschainReplaceNewL.Components[0].ActionCMU;
        sys.HistoricalDistance = haschainReplaceNewL.Components[0].ActionDOC;
        sys.TotalDistance = this.distanceForward + this.distanceReverse;
        sys.InstallOnEquipment = false;
        sys.InstallationDate = this.Actiondate;
        sys.InstallationDate_ = this.getFormatedDate(new Date(this.Actiondate));
        sys.JobsiteId = this.equipmentSystems[0].JobsiteId;
        sys.PMUAtInstall = 0;
        sys.PropelAtInstall = 0;
        sys.Serial = haschainReplaceNewL.NewSerialNo;
        sys.SetupDate = this.Actiondate;
        sys.Side = this.selectedSide;
        sys.SmuAtInstall = 0;
        sys.Type = 1;
        sys.Family = this.fam;
        sys.Model = this.model;
        sys.Make = this.Makes.find(x => x.Id == haschainReplaceNewL.Components[0].ActionBrandId)


        const chainsystemsreqL = chainsystemsL.map((c, index) => {
          console.log("chainData", c)
          let pos = index + 1;
          let comp = new ComponentSetup();
          comp.Brand = this.Makes.find(x => x.Id == c.ActionBrandId);
          comp.BudgetLife = c.ActionBudgetLife;
          comp.DistanceBudget = c.ActionBudgetDistance;
          comp.BushTurnedPercent = 75;
          comp.EquipmentSMU = 0;
          comp.HoursAtInstall = c.ActionCMU;
          comp.InstallCost = c.ActionCost;
          comp.InstallDate = this.Actiondate;
          comp.PMUAtInstall = 0;
          comp.Pos = c.Position;
          comp.PropelHrs = 0;
          comp.ShoeGrouser = 1;
          comp.SystemId = 0;
          comp.listPosition = pos;
          comp.Compart = this.compartList.find(i => i.Id == c.ActionComponentId);
          comp.ActionWO = c.ActionWO;
          comp.UsedWorn = c.ActionWorn;
          comp.UsedCMU = c.ActionCMU;
          comp.UsedDOC = c.ActionDOC;
          comp.Measurement = c.ActionReading;
          comp.ToolId = c.ActionToolId;
          comp.DOC = c.ActionDOC;
          return comp;
        })

        Promise.all(chainsystemsreqL).then(chainsystemsres => {
          sys.Components = chainsystemsres;
          let arry = [];
          arry.push(sys);
          this.chainSystem = arry;
          //replace new chain 
          // this.ValidateSerialNo(haschainReplaceNewL.ChainSysNewSrial, haschainReplaceNewL, this.chainSystem,1);

          if (haschainReplaceInventoryR == null) {

            var com1tot = haschainReplaceNewL.Components.reduce((accum, item) => accum + item.ActionCost, 0)
            console.log("chainSystem: ", this.chainSystem);
            this.submitChainSystem(this.chainSystem, haschainReplaceNewL.Components[0], 1, true, null, null, null, com1tot, 0);
          } else if (haschainReplaceInventoryR) {
            let params = new GeneralActionViewModel();
            params.Comment = haschainReplaceInventoryR.Components[0].ActionComment;//this.ActionComment;
            params.EquipmentId = Number(this.equipmentId);
            params.MakeId = haschainReplaceInventoryR.Components[0].ActionBrandId;
            params.NewSMU = this.NewSMU;
            params.ReplaceComponentCompartId = haschainReplaceInventoryR.Components[0].ActionComponentId;
            params.ActionDate = this.Actiondate;
            params.ActionEqUnitId = haschainReplaceInventoryR.Id;
            params.ActionTypeId = +ActionType.ReplaceSystemFromInventory;
            params.BudgetLife = haschainReplaceInventoryR.Components[0].ActionBudgetLife;
            params.BudgetDistance = haschainReplaceInventoryR.Components[0].ActionBudgetDistance;
            params.MiscCost = haschainReplaceInventoryR.Components.reduce((accum, item) => accum + item.ActionCost, 0)//haschainReplaceInventoryR.Components[0].ActionCost;
            params.NewEqUnitId = haschainReplaceInventoryR.ActionSelectionId;
            params.DOEatInstall = this.distanceForward + this.distanceReverse;
            console.log("params", params);
            //from inventory  
            const PromisechainsystemRepaceInvemtoryR = this.equipmentSystems.map(async z => {
              if (z.SystemType == "Chain" && z.Side == "Right") {

                this.oldSystemId = z.Id;

                console.log("Chain replace", this.oldSystemId, this.newSystemIdR)

                const response = await this._actionService.SystemReplacement(params, this.newSystemIdR, this.oldSystemId, 0).toPromise();

                return response;
              }
            })

            Promise.all(PromisechainsystemRepaceInvemtoryR).then(ReshainsystemRepaceInvemtoryR => {

              console.log("ReshainsystemRepaceInvemtory", ReshainsystemRepaceInvemtoryR)
              //this.PerformInspectionForAction();

              var com1tot = haschainReplaceNewL.Components.reduce((accum, item) => accum + item.ActionCost, 0)
              console.log("chainSystem: ", this.chainSystem);
              this.submitChainSystem(this.chainSystem, haschainReplaceNewL.Components[0], 1, true, null, null, null, com1tot, 0);
            }).catch(err => {
              console.log("PromisechainsystemRepaceInvemtoryR", err);

            })
          }



        }).catch(err => {
          console.log("chainsystemsreqL", err);

        })

      }
      else if (haschainReplaceNewR && haschainReplaceNewL == null) {
        this.chainSystem = [];
        let sys = new SystemSetup();
        sys.Id = 0;
        sys.BudgetLife = 0;
        sys.EquipmentId = 0;
        sys.HoursAtInstall = haschainReplaceNewR.Components[0].ActionCMU;
        sys.HistoricalDistance = haschainReplaceNewR.Components[0].ActionDOC;
        sys.TotalDistance = this.distanceForward + this.distanceReverse;
        sys.InstallOnEquipment = false;
        sys.InstallationDate = this.Actiondate;
        sys.InstallationDate_ = this.getFormatedDate(new Date(this.Actiondate));
        sys.JobsiteId = this.equipmentSystems[0].JobsiteId;
        sys.PMUAtInstall = 0;
        sys.PropelAtInstall = 0;
        sys.Serial = haschainReplaceNewR.NewSerialNo;
        sys.SetupDate = this.Actiondate;
        sys.Side = this.selectedSide;
        sys.SmuAtInstall = 0;
        sys.Type = 1;
        sys.Family = this.fam;
        sys.Model = this.model;
        sys.Make = this.Makes.find(x => x.Id == haschainReplaceNewR.Components[0].ActionBrandId)
        const chainsystemsreqR = chainsystemsR.map((c, index) => {
          console.log("chainData", c)
          let pos = index + 1;
          let comp = new ComponentSetup();
          comp.Brand = this.Makes.find(x => x.Id == c.ActionBrandId);
          comp.BudgetLife = c.ActionBudgetLife;
          comp.DistanceBudget = c.ActionBudgetDistance;
          comp.BushTurnedPercent = 75;
          comp.EquipmentSMU = 0;
          comp.HoursAtInstall = c.ActionCMU;
          comp.InstallCost = c.ActionCost;
          comp.InstallDate = this.Actiondate;
          comp.PMUAtInstall = 0;
          comp.Pos = c.Position;
          comp.PropelHrs = 0;
          comp.ShoeGrouser = 1;
          comp.SystemId = 0;
          comp.listPosition = pos;
          comp.Compart = this.compartList.find(i => i.Id == c.ActionComponentId);
          comp.ActionWO = c.ActionWO;
          comp.UsedWorn = c.ActionWorn;
          comp.UsedCMU = c.ActionCMU;
          comp.UsedDOC = c.ActionDOC;
          comp.Measurement = c.ActionReading;
          comp.ToolId = c.ActionToolId;
          comp.DOC = c.ActionDOC;
          return comp;
        })
        Promise.all(chainsystemsreqR).then(chainsystemsres => {
          sys.Components = chainsystemsres;
          let arry = [];
          arry.push(sys);
          this.chainSystem = arry;
          //replace new chain 
          //this.ValidateSerialNo(haschainReplaceNewR.ChainSysNewSrial, haschainReplaceNewR, this.chainSystem,2);

          var com1tot = haschainReplaceNewR.Components.reduce((accum, item) => accum + item.ActionCost, 0)
          console.log("chainSystem: ", this.chainSystem);
          this.submitChainSystem(this.chainSystem, haschainReplaceNewR.Components[0], 2, true, null, null, null, com1tot, 0);

        }).catch(err => {
          console.log("chainsystemsreqR", err);

        })

      }

      else if (haschainReplaceNewR && haschainReplaceNewL) {
        console.log("Data___GG_LEFT", haschainReplaceNewL.NewSerialNo)
        console.log("Data___GG_RIGHT", haschainReplaceNewR.NewSerialNo)


        this.chainSystemR = [];
        let sysR = new SystemSetup();
        sysR.Id = 0;
        sysR.BudgetLife = 0;
        sysR.EquipmentId = 0;
        sysR.HoursAtInstall = haschainReplaceNewR.Components[0].ActionCMU;
        sysR.HistoricalDistance = haschainReplaceNewR.Components[0].ActionDOC;
        sysR.TotalDistance = this.distanceForward + this.distanceReverse;
        sysR.InstallOnEquipment = false;
        sysR.InstallationDate = this.Actiondate;
        sysR.InstallationDate_ = this.getFormatedDate(new Date(this.Actiondate));
        sysR.JobsiteId = this.equipmentSystems[0].JobsiteId;
        sysR.PMUAtInstall = 0;
        sysR.PropelAtInstall = 0;
        sysR.Serial = haschainReplaceNewR.NewSerialNo;
        sysR.SetupDate = this.Actiondate;
        sysR.Side = this.selectedSide;
        sysR.SmuAtInstall = 0;
        sysR.Type = 1;
        sysR.Family = this.fam;
        sysR.Model = this.model;
        sysR.Make = this.Makes.find(x => x.Id == haschainReplaceNewR.Components[0].ActionBrandId)



        this.chainSystem = [];
        let sys = new SystemSetup();
        sys.Id = 0;
        sys.BudgetLife = 0;
        sys.EquipmentId = 0;
        sys.HoursAtInstall = haschainReplaceNewL.Components[0].ActionCMU;
        sys.HistoricalDistance = haschainReplaceNewL.Components[0].ActionDOC;
        sys.TotalDistance = this.distanceForward + this.distanceReverse;
        sys.InstallOnEquipment = false;
        sys.InstallationDate = this.Actiondate;
        sys.InstallationDate_ = this.getFormatedDate(new Date(this.Actiondate));
        sys.JobsiteId = this.equipmentSystems[0].JobsiteId;
        sys.PMUAtInstall = 0;
        sys.PropelAtInstall = 0;
        sys.Serial = haschainReplaceNewL.NewSerialNo;
        sys.SetupDate = this.Actiondate;
        sys.Side = this.selectedSide;
        sys.SmuAtInstall = 0;
        sys.Type = 1;
        sys.Family = this.fam;
        sys.Model = this.model;
        sys.Make = this.Makes.find(x => x.Id == haschainReplaceNewL.Components[0].ActionBrandId)



        const chainsystemsreqR = chainsystemsR.map((c, index) => {

          let pos = index + 1;
          let comp = new ComponentSetup();
          comp.Brand = this.Makes.find(x => x.Id == c.ActionBrandId);
          comp.BudgetLife = c.ActionBudgetLife;
          comp.DistanceBudget = c.ActionBudgetDistance;
          comp.BushTurnedPercent = 75;
          comp.EquipmentSMU = 0;
          comp.HoursAtInstall = c.ActionCMU;
          comp.InstallCost = c.ActionCost;
          comp.InstallDate = this.Actiondate;
          comp.PMUAtInstall = 0;
          comp.Pos = c.Position;
          comp.PropelHrs = 0;
          comp.ShoeGrouser = 1;
          comp.SystemId = 0;
          comp.listPosition = pos;
          comp.Compart = this.compartList.find(i => i.Id == c.ActionComponentId);
          comp.ActionWO = c.ActionWO;
          comp.UsedWorn = c.ActionWorn;
          comp.UsedCMU = c.ActionCMU;
          comp.UsedDOC = c.ActionDOC;
          comp.Measurement = c.ActionReading;
          comp.ToolId = c.ActionToolId;
          comp.DOC = c.ActionDOC;
          return comp;
        })
        Promise.all(chainsystemsreqR).then(chainsystemsres => {
          sysR.Components = chainsystemsres;
          let arry = [];
          arry.push(sysR);
          this.chainSystem = arry;
          //replace new chain 
          //this.ValidateSerialNo(haschainReplaceNewR.ChainSysNewSrial, haschainReplaceNewR, this.chainSystem,2);
          console.log("system___", this.chainSystem);

          var com1tot = haschainReplaceNewR.Components.reduce((accum, item) => accum + item.ActionCost, 0)
          var com2tot = haschainReplaceNewL.Components.reduce((accum, item) => accum + item.ActionCost, 0)
          console.log("chainSystem: ", this.chainSystem);
          this.submitChainSystem(this.chainSystem, haschainReplaceNewR.Components[0], 2, false, chainsystemsL, haschainReplaceNewL.Components[0], sys, com1tot, com2tot);

        }).catch(err => {
          console.log("chainsystemsreqR", err);

        })

      }
      else if (haschainReplaceInventoryR) {
        console.log("haschainReplaceInventoryR: ", haschainReplaceInventoryR)
        let params = new GeneralActionViewModel();
        params.Comment = haschainReplaceInventoryR.Components[0].ActionComment;//this.ActionComment;
        params.EquipmentId = Number(this.equipmentId);
        params.MakeId = haschainReplaceInventoryR.Components[0].ActionBrandId;
        params.NewSMU = this.NewSMU;
        params.ReplaceComponentCompartId = haschainReplaceInventoryR.Components[0].ActionComponentId;
        params.ActionDate = this.Actiondate;
        params.ActionEqUnitId = haschainReplaceInventoryR.Id;
        params.ActionTypeId = +ActionType.ReplaceSystemFromInventory;
        params.BudgetLife = haschainReplaceInventoryR.Components[0].ActionBudgetLife;
        params.BudgetDistance = haschainReplaceInventoryR.Components[0].ActionBudgetDistance;
        params.MiscCost = haschainReplaceInventoryR.Components.reduce((accum, item) => accum + item.ActionCost, 0)//haschainReplaceInventoryR.Components[0].ActionCost;
        params.NewEqUnitId = haschainReplaceInventoryR.ActionSelectionId;
        params.DOEatInstall = this.distanceForward + this.distanceReverse;
        console.log("params", params);
        //from inventory  
        const PromisechainsystemRepaceInvemtoryR = this.equipmentSystems.map(async z => {
          if (z.SystemType == "Chain" && z.Side == "Right") {

            this.oldSystemId = z.Id;

            console.log("Chain replace", this.oldSystemId, this.newSystemIdR)

            const response = await this._actionService.SystemReplacement(params, this.newSystemIdR, this.oldSystemId, 0).toPromise();

            return response;
          }
        })

        Promise.all(PromisechainsystemRepaceInvemtoryR).then(ReshainsystemRepaceInvemtoryR => {

          console.log("ReshainsystemRepaceInvemtory", ReshainsystemRepaceInvemtoryR)
          this.PerformInspectionForAction();
        }).catch(err => {
          console.log("PromisechainsystemRepaceInvemtoryR", err);

        })
      }
      else {
        this.ChainSystemAllMethods();
      }

    }
  }
  allowWornInput(SysReplaceActionId: number, actionTypeId: number) {
    //10303	Replace With Used Shoe
    //10402	Replace With Used Idler
    //10502	Replace With Used Sprocket
    //10603	Replace With Used CarrierRoller
    //10802	Replace With Used TrackRoller
    //10808	Replace With Used RS Rear Idler
    if (SysReplaceActionId == 2)
      return true;
    else if (actionTypeId == 10303 || actionTypeId == 10402 || actionTypeId == 10502 || actionTypeId == 10603 || actionTypeId == 10802 || actionTypeId == 10808)
      return true;
    else
      return false;
  }
  allowCMUInput(SysReplaceActionId: number) {
    if (SysReplaceActionId == 2)
      return true;
    else
      return false;
  }

  getSeverityDropdown() {
    this._interp.getSeverityDropdown(0).subscribe(rec => {
      this.SeverityDropDownList = rec;
      // this.loadingPossibleRecommendations = false;
    }, err => {
      //this._notify.error('Error', 'Unable to load possible recommendations. Please contact TrackTreads support. ');
      console.error(err);
    });
  }
  severityId: number = 2;
  addRecommendationVM: AddRecommendationVM;
  savingForm: boolean;

  onSubmit(Flag: number) {

    if (this.severityId > 0) {
      this.addRecommendationVM = new AddRecommendationVM();
      this.addRecommendationVM.Flag = Flag;
      this.addRecommendationVM.actionRecomendList = [];
      this.addRecommendationVM.chainStatusM = [];
      this.addRecommendationVM.equipmentId = this.equipmentId;
      this.addRecommendationVM.Comment = this.Comment;
      this.addRecommendationVM.DistanceReverse = this.convertDistanceMiToKm(this.distanceReverse);
      this.addRecommendationVM.DistanceForward = this.convertDistanceMiToKm(this.distanceForward);
      this.addRecommendationVM.SMU = this.NewSMU;
      this.equipmentSystems.forEach(element => {

        // const CModel= new ChainStatusModel();
        // CModel.StatusId= element.RemoveStatusId;
        // CModel.SystemId= element.Id;
        // this.addRecommendationVM.chainStatusM.push(CModel)


        element.Components.forEach(comp => {
          if (comp.SelectedActionTypeId > 0) {
            const rec = new AddRecommendationModel();
            rec.ActionId = comp.SelectedActionTypeId;
            rec.Comment = comp.Comment;
            rec.ComponentId = comp.Id;
            rec.InspectionId = null;
            rec.QuoteId = 0;
            rec.LabourCost = comp.LaborCost;
            rec.PartsCost = comp.PartCost;
            rec.MiscCost = comp.MiscCost;
            rec.SmuToCompleteActionBy = this.NewSMU + comp.HoursGained;
            rec.SmuToTakeAction = this.NewSMU;
            rec.AddedForBothSide = this.selectedSide == 3 ? true : false;
            rec.ActionDate = this.Actiondate;
            rec.SeverityId = this.severityId;
            rec.BudgetDistance = comp.ActionBudgetDistance;
            rec.Doc = comp.ActionDOC;
            rec.BudgetLife = comp.ActionBudgetLife;
            rec.CMU = comp.ActionCMU;
            if (comp.SelectedActionTypeId === 10602 || comp.SelectedActionTypeId === 17 || comp.SelectedActionTypeId === 10702 && (element.SysReplaceActionId != 2 && comp.ActionSelectionId == 3)) {
              rec.AvailableReplacementId = comp.SwapComponentId;
            } 
            else if(comp.ActionSelectionId==3){
               rec.AvailableReplacementId = comp.ActionComponentId;
            }
            else {
              rec.AvailableReplacementId = comp.ActionComponentId;

            }
            rec.BrandId = comp.ActionBrandId;
            this.addRecommendationVM.actionRecomendList.push(rec);
          }
        })
      });

      console.log(this.addRecommendationVM.actionRecomendList)

      if (this.addRecommendationVM.actionRecomendList.length > 0) {
        this.disableSave = true;
        this._interp.addRecommendationFromEquipment(this.addRecommendationVM).subscribe(r => {
          if (r.m_Item1 > 0) {
            this.ShowDone = true;
            this._notify.success('Added', r.m_Item3);
          } else {
            this._notify.error('Failed', r.m_Item3);
            console.error(r.m_Item2);
          }
          this.savingForm = false;
        }, error => {
          this._notify.error('Error', 'Unable to add the recommendation. Please contact TrackTreads support. ');
          console.error(error);
          this.savingForm = false;
        });
      } else {
        this._notify.warn('Warning', 'Please Select Actions. ');
      }
    } else {
      this._notify.warn('Warning', 'Please Select Severity');
    }
  }

  getUserUOD() {
    this._pref.getGeneralTabPreferences().subscribe(res => {
      this.userUOD = res.UnitofDistance;
    })
  }
  // to convert distance from kilometers to miles for display purpose
  convertDistanceKmToMi(distance: number): number {
    return this.userUOD === 'km' ? distance : Math.round(distance * 0.621371 * 10) / 10;
  }
  //to save values in KM when user preferance is in miles
  convertDistanceMiToKm(val: number): number {
    return this.userUOD === 'km' ? val : Math.round(val * 1.60934);
  }
  ActionRecommentDationOnDateVM: ActionRecommentDationOnDateVM;
  ActionRecommentDationOnDate: ActionRecommentDationOnDate[] = [];
  Side: number;
  GetActionRecommentdationBySmuDate() {
    this.ActionRecommentDationOnDate = [];
   debugger;
    this._interp.GetActionRecommentdationBySmuDate(this.EquipmentIdEdit, this.SmuEdit, this.DateEdit).subscribe(rec => {
      if (rec != null) {
        this.ActionRecommentDationOnDate = rec.Data
        this.NewSMU = this.ActionRecommentDationOnDate[0].StartSmu;
        this.selectedSide = this.ActionRecommentDationOnDate[0].Side;
        this.Comment = this.ActionRecommentDationOnDate[0].CommentOverall
        this.ChangeSide();
        this.Actiondate = this.ActionRecommentDationOnDate[0].ActionDate;
        this.distanceForward = this.ActionRecommentDationOnDate[0].DistanceForward;
        this.distanceReverse = this.ActionRecommentDationOnDate[0].DistanceReverse;
        this.ActionRecommentDationOnDate.forEach(x => {
          this.equipmentSystems.forEach(y => {
            y.Components.forEach(comp => {
              if (x.TrackUnitAuto == comp.Id) {
                comp.PartCost = x.PartsCost;
                comp.MiscCost = x.MiscCost;
                comp.LaborCost = x.LabourCost;
                comp.ActionBudgetLife = x.BudgetLife;
                comp.ActionCMU = x.CMU;
                comp.ActionBrandId = x.BrandId
                 if (x.ActionDescription.includes('Replace')) {
                  comp.ActionSelectionId = 2;
                  this.ChangeActionSelection(comp, null)
                //this.ChangeAvailableAction(comp, y)
                  comp.SelectedActionTypeId = x.OpTypeAuto;

                   if (comp.SelectedActionTypeId === 10602 || comp.SelectedActionTypeId === 17 || comp.SelectedActionTypeId === 10702 && (y.SysReplaceActionId != 2 && comp.ActionSelectionId == 3)) {
                    comp.SwapComponentId = x.AvailableReplacementId;
                  } else {
                    comp.ActionComponentId = x.AvailableReplacementId;
                  }
                } else {
                  comp.ActionSelectionId = 3;
                  
                  comp.SelectedActionTypeId = x.OpTypeAuto;
                 if (comp.SelectedActionTypeId === 10602 || comp.SelectedActionTypeId === 17 || comp.SelectedActionTypeId === 10702 && (y.SysReplaceActionId != 2 && comp.ActionSelectionId == 3)) {
                   
                   this.ChangeAvailableAction(comp,y)
                    comp.SwapComponentId = x.AvailableReplacementId;
                   // this.swapRollerEvent(comp.SwapComponentId, comp,y)
                  } else {
                    comp.ActionComponentId = x.AvailableReplacementId;
                  }
                }
                this.ChangeActionSelection(comp, null)
                comp.ActionDOC = x.Doc
                comp.ActionBudgetDistance = x.BudgetDistance
                comp.ComponentStatus = x.StatusId
                comp.QuoteDetailId = x.QuoteDetailAuto
                if (x.StatusId > 0) {
                  comp.isForDelete = true
                }
              }
            })

          })

        })
      }

    }, err => {
      console.error(err);
    });
  }


  DeleteQuote(QuotedetailId: number) {
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      width: '400px',
      data: {
        title: 'Delete',
        message: 'Are you sure you want to delete this recommendation?',
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.confirmed) {
        this._interp.DeleteRecommendation(QuotedetailId).subscribe(rec => {

          if (rec == 1) {
            this.GetActionRecommentdationBySmuDate();
            this._notify.success("Recommendation Deleted Successfully.")
          }
        });
      }
    });
  }
}
